import { Component } from 'react';
import { connect } from "react-redux";
import Decimal from "decimal.js";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import { APP_LIVE_URL, API_URL, ADMIN_URL } from "../../../config/config";

import {
  getSingleRfq,
  deleteAnswerOption,
  deleteQuestions,
  listServicesWithPriceAgents,
  getSingleQuotation,
  listSingleClient,
  saveOrderAsDraft,
  saveOrderAndSent,
  saveQuotationInformation,
  getAssignedQuotationSettings,
  saveQuotationComment,
  getSingleNote,
  saveQuotationNote,
  getSingleOrder,
  getAssignedOrderSettings,
  saveOrderInformation,
  getPaymentMethodForNew,
  getOrderCommissionSettings,
  checkPartnerSalesOrderNumberExists,
  getOrdersSettings,
  getPaymentTerms,
} from "./../../../config/quotation_api_calls";
import { getAgentService } from "./../../../config/api_calls";
//import { listQuotationAgreements } from "./../../../config/api_calls";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import {
  resolvePaymentTermDays,
  dueDateFromTerm,
} from "./../../../config/payment_terms";
import { addSettings, addMsaInfo } from "../../../actions";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/Form";
import { Fileupload } from "../../../components/Image/Fileupload";
import Tooltip from "@material-ui/core/Tooltip";
import MutextField from "@material-ui/core/TextField";
import dateFormat, { masks } from "dateformat";
import DataTable from "../../../components/Tables/DataTable";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Editor } from "@tinymce/tinymce-react";
//import { CKEditor } from "@ckeditor/ckeditor5-react";
//import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import RichTextEditorComponent from "../../../components/Reseller/RichTextEditorComponent";
import parsePhoneNumberFromString from "libphonenumber-js";
import {
  DateTimePicker,
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
const animatedComponents = makeAnimated();

const auth = new HelperClass();
const MAX_INPUT_DIGITS = 15;
const MAX_SAFE_VALUE = Number.MAX_SAFE_INTEGER;

const parseDateLocal = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null;
};
const PAYMENT_TERMS_OPTIONS = [
  "Net 30",
  "Net 60",
  "Net 90",
  "Due on Receipt",
  "2/10 Net 30",
  "1/10 Net 30",
  "2/10 Net 60",
  "3/10 Net 30",
  "Net 45",
  "Net 120",
  "Cash on Delivery (COD)",
  "Cash in Advance (CIA)",
  "Stage Payments",
  "End of Month (EOM)",
  "Other",
];

class EditUotations extends Component {
  constructor() {
    super();
    this.isSendingToCustomer = false;
    const numberOfStates = 100;

    // Initialize state object with incremented values
    const initialState = {};
    const initialStateOptional = {};
    for (let i = 1; i <= numberOfStates; i++) {
      initialState[`select_a_service_${i}`] = null; // You can set any initial value as needed
      initialStateOptional[`select_a_service__optional_${i}`] = null;
    }
    this.state = {
      tableData: [],
      errorMessage: "",
      formLoader: true,
      successMessage: "",
      convErrorMessage: "",
      download_start: false,
      tableLoader: true,
      copied: false,
      copied2: false,
      disabled: false,
      cpied_value: "",
      current_id: "",
      reg_button: false,
      reg_button_login: false,
      cancel_button: false,
      quote_comment_button: false,
      tableLoader: true,
      selected_options: [],
      rfq_requirements: "",
      rfq_attachment: "",
      client_accountno: "",
      rfq_accountno: "",
      draft_button: false,
      send_client_button: false,
      quotation_services: [],
      questions: [],
      all_answers: [],
      client_details: [],
      client_name: "",
      client_company: "",
      client_email: "",
      client_phone: "",
      client_address: "",
      client_address2: "",
      client_city: "",
      client_state: "",
      client_zip: "",
      client_country: "",
      reseller_name: "",
      reseller_company: "",
      reseller_email: "",
      reseller_phone: "",
      reseller_address: "",
      reseller_city: "",
      reseller_state: "",
      reseller_zip: "",
      reseller_details: [],
      service_success_message: "",
      service_already_eists_message: "",
      quote_status: "",
      savedRows: new Set(),
      editingRows: new Set(),
      editingSection: null,
      editableRows: new Set(),
      //Services
      service_grand_total: 0,
      service_grand_sub_total: 0,
      //NOTES
      quote_note_button: false,
      note: [],
      quote_note: "",
      noteErrorMessage: "",
      //Discount Entries
      discount_type: "amount",
      discount_value: 0,
      discount_value_total: 0,
      discount_reason: "",
      //Shipping Entries
      shipping_title: "",
      shipping_value: 0,
      shipping_value_total: 0,
      //Tax Details
      tax_type: "amount",
      tax_value: 0,
      tax_value_total: 0,
      tax_reason: "",
      // Validation error states for numeric inputs
      discount_value_error: "",
      shipping_value_error: "",
      tax_value_error: "",
      // Order Summary Items
      orderSummarySections: [],
      orderSummaryValues: {},
      orderSummaryModalValues: {},
      orderSummaryValueErrors: {},
      orderSummaryItems: [],
      savedOrderSummaryItems: [],
      orderSummaryModalError: "",
      orderSummaryModalSuccess: "",
      activeOrderSummarySectionId: "",
      useDynamicOrderSummary: false,
      all_services: [],
      all_select_services: [],
      all_select_services_optional: [],
      select_service: "",
      select_name: "",
      select_a_service: null,
      select_service_optional: "",
      select_a_service_optional: null,
      initialState,
      initialStateOptional,
      select_name: "",
      quote_accountno: "",
      quote_title: "",
      quote_notes: "",
      email_sent: "No",
      //Quotation Settings
      quotation_notes: "",
      payment_terms: "Net 30",
      custom_payment_terms: "",
      quotation_agreements: [],
      selectedAgreement: "none",
      agreementTitle: "",
      agreementContent: "",
      currency: "USD",
      contact_person: "",
      contact_email: "",
      validity: "",
      errorMessageInfo: "",
      successMessageInfo: "",
      info_button: false,
      conversations: [],
      rows_rfq_questions: [],
      rows_rfq_services: [],
      quote_comment: "",
      rows: [],
      orderno: "",
      agreement_accountno: "",
      payment_details: "",
      payment_method: "",
      order_paid: "unpaid",
      isEditorReady: false,
      isEditorReadyNotes: false,
      quote_attachement: "",
      quotation_attachement_button: false,
      decimal_point: 2,
      billing_decimal_point: 2,

      notifyCheckBox: true,
      cp_commission: (0).toFixed(2),
      commissionSettings: [],
      commission_value: 0,
      commission_value_type: "",
      order_commission: 0,
      orderCommissions: [],
      agent_name: "",
      agent_comp_name: "",
      paymentTermsList: [],
      issueDate: new Date(),
      dueDate: new Date(new Date().setDate(new Date().getDate() + 30)),
      saveButtonEnabled: false,
      saveButtonEnabledOptional: false,

      rows_service_temp: [
        {
          temp_serv_id: "row-135",
          temp_serv_data: {
            temp_serv_inner_id: 940,
            temp_serv_inner_sku: "",
            temp_serv_inner_name: "Item 1",
            temp_serv_inner_quantity: 2,
            temp_serv_inner_unit: "sbc",
            temp_serv_inner_price: 10,
            temp_serv_inner_total: 10,
            temp_serv_inner_type: "service",
          },
        },
      ],
      rows_optional: [],
      rows_optional_temp: [
        {
          temp_opt_id: "row-145",
          temp_opt_data: {
            temp_opt_inner_id: 940,
            temp_opt_inner_sku: "",
            temp_opt_inner_name: "Item 1",
            temp_opt_inner_quantity: 2,
            temp_opt_inner_unit: "sbc",
            temp_opt_inner_price: 10,
            temp_opt_inner_total: 10,
            temp_opt_inner_type: "service",
          },
        },
      ],
      rows_custom_temp: [
        {
          temp_id: "row-125",
          temp_data: {
            temp_inner_id: 94,
            temp_inner_sku: "",
            temp_inner_name: "Item 1",
            temp_inner_quantity: 2,
            temp_inner_unit: "sbc",
            temp_inner_price: 10,
            temp_inner_total: 10,
            temp_inner_type: "custom",
          },
        },
      ],
    };
  }

  getDecimalPoint = () => {
    if (
      this.props.quotationSettings[0]?.decimal_point &&
      this.props.quotationSettings[0]?.decimal_point !== ""
    ) {
      const decimalPoint = this.props.quotationSettings[0]?.decimal_point;
      return decimalPoint !== "" ? Number(decimalPoint) : 2;
    }
    return 2;
  };

  getBillingDecimalPoint = () => {
    if (
      this.props.quotationSettings[0]?.billing_decimal_point &&
      this.props.quotationSettings[0]?.billing_decimal_point !== ""
    ) {
      const decimalPoint =
        this.props.quotationSettings[0]?.billing_decimal_point;
      return decimalPoint !== "" ? Number(decimalPoint) : 2;
    }
    return 2;
  };

  async componentDidMount() {
    let orderno = this.props.props.match.params.orderno;
    let client_accountno = this.props.props.match.params.client_accountno;
    let quote_accountno = this.props.props.match.params.quote_accountno;
    const urlParams = new URLSearchParams(window.location.search);
    const orderParam = urlParams.get("order");

    if (orderParam === "add") {
      const orderNumberResponse = await checkPartnerSalesOrderNumberExists(
        auth.getAccount(),
        auth.getToken(),
        client_accountno,
        "add",
        orderno
      );

      if (
        orderNumberResponse &&
        orderNumberResponse.data &&
        (orderNumberResponse.data.status === 200 ||
          orderNumberResponse.data.message === "success")
      ) {
        orderno =
          orderNumberResponse.data.orderno ||
          (orderNumberResponse.data.data &&
            orderNumberResponse.data.data.orderno) ||
          orderno;
      }
    }
    //Zc5DaPETvz7oXkd
    let decimal_point = 2;
    if (
      this.props.quotationSettings[0]?.decimal_point &&
      this.props.quotationSettings[0]?.decimal_point !== ""
    ) {
      const decimalPoint = this.props.quotationSettings[0]?.decimal_point;
      decimal_point = decimalPoint !== "" ? Number(decimalPoint) : 2;
    }
    let billing_decimal_point = 2;
    if (
      this.props.quotationSettings[0]?.billing_decimal_point &&
      this.props.quotationSettings[0]?.billing_decimal_point !== ""
    ) {
      const decimalPoint =
        this.props.quotationSettings[0]?.billing_decimal_point;
      billing_decimal_point = decimalPoint !== "" ? Number(decimalPoint) : 2;
    }

    await new Promise((resolve) =>
      this.setState(
        {
          client_accountno: client_accountno,
          orderno: orderno,
          quote_accountno: quote_accountno,
          quote_title: "Order - " + orderno,
          decimal_point: decimal_point,
          billing_decimal_point: billing_decimal_point,
        },
        resolve
      )
    );

    this.getServices();
    this.getPaymentTermsList();

    if (
      this.props.props.match.params.quote_accountno &&
      this.props.props.match.params.quote_accountno !== ""
    ) {
      //this.getSingleQuotation(client_accountno, quote_accountno);
      //this.getQuotationSettings(quote_accountno);
    }
    await this.getOrderCommissionSettings();
    this.loadOrderSummarySettings();
    if (orderno && orderno !== "") {
      this.getSingleOrder(client_accountno, orderno);
      this.getOrderSettings(orderno);
      setTimeout(async () => {
        this.getPaymentMethod(orderno);
      }, 1000);
    }

    if (client_accountno !== "") {
      this.getSingleClient(client_accountno);
    }
  }

  getPaymentTermsList = async () => {
    try {
      const response = await getPaymentTerms(auth.getAccount(), auth.getToken());
      if (
        response &&
        response.data &&
        response.data.status === 200 &&
        response.data.message === "success"
      ) {
        const list = response.data.data;
        const newState = { paymentTermsList: list };
        const computed = dueDateFromTerm(
          parseDateLocal(this.state.issueDate) || new Date(),
          resolvePaymentTermDays(this.state.payment_terms, list)
        );
        if (computed) newState.dueDate = computed;
        this.setState(newState);
      }
    } catch (e) { }
  };

  getSingleClient = async (client_accountno) => {
    const servicesResponce = await listSingleClient(
      auth.getAccount(),
      auth.getToken(),
      client_accountno
    );
    //console.log("getSingleClient: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        client_details: servicesResponce.data.client_details,
        //quotation_notes: quotation_notes,
        //quote_notes: quotation_notes,
        client_name:
          servicesResponce.data.client_details[0]["name"] &&
            servicesResponce.data.client_details[0]["name"] !== ""
            ? servicesResponce.data.client_details[0]["name"]
            : "",
        client_company: servicesResponce.data.client_details[0]["comp_name"]
          ? servicesResponce.data.client_details[0]["comp_name"]
          : "",
        client_email: servicesResponce.data.client_details[0]["email"]
          ? servicesResponce.data.client_details[0]["email"]
          : "",
        client_phone: servicesResponce.data.client_details[0]["phone"]
          ? servicesResponce.data.client_details[0]["phone"]
          : "",
        client_address: servicesResponce.data.client_details[0]["address"]
          ? servicesResponce.data.client_details[0]["address"]
          : "",
        client_address2: servicesResponce.data.client_details[0]["address2"]
          ? servicesResponce.data.client_details[0]["address2"]
          : "",
        client_city: servicesResponce.data.client_details[0]["city"]
          ? servicesResponce.data.client_details[0]["city"]
          : "",
        client_state: servicesResponce.data.client_details[0]["state"]
          ? servicesResponce.data.client_details[0]["state"]
          : "",
        client_zip: servicesResponce.data.client_details[0]["zip"]
          ? servicesResponce.data.client_details[0]["zip"]
          : "",
        client_country: servicesResponce.data.client_details[0]["country"]
          ? servicesResponce.data.client_details[0]["country"]
          : "",
        agent_name: servicesResponce.data.client_details[0]["agent_name"],
        agent_comp_name:
          servicesResponce.data.client_details[0]["agent_comp_name"],
        reseller_details: servicesResponce.data.reseller_details,
        reseller_name: servicesResponce.data.reseller_details[0]["name"]
          ? servicesResponce.data.reseller_details[0]["name"]
          : "",
        reseller_company: servicesResponce.data.reseller_details[0]["comp_name"]
          ? servicesResponce.data.reseller_details[0]["comp_name"]
          : "",
        reseller_email: servicesResponce.data.reseller_details[0]["email"]
          ? servicesResponce.data.reseller_details[0]["email"]
          : "",
        reseller_phone: servicesResponce.data.reseller_details[0]["phone"]
          ? servicesResponce.data.reseller_details[0]["phone"]
          : "",
        reseller_address: servicesResponce.data.reseller_details[0]["address"]
          ? servicesResponce.data.reseller_details[0]["address"]
          : "",
        reseller_city: servicesResponce.data.reseller_details[0]["city"]
          ? servicesResponce.data.reseller_details[0]["city"]
          : "",
        reseller_state: servicesResponce.data.reseller_details[0]["state"]
          ? servicesResponce.data.reseller_details[0]["state"]
          : "",
        reseller_zip: servicesResponce.data.reseller_details[0]["zip"]
          ? servicesResponce.data.reseller_details[0]["zip"]
          : "",
        tableLoader: false,
      });
    } else {
      // window.location.replace("/error");
    }
  };

  getQuotationSettings = async (quote_accountno) => {
    const servicesResponce = await getAssignedQuotationSettings(
      auth.getAccount(),
      auth.getToken(),
      quote_accountno
    );
    //console.log("getQuotationSettings: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      const savedPaymentTerms = servicesResponce.data.data[0]["payment_terms"] || "";
      const isPredefinedPaymentTerm = PAYMENT_TERMS_OPTIONS.includes(savedPaymentTerms);
      this.setState({
        payment_terms: isPredefinedPaymentTerm
          ? savedPaymentTerms
          : savedPaymentTerms
            ? "Other"
            : "Net 30",
        custom_payment_terms: isPredefinedPaymentTerm ? "" : savedPaymentTerms,
        currency: servicesResponce.data.data[0]["currency"].toUpperCase(),
        contact_person: servicesResponce.data.data[0]["contact_person"],
        contact_email: servicesResponce.data.data[0]["contact_email"],
        validity: servicesResponce.data.data[0]["validity"],
        quote_notes: servicesResponce.data.data[0]["quote_notes"],
        selectedAgreement: servicesResponce.data.data[0]["agreement_accountno"],
        agreementTitle: servicesResponce.data.data[0]["agreement_title"],
        agreementContent: servicesResponce.data.data[0]["agreement_content"],
        tableLoader: false,
      });
    } else {
      // window.location.replace("/error");
    }
  };

  getPaymentMethod = async (orderno) => {
    //const { orderno } = this.state;
    this.setState({
      paymentMethodLoader: true,
      payErrorMessage: "",
    });
    const servicesResponce = await getPaymentMethodForNew(
      auth.getAccount(),
      auth.getToken(),
      orderno
    );
    //console.log("getPaymentMethod: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
      this.setState({
        paymentMethodLoader: false,
        payErrorMessage:
          "There is some error while getting the payment methods.",
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let payment_details = "";
      if (servicesResponce.data.data && servicesResponce.data.data.length > 0) {
        payment_details = servicesResponce.data.data[0]["payment_details"];
      }
      //console.log("payment_details: ", payment_details);
      this.setState(
        {
          //payment_method: servicesResponce.data.data[0]["payment_method"],
          payment_details: payment_details,
          paymentMethodLoader: false,
          isEditorReady: false,
        },
        () => {
          setTimeout(() => {
            this.setState({ isEditorReady: true });
          }, 500);
        }
      );
    } else {
      this.setState({
        paymentMethodLoader: false,
        payErrorMessage:
          "There is some error while getting the payment methods.",
      });
      // window.location.replace("/error");
    }
    if (this.state.payErrorMessage !== "") {
      setTimeout(() => {
        this.setState({
          payErrorMessage: "",
        });
      }, 4000);
    }
  };

  getOrderCommissionSettings = async () => {
    //const { client_accountno } = this.state;
    const servicesResponce = await getOrderCommissionSettings(
      auth.getAccount(),
      auth.getToken()
    );
    //console.log("getOrderCommissionSettings: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        commissionSettings: servicesResponce.data.commissionSettings,
        commission_value:
          servicesResponce.data.commissionSettings[0]["commission_value"],
        commission_value_type:
          servicesResponce.data.commissionSettings[0]["commission_value_type"],
        tableLoader: false,
      });
    } else {
      // window.location.replace("/error");
    }
  };

  calculateCommission = () => {
    const {
      commission_value,
      commission_value_type,
      service_grand_sub_total,
      service_grand_total,
      discount_value_total,
    } = this.state;
    let calculated_commission = 0;
    let amount_eligible_for_commission =
      service_grand_sub_total - discount_value_total;
    if (commission_value_type === "percentage") {
      calculated_commission =
        (commission_value / 100) * amount_eligible_for_commission;
      // console.log("calculated_commission Inner: ", calculated_commission);
    } else {
      calculated_commission = commission_value;
    }
    this.setState({
      cp_commission: calculated_commission
        ? calculated_commission.toFixed(this.getBillingDecimalPoint())
        : (0).toFixed(this.getBillingDecimalPoint()),
    });
  };

  handleTabChange(tabId) {
    this.setState({ activeTab: tabId });
  }

  getOrderSettings = async (orderno) => {
    const servicesResponce = await getAssignedOrderSettings(
      auth.getAccount(),
      auth.getToken(),
      orderno
    );
    //console.log("getOrderSettings: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({ isEditorReadyNotes: true })
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let quote_note = this.state.quote_notes;
      const savedPaymentTerms =
        servicesResponce.data.data[0]["payment_terms"] &&
          servicesResponce.data.data[0]["payment_terms"] !== ""
          ? servicesResponce.data.data[0]["payment_terms"]
          : "Net 30";
      const isPredefinedPaymentTerm = PAYMENT_TERMS_OPTIONS.includes(savedPaymentTerms);
      this.setState({
        payment_terms: isPredefinedPaymentTerm ? savedPaymentTerms : "Other",
        custom_payment_terms: isPredefinedPaymentTerm ? "" : savedPaymentTerms,
        currency: servicesResponce.data.data[0]["currency"].toUpperCase(),
        contact_person: servicesResponce.data.data[0]["contact_person"],
        contact_email: servicesResponce.data.data[0]["contact_email"],
        validity: servicesResponce.data.data[0]["validity"],
        quote_notes: servicesResponce.data.data[0]["quote_notes"],
        selectedAgreement: servicesResponce.data.data[0]["agreement_accountno"],
        agreementTitle: servicesResponce.data.data[0]["agreement_title"],
        agreementContent: servicesResponce.data.data[0]["agreement_content"],
        tableLoader: false,
      });
      if (!this.state.quote_notes || this.state.quote_notes === "") {
        quote_note = servicesResponce.data.data[0]["quote_notes"];

        this.setState({
          quote_notes: quote_note,
          isEditorReadyNotes: true,
        });
      }
    } else {
      this.setState({ isEditorReadyNotes: true });
    }
  };

  getSingleRfq = async (client_accountno, rfq_accountno) => {
    const servicesResponce = await getSingleRfq(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
      rfq_accountno
    );
    //console.log("getSingleRfq: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      if (
        servicesResponce.data.data[0]["rfq_questions"] &&
        servicesResponce.data.data[0]["rfq_questions"].length > 0
      ) {
        let rfq_questions = servicesResponce.data.data[0]["rfq_questions"];
        for (let i = 0; i < rfq_questions.length; i++) {
          if (
            rfq_questions[i]["question_type"] === "radio" ||
            rfq_questions[i]["question_type"] === "dropdown"
          ) {
            let answer_id = this.doesAnswerIdExist(
              Number(rfq_questions[i]["answer_id"]),
              servicesResponce.data.all_answers
            );

            rfq_questions[i]["answer"] = answer_id;
          } else if (rfq_questions[i]["question_type"] === "checkbox") {
            let answer_id = this.doesAnswerArrayExist(
              JSON.parse(rfq_questions[i]["answer_id"]),
              servicesResponce.data.all_answers
            );

            rfq_questions[i]["answer"] = answer_id;
          } else {
            rfq_questions[i]["answer"] = rfq_questions[i]["answer_id"];
          }
        }
      }

      //console.log("rfq_questions: "+servicesResponce.data.data);
      let servicesRows = [];
      if (
        servicesResponce.data.data[0]["rfq_services"] &&
        servicesResponce.data.data[0]["rfq_services"].length > 0
      ) {
        let rfq_services = servicesResponce.data.data[0]["rfq_services"];
        for (let i = 0; i < rfq_services.length; i++) {
          let newArray = {
            id: `row-${i}`,
            data: {
              id: rfq_services[i]["service_id"],
              name: rfq_services[i]["service_name"],
              quantity: rfq_services[i]["quantity"],
              unit: rfq_services[i]["service_unit"],
              sku: rfq_services[i]["sku"],
              price: 0,
              total: 0,
              type: "service",
            },
          };
          servicesRows.push(newArray);
        }
      }
      // console.log("servicesRows: ", servicesRows);
      this.setState({
        rows_rfq_services: servicesRows,
        //tableData: servicesResponce.data.data,
        rows_rfq_questions: servicesResponce.data.data[0]["rfq_questions"],
        quotation_services: servicesResponce.data.data[0]["rfq_services"],
        rfq_requirements: servicesResponce.data.data[0]["rfq_comments"],
        rfq_attachment: servicesResponce.data.data[0]["rfq_attachement"],
        all_answers: servicesResponce.data.all_answers,

        tableLoader: false,
      });
    } else {
      // window.location.replace("/error");
    }
  };

  handleDateChange = (newDate) => {
    const { issueDate } = this.state;
    if (issueDate && newDate < new Date(issueDate)) {
      this.setState({ errorMessageInfo: "Due date cannot be earlier than Issue date." });
    } else {
      this.setState({ dueDate: newDate, errorMessageInfo: "" });
    }
  };

  handleIssueDateChange = (newDate) => {
    const { dueDate, paymentTermsList, payment_terms } = this.state;
    const computed = dueDateFromTerm(
      newDate,
      resolvePaymentTermDays(payment_terms, paymentTermsList)
    );
    if (computed) {
      this.setState({ issueDate: newDate, dueDate: computed, errorMessageInfo: "" });
      return;
    }
    if (dueDate && newDate > new Date(dueDate)) {
      this.setState({ errorMessageInfo: "Issue date cannot be later than Due date." });
    } else {
      this.setState({ issueDate: newDate, errorMessageInfo: "" });
    }
  };

  getSingleQuotation = async (client_accountno, quote_accountno) => {
    const servicesResponce = await getSingleQuotation(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
      quote_accountno
    );
    //console.log("getSingleQuotation: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let discount_value_total = 0;
      let discount_type = "amount";
      let discount_value = 0;
      let discount_reason = "";
      if (
        servicesResponce.data.data[0]["discounts"] &&
        servicesResponce.data.data[0]["discounts"].length > 0
      ) {
        discount_value_total =
          servicesResponce.data.data[0]["discounts"][0]["discount_total"];
        discount_type =
          servicesResponce.data.data[0]["discounts"][0]["discount_type"];
        discount_value =
          servicesResponce.data.data[0]["discounts"][0]["discount_value"];
        discount_reason =
          servicesResponce.data.data[0]["discounts"][0]["discount_reason"];
      }
      let tax_value_total = 0;
      let tax_type = "amount";
      let tax_value = 0;
      let tax_reason = "";
      if (
        servicesResponce.data.data[0]["taxes"] &&
        servicesResponce.data.data[0]["taxes"].length > 0
      ) {
        tax_value_total =
          servicesResponce.data.data[0]["taxes"][0]["tax_total"];
        tax_type = servicesResponce.data.data[0]["taxes"][0]["tax_type"];
        tax_value = servicesResponce.data.data[0]["taxes"][0]["tax_value"];
        tax_reason = servicesResponce.data.data[0]["taxes"][0]["tax_reason"];
      }
      let shipping_value_total = 0;
      let shipping_title = "";
      let shipping_value = "";
      if (
        servicesResponce.data.data[0]["shipping"] &&
        servicesResponce.data.data[0]["shipping"].length > 0
      ) {
        shipping_value_total =
          servicesResponce.data.data[0]["shipping"][0]["shipping_value"];
        shipping_title =
          servicesResponce.data.data[0]["shipping"][0]["shipping_title"];
        shipping_value =
          servicesResponce.data.data[0]["shipping"][0]["shipping_value"];
      }
      //console.log("rfq_questions: "+servicesResponce.data.data);
      let servicesRows = [];
      let total = 0;
      if (
        servicesResponce.data.data[0]["quote_services"] &&
        servicesResponce.data.data[0]["quote_services"].length > 0
      ) {
        let rfq_services = servicesResponce.data.data[0]["quote_services"];
        for (let i = 0; i < rfq_services.length; i++) {
          let sku = rfq_services[i]["sku"];
          if (rfq_services[i]["item_type"] === "custom") {
            if (rfq_services[i]["sku"] && rfq_services[i]["sku"] !== "") {
              sku = rfq_services[i]["sku"];
            } else {
              sku = "CU-" + i;
            }
          }
          let newArray = {
            id: `row-${i}`,
            data: {
              id: rfq_services[i]["service_id"],
              sku: sku,
              name: rfq_services[i]["service_name"],
              quantity: rfq_services[i]["quantity"],
              unit: rfq_services[i]["service_unit"],
              price: Number(rfq_services[i]["service_price"]),
              total: Number(
                Number(rfq_services[i]["quantity"]) *
                rfq_services[i]["service_price"]
              ).toFixed(this.getBillingDecimalPoint()),
              type: rfq_services[i]["item_type"],
            },
          };
          servicesRows.push(newArray);
          total =
            total +
            Number(rfq_services[i]["service_price"]) *
            Number(rfq_services[i]["quantity"]);
          //Remove already added services from the list
        }
      }
      //Minus Discount
      let with_discount = total - parseFloat(discount_value_total);
      //Calculate Tax
      with_discount = with_discount + parseFloat(tax_value_total);
      //Calculate Shipping
      with_discount = with_discount + parseFloat(shipping_value_total);

      //**** Get Optional Services ****/rows_optional
      let servicesOptionalRows = [];
      if (
        servicesResponce.data.data[0]["quote_optional_services"] &&
        servicesResponce.data.data[0]["quote_optional_services"].length > 0
      ) {
        let optional_services =
          servicesResponce.data.data[0]["quote_optional_services"];
        for (let i = 0; i < optional_services.length; i++) {
          let newArrays = {
            id: `row-${i}`,
            data: {
              id: optional_services[i]["service_id"],
              sku: optional_services[i]["sku"],
              name: optional_services[i]["service_name"],
              quantity: optional_services[i]["quantity"],
              unit: optional_services[i]["service_unit"],
              price: Number(optional_services[i]["service_price"]).toFixed(
                this.getDecimalPoint()
              ),
              total: Number(
                Number(optional_services[i]["quantity"]) *
                optional_services[i]["service_price"]
              ).toFixed(this.getBillingDecimalPoint()),
              type: optional_services[i]["item_type"],
            },
          };
          servicesOptionalRows.push(newArrays);
        }
      }
      this.setState({
        rows: servicesRows,
        rows_optional: servicesOptionalRows,
        tableData: servicesResponce.data.data,
        quotation_services: servicesResponce.data.data[0]["quote_services"],
        quote_title: servicesResponce.data.data[0]["quote_title"],
        quote_notes: servicesResponce.data.data[0]["quote_notes"],
        quote_attachement: servicesResponce.data.data[0]["quote_attachement"],
        all_answers: servicesResponce.data.all_answers,
        service_grand_total:
          with_discount && with_discount > 0
            ? with_discount.toFixed(this.getBillingDecimalPoint())
            : (0).toFixed(this.getBillingDecimalPoint()),
        service_grand_sub_total:
          total && total > 0
            ? total.toFixed(this.getBillingDecimalPoint())
            : (0).toFixed(this.getBillingDecimalPoint()),
        discount_value_total: discount_value_total,
        discount_type: discount_type,
        discount_value: discount_value,
        discount_reason: discount_reason,
        tax_value_total: tax_value_total,
        tax_type: tax_type,
        tax_value: tax_value,
        tax_reason: tax_reason,
        shipping_value_total: shipping_value_total,
        shipping_value: shipping_value,
        shipping_title: shipping_title,
        email_sent: servicesResponce.data.data[0]["email_sent"],
        conversations: servicesResponce.data.data[0]["conversations"],
        quote_status: servicesResponce.data.data[0]["quote_status"],

        tableLoader: false,
      });
    } else {
      // window.location.replace("/error");
    }
  };

  getSingleOrder = async (client_accountno, orderno) => {
    const { decimal_point } = this.state;
    const servicesResponce = await getSingleOrder(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
      orderno
    );
    // console.log("getSingleOrder: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({ isEditorReady: true });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let discount_value_total = 0;
      let discount_type = "amount";
      let discount_value = 0;
      let discount_reason = "";
      if (
        servicesResponce.data.data[0]["discounts"] &&
        servicesResponce.data.data[0]["discounts"].length > 0
      ) {
        discount_value_total =
          servicesResponce.data.data[0]["discounts"][0]["discount_total"];
        discount_type =
          servicesResponce.data.data[0]["discounts"][0]["discount_type"];
        discount_value =
          servicesResponce.data.data[0]["discounts"][0]["discount_value"];
        discount_reason =
          servicesResponce.data.data[0]["discounts"][0]["discount_reason"];
      }
      let tax_value_total = 0;
      let tax_type = "amount";
      let tax_value = 0;
      let tax_reason = "";
      if (
        servicesResponce.data.data[0]["taxes"] &&
        servicesResponce.data.data[0]["taxes"].length > 0
      ) {
        tax_value_total =
          servicesResponce.data.data[0]["taxes"][0]["tax_total"];
        tax_type = servicesResponce.data.data[0]["taxes"][0]["tax_type"];
        tax_value = servicesResponce.data.data[0]["taxes"][0]["tax_value"];
        tax_reason = servicesResponce.data.data[0]["taxes"][0]["tax_reason"];
      }
      let shipping_value_total = 0;
      let shipping_title = "";
      let shipping_value = "";
      if (
        servicesResponce.data.data[0]["shipping"] &&
        servicesResponce.data.data[0]["shipping"].length > 0
      ) {
        shipping_value_total =
          servicesResponce.data.data[0]["shipping"][0]["shipping_value"];
        shipping_title =
          servicesResponce.data.data[0]["shipping"][0]["shipping_title"];
        shipping_value =
          servicesResponce.data.data[0]["shipping"][0]["shipping_value"];
      }
      //console.log("rfq_questions: "+servicesResponce.data.data);
      let servicesRows = [];
      let savedRowIds = new Set();
      let total = 0;
      if (
        servicesResponce.data.data[0]["quote_services"] &&
        servicesResponce.data.data[0]["quote_services"].length > 0
      ) {
        let rfq_services = servicesResponce.data.data[0]["quote_services"];
        for (let i = 0; i < rfq_services.length; i++) {
          let rowId = `row-${i}`;
          savedRowIds.add(rowId);
          let sku = rfq_services[i]["sku"];
          let description = rfq_services[i]["description"];
          if (rfq_services[i]["item_type"] === "custom") {
            if (rfq_services[i]["sku"] && rfq_services[i]["sku"] !== "") {
              sku = rfq_services[i]["sku"];
            } else {
              sku = "CU-" + i;
            }
            if (
              rfq_services[i]["description"] &&
              rfq_services[i]["description"] !== ""
            ) {
              description = rfq_services[i]["description"];
            } else {
              description = "";
            }
          }
          let newArray = {
            id: `row-${i}`,
            data: {
              id: rfq_services[i]["service_id"],
              sku: sku,
              name: rfq_services[i]["service_name"],
              quantity: rfq_services[i]["quantity"],
              unit: rfq_services[i]["service_unit"],
              price: Number(rfq_services[i]["service_price"]),
              total: Number(
                Number(rfq_services[i]["quantity"]) *
                rfq_services[i]["service_price"]
              ).toFixed(this.getBillingDecimalPoint()),
              type: rfq_services[i]["item_type"],
              description: description,
            },
          };
          servicesRows.push(newArray);
          total =
            total +
            Number(rfq_services[i]["service_price"]) *
            Number(rfq_services[i]["quantity"]);
          //Remove already added services from the list
        }
      }
      //Minus Discount
      let with_discount = total - parseFloat(discount_value_total);
      //Calculate Tax
      with_discount = with_discount + parseFloat(tax_value_total);
      //Calculate Shipping
      with_discount = with_discount + parseFloat(shipping_value_total);

      //**** Get Optional Services ****/rows_optional
      let servicesOptionalRows = [];
      let order_paid = "unpaid";
      if (
        servicesResponce.data.data[0]["payment_status"] &&
        servicesResponce.data.data[0]["payment_status"] === "paid"
      ) {
        order_paid = "paid";
      }
      let issueDate = this.state.issueDate;
      if (
        servicesResponce.data.data[0]["dateCreated"] &&
        servicesResponce.data.data[0]["dateCreated"] !== ""
      ) {
        issueDate = parseDateLocal(servicesResponce.data.data[0]["dateCreated"]);
      }

      let dueDate;
      if (
        servicesResponce.data.data[0]["dueDate"] &&
        servicesResponce.data.data[0]["dueDate"] !== ""
      ) {
        dueDate = parseDateLocal(servicesResponce.data.data[0]["dueDate"]);
      } else {
        const termName =
          servicesResponce.data.data[0]["payment_terms"] || this.state.payment_terms;
        const days = resolvePaymentTermDays(termName, this.state.paymentTermsList);
        // Unknown term: fall back to the issue date rather than silently
        // assuming 30 days, which is what made "Due on Receipt" a month late.
        dueDate =
          dueDateFromTerm(parseDateLocal(issueDate) || new Date(), days) ||
          parseDateLocal(issueDate) ||
          new Date();
      }

      let all_select_services = [];

      if (servicesResponce.data.data[0]["quote_services"]) {
        const services = servicesResponce.data.data[0]["quote_services"];
        for (let service of services) {
          all_select_services.push({
            label: service.service_name,
            value: service.service_id,
          });
        }
      }

      if (this.state.rows && this.state.rows.length > 0) {
        for (let row of this.state.rows) {
          if (row.data.type === "service" && row.data.id) {
            all_select_services = all_select_services.filter(
              (item) => item.value !== row.data.id
            );
          }
        }
      }

      if (this.state.all_services && this.state.all_services.length > 0) {
        all_select_services = this.state.all_services.map((service) => ({
          value: service[0],
          label: service[1] || service[0],
        }));
        if (servicesRows.length > 0) {
          for (let row of servicesRows) {
            if (row.data.id && row.data.id !== "") {
              all_select_services = all_select_services.filter(
                (item) => item.value !== row.data.id
              );
            }
          }
        }
        if (servicesOptionalRows.length > 0) {
          for (let row of servicesOptionalRows) {
            if (row.data.id && row.data.id !== "") {
              all_select_services = all_select_services.filter(
                (item) => item.value !== row.data.id
              );
            }
          }
        }
      }
      // Extract dynamic order summary sections directly from get_single_order response
      const rawOrderSettings =
        servicesResponce.data.data[0]["order_settings"] ||
        servicesResponce.data["order_settings"] ||
        [];
      const activeSections = (rawOrderSettings || []).filter(
        (section) => section && section.section_is_active
      );
      const initialOrderSummaryValues = {};
      activeSections.forEach((section) => {
        initialOrderSummaryValues[section.id] = { value: "", description: "" };
      });
      const orderSummaryItemsFromApi =
        servicesResponce.data.data[0]["order_summary_items"] &&
          servicesResponce.data.data[0]["order_summary_items"].length > 0
          ? servicesResponce.data.data[0]["order_summary_items"]
          : servicesResponce.data.data[0]["orderSummaryItems"] &&
            servicesResponce.data.data[0]["orderSummaryItems"].length > 0
            ? servicesResponce.data.data[0]["orderSummaryItems"]
            : [];

      this.setState(
        {
          rows: servicesRows,
          rows_optional: servicesOptionalRows,
          tableData: servicesResponce.data.data,
          quotation_services: servicesResponce.data.data[0]["quote_services"],
          quote_title: servicesResponce.data.data[0]["quote_title"],
          quote_notes: servicesResponce.data.data[0]["quote_notes"],
          quote_attachement: servicesResponce.data.data[0]["quote_attachement"],
          all_answers: servicesResponce.data.all_answers,
          service_grand_total:
            with_discount && with_discount > 0
              ? with_discount.toFixed(this.getBillingDecimalPoint())
              : (0).toFixed(this.getBillingDecimalPoint()),
          service_grand_sub_total:
            total && total > 0
              ? total.toFixed(this.getBillingDecimalPoint())
              : (0).toFixed(this.getBillingDecimalPoint()),
          discount_value_total: discount_value_total,
          discount_type: discount_type,
          discount_value: discount_value,
          discount_reason: discount_reason,
          tax_value_total: tax_value_total,
          tax_type: tax_type,
          tax_value: tax_value,
          tax_reason: tax_reason,
          shipping_value_total: shipping_value_total,
          shipping_value: shipping_value,
          shipping_title: shipping_title,
          email_sent: servicesResponce.data.data[0]["email_sent"],
          conversations: servicesResponce.data.data[0]["conversations"],
          quote_status: servicesResponce.data.data[0]["quote_status"],
          savedRows: savedRowIds,
          order_paid: order_paid,
          issueDate: issueDate,
          dueDate: dueDate,
          all_select_services: all_select_services,
          all_select_services_optional: all_select_services,
          saveButtonEnabled: servicesRows.length > 0,
          saveButtonEnabledOptional: servicesOptionalRows.length > 0,
          savedOrderSummaryItems: orderSummaryItemsFromApi,
          orderSummarySections: activeSections,
          useDynamicOrderSummary: activeSections.length > 0,
          orderSummaryValues: initialOrderSummaryValues,
          rows_service_temp: servicesRows.map((row) => ({
            temp_serv_id: row.id,
            temp_serv_data: {
              temp_serv_inner_id: row.data.id,
              temp_serv_inner_sku: row.data.sku || "",
              temp_serv_inner_name: row.data.name,
              temp_serv_inner_quantity: row.data.quantity || 1,
              temp_serv_inner_unit: row.data.unit || "",
              temp_serv_inner_price: row.data.price,
              temp_serv_inner_total: row.data.total,
              temp_serv_inner_type: "service",
              temp_serv_inner_serviceType: row.data.serviceType || "",
            },
          })),
          tableLoader: false,
          isEditorReady: true,
        },
        () => {
          setTimeout(() => {
            let orderCommissions = 0;
            if (
              servicesResponce.data.data[0]["orderCommissions"] &&
              servicesResponce.data.data[0]["orderCommissions"].length > 0
            ) {
              let commArray = servicesResponce.data.data[0]["orderCommissions"];
              orderCommissions = commArray[0]["total_commission"].toFixed(
                this.getBillingDecimalPoint()
              );
            }

            if (orderCommissions === 0) {
              orderCommissions = this.getCommission();
            }
            // console.log("orderCommissions: ", orderCommissions);
            this.setState({
              isEditorReadyNotes: true,
              cp_commission: orderCommissions,
            });
          }, 500);
          if (activeSections.length > 0) {
            const { savedOrderSummaryItems } = this.state;
            if (savedOrderSummaryItems && savedOrderSummaryItems.length > 0) {
              this.hydrateFromSavedItems(savedOrderSummaryItems);
            } else {
              this.hydrateDynamicSummaryFromLegacy();
            }
            this.calculateTotalRate();
          } else {
            this.loadOrderSummarySettings();
          }
        }
      );
    } else {
      this.setState({ isEditorReady: true });
      // window.location.replace("/error");
    }
  };

  getCommission = () => {
    const {
      commission_value,
      commission_value_type,
      service_grand_sub_total,
      service_grand_total,
      discount_value_total,
    } = this.state;
    let calculated_commission = 0;
    let amount_eligible_for_commission =
      service_grand_sub_total - discount_value_total;
    if (commission_value_type === "percentage") {
      calculated_commission =
        (commission_value / 100) * amount_eligible_for_commission;
      // console.log("calculated_commission Inner: ", calculated_commission);
    } else {
      calculated_commission = commission_value;
    }
    return calculated_commission
      ? calculated_commission.toFixed(this.getBillingDecimalPoint())
      : (0).toFixed(this.getBillingDecimalPoint());
  };

  getServices = async () => {
    const { client_accountno } = this.state;
    const servicesResponce = await listServicesWithPriceAgents(
      auth.getAccount(),
      auth.getToken(),
      client_accountno
    );
    // console.log("getServices: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let all_select_services = [];
      if (servicesResponce.data.data && servicesResponce.data.data.length > 0) {
        for (let i = 0; i < servicesResponce.data.data.length; i++) {
          let newArr = {
            label: servicesResponce.data.data[i][1],
            value: servicesResponce.data.data[i][0],
          };
          all_select_services.push(newArr);
        }
      }
      if (this.state.rows && this.state.rows.length > 0) {
        for (let i = 0; i < this.state.rows.length; i++) {
          // console.log(
          //   'this.state.rows[i]["type"]: ' +
          //     this.state.rows[i].data.type +
          //     " " +
          //     this.state.rows[i].data.id
          // );
          if (this.state.rows[i].data.type === "service") {
            if (
              this.state.rows[i].data.id &&
              this.state.rows[i].data.id !== ""
            ) {
              all_select_services = all_select_services.filter(
                (item) => item.value !== this.state.rows[i].data.id
              );
            }
          }
        }
      }
      this.setState({
        all_select_services: all_select_services,
        all_select_services_optional: all_select_services,
        all_services: servicesResponce.data.data,
      });
    }
  };

  removeAddedServices = async (service_id, service_type) => {
    // console.log("removeAddedServices service_id: ", service_id);
    let all_services = this.state.all_services;
    // console.log("removeAddedServices all_select_services: ", all_services);
    let all_select_services_optional = this.state.all_select_services_optional;
    if (service_type === "service") {
      let arrayOfItems = all_services.filter(
        (item) => item.value !== service_id
      );
      // console.log("removeAddedServices arrayOfItems: ", arrayOfItems);
      this.setState({
        all_services: arrayOfItems,
        all_select_services_optional: arrayOfItems,
      });
    }
  };

  doesAnswerIdExist = (answerIdToCheck, answerArray) => {
    //return answerArray.some((answer) => answer.answer_id === answerIdToCheck);
    const answer = answerArray.find((item) => item.id === answerIdToCheck);
    return answer ? answer.question_options : "";
  };

  doesAnswerArrayExist = (answerIdToCheck, answerArray) => {
    answerIdToCheck = JSON.stringify(answerIdToCheck);
    //return answerArray.some((answer) => answer.answer_id === answerIdToCheck);
    const objectValues = answerIdToCheck.slice(1, -1).split(",");
    var matchingItems = "";
    objectValues.map((setString, index) => {
      // console.log("setString: ", setString);
      let answer = answerArray.find((item) => item.id === Number(setString));
      if (answer) {
        matchingItems +=
          "<p>" + (Number(index) + 1) + ": " + answer.question_options + "</p>";
      }
    });

    return (
      <div
        dangerouslySetInnerHTML={{
          __html: matchingItems,
        }}
      />
    );
  };

  validateAllRowsSaved = () => {
    const { rows, savedRows, editingRows, editingSection, editableRows } =
      this.state;

    let messages = [];
    let lineItemIssue = false;

    // Validate all line items (regular and custom)
    const unsavedRows = rows.filter(
      (row) =>
        !savedRows.has(row.id) ||
        editingRows.has(row.id) ||
        editableRows.has(row.id)
    );
    if (unsavedRows.length > 0 || editingSection !== null) {
      lineItemIssue = true;
    }

    // Generate messages based on the issues found
    if (lineItemIssue) {
      messages.push("Please save all line items to proceed.");
    }
    // Return the appropriate message
    return messages.length > 0 ? messages[0] : null;
  };

  defaultText = (value, tableMeta) => {
    let is_default = value;
    if (is_default === "pending") {
      return <span className="badge badge-outline-primary">Pending</span>;
    } else if (is_default === "approved") {
      return <span className="badge badge-outline-success">Approved</span>;
    } else if (is_default === "cancelled") {
      return <span className="badge badge-outline-danger">Cancelled</span>;
    } else if (is_default === "in_review") {
      return <span className="badge badge-outline-warning">In Review</span>;
    }
  };

  toggleEditMode = (rowId) => {
    this.getServices();
    this.setState((prevState) => {
      const newEditingRows = new Set(prevState.editingRows);
      if (newEditingRows.has(rowId)) {
        newEditingRows.delete(rowId);
      } else {
        newEditingRows.add(rowId);
      }
      return { editingRows: newEditingRows };
    });
  };

  toggleEditModeCustom = (rowId) => {
    const { rows, rows_custom_temp } = this.state;

    const existingTempRow = rows_custom_temp.find(
      (row) => row.temp_id === rowId
    );
    if (!existingTempRow) {
      const rowToEdit = rows.find((row) => row.id === rowId);
      if (rowToEdit) {
        const newTempRow = {
          temp_id: rowId,
          temp_data: {
            temp_inner_id: rowToEdit.data.id,
            temp_inner_sku: rowToEdit.data.sku,
            temp_inner_name: rowToEdit.data.name,
            temp_inner_description: rowToEdit.data.description,
            temp_inner_quantity: rowToEdit.data.quantity,
            temp_inner_unit: rowToEdit.data.unit,
            temp_inner_price: rowToEdit.data.price,
            temp_inner_total: rowToEdit.data.total,
            temp_inner_type: "custom",
          },
        };
        this.setState((prevState) => ({
          rows_custom_temp: [...prevState.rows_custom_temp, newTempRow],
        }));
      }
    }

    // Toggle edit mode
    this.setState((prevState) => {
      const editableRows = new Set(prevState.editableRows);
      if (editableRows.has(rowId)) {
        editableRows.delete(rowId);
      } else {
        editableRows.add(rowId);
      }
      return { editableRows };
    });
  };

  handleEditSection = (rowId) => {
    const row = this.state.rows.find((row) => row.id === rowId);
    this.setState({
      editingSection: rowId,
      select_name: row.data.name,
    });
  };

  updateSection = (rowId) => {
    const { select_name, rows } = this.state;
    if (select_name !== "") {
      const updatedRows = rows.map((row) => {
        if (row.id === rowId) {
          return {
            ...row,
            data: {
              ...row.data,
              name: select_name,
            },
          };
        }
        return row;
      });

      this.setState({
        rows: updatedRows,
        editingSection: null,
        select_name: "",
      });
    }
  };

  showRequirements = (value, tableMeta) => {
    let rfq_accountno = tableMeta.rowData[0];

    let all_data = this.state.tableData;
    let rfq_requirements = "";
    for (let i = 0; i < all_data.length; i++) {
      if (rfq_accountno === all_data[i]["rfq_accountno"]) {
        rfq_requirements = all_data[i]["rfq_comments"];
      }
    }

    window.$("#modalFormOptions").modal("show");
    setTimeout(() => {
      this.setState({
        formLoader: false,
        rfq_requirements: rfq_requirements,
      });
    }, 3000);
  };

  viewQuestionType = (value, tableMeta) => {
    let domain_str = tableMeta.rowData[4];

    if (domain_str === "") {
      return "---";
    } else if (domain_str !== "") {
      return (
        <span className="badge badge-outline-dark">
          <em className="icon ni ni-card-view"></em> View
        </span>
      );
    }
  };

  viewPdf = (value, tableMeta) => {
    let domain_str = value;
    //console.log("domain_str: ", domain_str);
    if (domain_str && domain_str !== "") {
      return (
        <div>
          <a
            onClick={() => this.downloadPdf(value)}
            style={{ cursor: "pointer" }}
            title="Download PDF"
          >
            <span className="badge badge-outline-secondary">
              {" "}
              <em className="icon ni ni-download"></em> View Attachment
            </span>
          </a>
        </div>
      );
    } else {
      return "---";
    }
  };

  downloadPdfRfq = async (d_f_name) => {
    var url = d_f_name;
    let file_name = this.extractFileNameFromUrl(d_f_name);

    fetch(url)
      .then((x) => x.blob())
      .then((b) => {
        // console.log("B INSTANCE", b instanceof Blob);
        const url = window.URL.createObjectURL(b);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = file_name;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        this.setState({
          errorMessage: "There is some error while downloading the attachment.",
        });
        setTimeout(() => {
          this.setState({ errorMessage: "" });
        }, 4000);
        // Handle any errors that occurred during the fetch
        console.error("Fetch error:", error);
      });
  };

  downloadPdfDetails = async (d_f_name) => {
    //var url = d_f_name;
    this.setState({
      quotation_attachement_button: true,
      errorMessageDetails: "",
    });
    if (d_f_name && d_f_name !== "") {
      let file_name = d_f_name;
      var url = APP_LIVE_URL + "files_data/rfq/" + d_f_name;
      fetch(url)
        .then((x) => x.blob())
        .then((b) => {
          // console.log("B INSTANCE", b instanceof Blob);
          const url = window.URL.createObjectURL(b);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = file_name;
          a.click();
          window.URL.revokeObjectURL(url);
          this.setState({ quotation_attachement_button: false });
        })
        .catch((error) => {
          this.setState({
            errorMessageDetails:
              "There is some error while downloading the attachment.",
          });
          setTimeout(() => {
            this.setState({
              errorMessageDetails: "",
              quotation_attachement_button: false,
            });
          }, 4000);
          // Handle any errors that occurred during the fetch
          console.error("Fetch error:", error);
        });
    } else {
      this.setState({
        errorMessageDetails: "Attachement not found.",
        quotation_attachement_button: false,
      });
      setTimeout(() => {
        this.setState({ errorMessageDetails: "" });
      }, 4000);
    }
  };

  extractFileNameFromUrl = (url) => {
    const urlObject = new URL(url);
    const pathname = urlObject.pathname; // Gets the path after the domain
    const fileName = pathname.split("/").pop(); // Extracts the last segment after splitting by '/'
    return fileName;
  };

  deleteQuestions = async (value, tableMeta) => {
    let question_id = tableMeta.rowData[0];
    this.setState({
      errorMessage: "",
      successMessage: "",
      disabled: true,
    });

    const servicesResponce = await deleteQuestions(
      auth.getAccount(),
      auth.getToken(),
      question_id
    );
    //console.log("addRfqQuestion: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      //auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "not_found"
    ) {
      this.setState({
        errorMessage: "The question not found.",
        successMessage: "",
        disabled: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        errorMessage: "",
        successMessage: "Question deleted successfully.",
        disabled: false,
      });
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    } else {
      this.setState({
        errorMessage: "There is some error while deleting the question.",
        successMessage: "",
        disabled: false,
      });
    }

    setTimeout(() => {
      this.setState({ errorMessage: "", successMessage: "" });
    }, 5000);
  };

  deleteOption = async (id, question_id) => {
    this.setState({
      optionErrorMessage: "",
      optionSuccessMessage: "",
      disabled: true,
    });

    const servicesResponce = await deleteAnswerOption(
      auth.getAccount(),
      auth.getToken(),
      id,
      question_id
    );
    //console.log("addRfqQuestion: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      //auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        optionErrorMessage:
          "There is some error while deleting the answer option.",
        optionSuccessMessage: "",
        disabled: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        optionErrorMessage: "",
        optionSuccessMessage: "Answer option deleted successfully.",
        disabled: false,
      });
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    } else {
      this.setState({
        optionErrorMessage:
          "There is some error while adding the answer option.",
        optionSuccessMessage: "",
        disabled: false,
      });
    }

    setTimeout(() => {
      this.setState({ optionErrorMessage: "", optionSuccessMessage: "" });
    }, 5000);
  };

  // Validate numeric input for max digits and safe value
  validateNumericInput = (value, fieldName) => {
    // Remove non-numeric chars except decimal point
    let cleanValue = value.replace(/[^0-9.]/g, "").replace(/^0+(?!\.|$)/, "");
    if (!cleanValue || cleanValue === ".") {
      cleanValue = "0";
    }

    // Check digit count (excluding decimal point)
    const digitsOnly = cleanValue.replace(".", "");
    if (digitsOnly.length > MAX_INPUT_DIGITS) {
      // Truncate to max digits - don't allow more input
      const hasDecimal = cleanValue.includes(".");
      if (hasDecimal) {
        const parts = cleanValue.split(".");
        const maxIntDigits = MAX_INPUT_DIGITS - (parts[1] ? parts[1].length : 0);
        if (maxIntDigits > 0) {
          cleanValue = parts[0].slice(0, maxIntDigits) + "." + (parts[1] || "");
        } else {
          cleanValue = parts[0].slice(0, MAX_INPUT_DIGITS);
        }
      } else {
        cleanValue = cleanValue.slice(0, MAX_INPUT_DIGITS);
      }
      return {
        value: cleanValue,
        error: `Maximum ${MAX_INPUT_DIGITS} digits allowed.`,
        isValid: false
      };
    }

    // Parse and check for Infinity or unsafe values
    const numValue = parseFloat(cleanValue);
    if (!isFinite(numValue)) {
      return {
        value: "0",
        error: "Invalid number. Value is too large or not a valid number.",
        isValid: false
      };
    }

    if (numValue > MAX_SAFE_VALUE) {
      return {
        value: cleanValue,
        error: `Value exceeds maximum safe limit. Please enter a smaller number.`,
        isValid: false
      };
    }

    return {
      value: cleanValue,
      error: "",
      isValid: true
    };
  };

  handleChange = async (event) => {
    const { target } = event;
    let value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    // console.log(name + " - " + value);
    if (name === "discount_value") {
      const validation = this.validateNumericInput(value, name);
      this.setState({
        discount_value: validation.value,
        discount_value_error: validation.error
      });
      return;
    }

    if (name === "shipping_value") {
      const validation = this.validateNumericInput(value, name);
      this.setState({
        shipping_value: validation.value,
        shipping_value_error: validation.error
      });
      return;
    }

    if (name === "tax_value") {
      const validation = this.validateNumericInput(value, name);
      this.setState({
        tax_value: validation.value,
        tax_value_error: validation.error
      });
      return;
    }

    if (name === "payment_terms" && value !== "Other") {
      const newState = { [name]: value, custom_payment_terms: "" };
      const computed = dueDateFromTerm(
        parseDateLocal(this.state.issueDate) || new Date(),
        resolvePaymentTermDays(value, this.state.paymentTermsList)
      );
      if (computed) newState.dueDate = computed;
      this.setState(newState);
      return;
    }

    this.setState({
      [name]: value,
    });
  };

  validateIPAddress = (ipAddress) => {
    const ipRegex = /^(\d{1,3}\.){3}\d{1,3}$/;
    const isValid = ipRegex.test(ipAddress);
    //console.log(`Is IP Address valid? ${isValid}`);
    return isValid;
  };

  validateDomain = (domain) => {
    const domainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isValid = domainRegex.test(domain);
    //console.log(`Is domain valid? ${isValid}`);
    if (isValid) {
      return true;
    }
    return false;
  };

  validateEmailAdd = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = emailRegex.test(email);
    //console.log("isValidEmail: " + " " + email + " = " + isValidEmail);
    if (isValidEmail) {
      return true;
    }
    return false;
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  openServices = () => {
    this.getServices();
    window.$("#modalFormServices").modal("show");
  };

  modalHide = (modalId) => {
    window.$("#" + modalId).modal("hide");
  };

  calculateTotalRate = async () => {
    const { rows, discount_value_total, tax_value_total, shipping_value_total, useDynamicOrderSummary, orderSummarySections, orderSummaryValues, savedOrderSummaryItems } = this.state;

    const useDynamicPath = useDynamicOrderSummary && orderSummarySections && orderSummarySections.length > 0;

    try {
      // Calculate subtotal from rows using Decimal.js
      let total = new Decimal(0);

      if (rows && rows.length > 0) {
        for (let i = 0; i < rows.length; i++) {
          const price = new Decimal(rows[i].data.price || 0);
          const quantity = new Decimal(rows[i].data.quantity || 0);
          total = total.plus(price.times(quantity));
        }
      }

      let with_discount = new Decimal(total);
      let dynamicItems = [];
      let dynamicDiscountTotal = new Decimal(0);
      let dynamicTaxTotal = new Decimal(0);
      let dynamicShippingTotal = new Decimal(0);

      if (useDynamicPath) {
        dynamicItems = this.buildOrderSummaryItems(
          total.toNumber(),
          orderSummarySections,
          orderSummaryValues
        );

        dynamicItems.forEach((item) => {
          const amount = new Decimal(item.applied_amount || 0);
          const operation = String(item.operation || "").toUpperCase();
          if (operation === "ADD") {
            with_discount = with_discount.plus(amount);
          } else {
            with_discount = with_discount.minus(amount);
          }

          const moduleType = String(item.module_type || "").toUpperCase();
          if (moduleType === "DISCOUNT") {
            dynamicDiscountTotal = dynamicDiscountTotal.plus(amount);
          }
          if (moduleType === "TAX") {
            dynamicTaxTotal = dynamicTaxTotal.plus(amount);
          }
          if (moduleType === "SHIPPING") {
            dynamicShippingTotal = dynamicShippingTotal.plus(amount);
          }
        });
      } else {
        // Legacy fallback
        const discount = new Decimal(discount_value_total || 0);
        with_discount = with_discount.minus(discount);

        const tax = new Decimal(tax_value_total || 0);
        with_discount = with_discount.plus(tax);

        const shipping = new Decimal(shipping_value_total || 0);
        with_discount = with_discount.plus(shipping);
      }

      // Check for Infinity or invalid results
      if (!with_discount.isFinite() || !total.isFinite()) {
        console.error("calculateTotalRate: Invalid calculation result");
        this.setState({
          errorMessage: "Calculation error: Result is too large. Please check input values."
        });
        return;
      }

      // Format without scientific notation
      const grandTotal = with_discount.greaterThan(0)
        ? with_discount.toFixed(this.getBillingDecimalPoint())
        : (0).toFixed(this.getBillingDecimalPoint());

      const subTotal = total.greaterThan(0)
        ? total.toFixed(this.getBillingDecimalPoint())
        : (0).toFixed(this.getBillingDecimalPoint());

      this.setState({
        service_grand_total: grandTotal,
        service_grand_sub_total: subTotal,
        ...(useDynamicPath
          ? {
            orderSummaryItems: dynamicItems,
            discount_value_total: dynamicDiscountTotal.toNumber(),
            tax_value_total: dynamicTaxTotal.toNumber(),
            shipping_value_total: dynamicShippingTotal.toNumber(),
          }
          : {
            // When not using dynamic path but editing an existing order with saved items,
            // preserve the orderSummaryItems so they can be displayed
            ...(savedOrderSummaryItems && savedOrderSummaryItems.length > 0
              ? { orderSummaryItems: savedOrderSummaryItems }
              : {}),
          }),
      });
      this.calculateCommission();
    } catch (e) {
      console.error("calculateTotalRate error:", e);
      this.setState({
        errorMessage: "Error calculating totals. Please check your input values."
      });
    }
  };

  // Order Summary Items Methods
  loadOrderSummarySettings = async () => {
    try {
      const resp = await getOrdersSettings(auth.getAccount(), auth.getToken());
      if (resp?.data?.status === 200) {
        const activeSections = (resp.data.order_settings || []).filter(
          (section) => section && section.section_is_active
        );
        const values = { ...this.state.orderSummaryValues };
        activeSections.forEach((section) => {
          if (!values[section.id]) {
            values[section.id] = { value: "", description: "" };
          }
        });

        this.setState(
          {
            orderSummarySections: activeSections,
            orderSummaryValues: values,
            useDynamicOrderSummary: activeSections.length > 0,
          },
          () => {
            const { savedOrderSummaryItems } = this.state;
            if (savedOrderSummaryItems && savedOrderSummaryItems.length > 0) {
              // Existing order — restore previously saved summary items from DB
              this.hydrateFromSavedItems(savedOrderSummaryItems);
            } else {
              // New order — map legacy discount / tax / shipping fields into sections
              this.hydrateDynamicSummaryFromLegacy();
            }
            this.calculateTotalRate();
          }
        );
      }
    } catch (e) {
      console.error("loadOrderSummarySettings error:", e);
    }
  };

  hydrateFromSavedItems = (savedItems) => {
    const { orderSummarySections } = this.state;
    const values = {};

    // Initialize all sections with empty defaults first
    (orderSummarySections || []).forEach((section) => {
      values[section.id] = { value: "", description: "" };
    });

    // Overwrite with saved values from the DB
    (savedItems || []).forEach((item) => {
      values[item.section_id] = {
        value: String(item.value || ""),
        description: item.description || "",
      };
    });

    this.setState({ orderSummaryValues: values }, () => {
      this.calculateTotalRate();
    });
  };

  hydrateDynamicSummaryFromLegacy = () => {
    const {
      orderSummarySections,
      orderSummaryValues,
      discount_type,
      discount_value,
      discount_reason,
      shipping_value,
      shipping_title,
      tax_type,
      tax_value,
      tax_reason,
    } = this.state;

    if (!orderSummarySections || orderSummarySections.length === 0) {
      return;
    }

    const values = { ...orderSummaryValues };
    let changed = false;

    (orderSummarySections || []).forEach((section) => {
      const existing = values[section.id] || { value: "", description: "" };
      const hasValue = existing.value !== "" && parseFloat(existing.value || 0) > 0;
      if (hasValue) {
        return;
      }

      const moduleType = String(section.section_module_type || "").toUpperCase();
      const scope = String(section.section_scope || "").toUpperCase();

      if (
        moduleType === "DISCOUNT" &&
        ((scope === "PERCENTAGE" && discount_type === "percentage") ||
          (scope === "FIXED" && discount_type === "amount")) &&
        parseFloat(discount_value || 0) > 0
      ) {
        values[section.id] = {
          value: String(discount_value),
          description: discount_reason || "",
        };
        changed = true;
      }

      if (
        moduleType === "SHIPPING" &&
        scope === "FIXED" &&
        parseFloat(shipping_value || 0) > 0
      ) {
        values[section.id] = {
          value: String(shipping_value),
          description: shipping_title || "",
        };
        changed = true;
      }

      if (
        moduleType === "TAX" &&
        ((scope === "PERCENTAGE" && tax_type === "percentage") ||
          (scope === "FIXED" && tax_type === "amount")) &&
        parseFloat(tax_value || 0) > 0
      ) {
        values[section.id] = {
          value: String(tax_value),
          description: tax_reason || "",
        };
        changed = true;
      }
    });

    if (changed) {
      this.setState({ orderSummaryValues: values }, () => {
        this.calculateTotalRate();
      });
    }
  };

  buildOrderSummaryItems = (subtotal, sections, values) => {
    const orderedSections = [...(sections || [])];
    let runningTotal = new Decimal(subtotal || 0);
    const items = [];

    // Always use the original subtotal for percentage calculations
    const baseSubtotal = new Decimal(subtotal || 0);

    orderedSections.forEach((section, index) => {
      const rawValue = (values?.[section.id]?.value ?? "").toString().trim();
      const numericValue = parseFloat(rawValue || 0);
      // Always include all sections, even with 0 values

      const scope = String(section.section_scope || "").toUpperCase();
      const operation = String(section.section_type || "").toUpperCase();
      let appliedAmount = new Decimal(0);

      if (scope === "PERCENTAGE") {
        // Use baseSubtotal for all percentage calculations
        appliedAmount = baseSubtotal.times(new Decimal(numericValue).div(100));
      } else {
        appliedAmount = new Decimal(numericValue);
      }

      if (operation === "ADD") {
        runningTotal = runningTotal.plus(appliedAmount);
      } else {
        runningTotal = runningTotal.minus(appliedAmount);
      }

      items.push({
        section_id: section.id,
        section_title: section.section_title,
        module_type: section.section_module_type,
        operation,
        value_type: scope,
        section_order: index,
        value: numericValue,
        description: values?.[section.id]?.description || "",
        applied_amount: appliedAmount.toNumber(),
      });
    });

    return items;
  };

  handleOrderSummaryChange = (sectionId, field, value) => {
    const { orderSummaryValues } = this.state;
    const newValues = {
      ...orderSummaryValues,
      [sectionId]: {
        ...orderSummaryValues[sectionId],
        [field]: value,
      },
    };
    this.setState({ orderSummaryValues: newValues }, () => {
      this.calculateTotalRate();
    });
  };

  handleOrderSummaryValueChange = (sectionId, field, value) => {
    if (field === "value") {
      const validation = this.validateNumericInput(value, `order_summary_${sectionId}`);
      this.setState((prevState) => ({
        orderSummaryModalValues: {
          ...prevState.orderSummaryModalValues,
          [sectionId]: {
            ...(prevState.orderSummaryModalValues[sectionId] || {
              value: "",
              description: "",
            }),
            value: validation.value,
          },
        },
        orderSummaryValueErrors: {
          ...prevState.orderSummaryValueErrors,
          [sectionId]: validation.error,
        },
      }));
      return;
    }

    this.setState((prevState) => ({
      orderSummaryModalValues: {
        ...prevState.orderSummaryModalValues,
        [sectionId]: {
          ...(prevState.orderSummaryModalValues[sectionId] || {
            value: "",
            description: "",
          }),
          description: value,
        },
      },
    }));
  };

  handleOrderSummaryDescriptionChange = (sectionId, description) => {
    this.handleOrderSummaryChange(sectionId, "description", description);
  };

  openOrderSummaryModal = (sectionId) => {
    this.setState((prevState) => ({
      activeOrderSummarySectionId: sectionId || "",
      // Always get fresh values from current orderSummaryValues to avoid stale closures
      orderSummaryModalValues: { ...prevState.orderSummaryValues },
      orderSummaryValueErrors: {},
      orderSummaryModalError: "",
      orderSummaryModalSuccess: "",
    }));
    window.$("#modalOrderSummary").modal("show");
  };

  closeOrderSummaryModal = () => {
    this.setState({
      activeOrderSummarySectionId: "",
      orderSummaryModalError: "",
      orderSummaryModalSuccess: "",
      orderSummaryValueErrors: {},
      orderSummaryModalValues: {}, // Clear modal values when closing
    });
    window.$("#modalOrderSummary").modal("hide");
  };

  hasOrderSummaryApplicableItems = () => {
    const { rows } = this.state;
    return (rows || []).some((row) => {
      const rowType = row?.data?.type || "";
      if (rowType === "section") {
        return false;
      }
      const rowName = (row?.data?.name || "").toString().trim();
      return rowName !== "";
    });
  };

  applyOrderSummaryModal = () => {
    const {
      activeOrderSummarySectionId,
      orderSummaryValueErrors,
      orderSummaryModalValues,
      orderSummaryValues,
    } = this.state;

    if (!this.hasOrderSummaryApplicableItems()) {
      this.setState({
        orderSummaryModalError: "Please select a product first.",
        orderSummaryModalSuccess: "",
      });
      return;
    }

    if (!activeOrderSummarySectionId) {
      this.setState({
        orderSummaryModalError: "Please select a section first.",
        orderSummaryModalSuccess: "",
      });
      return;
    }

    if (orderSummaryValueErrors?.[activeOrderSummarySectionId]) {
      this.setState({
        orderSummaryModalError: "Please fix invalid values before applying.",
        orderSummaryModalSuccess: "",
      });
      return;
    }

    // Create a new array reference to ensure state change is detected
    const mergedValues = {
      ...orderSummaryValues,
      [activeOrderSummarySectionId]: orderSummaryModalValues[activeOrderSummarySectionId]
        ? { ...orderSummaryModalValues[activeOrderSummarySectionId] }
        : { value: "", description: "" },
    };

    this.setState(
      {
        orderSummaryValues: mergedValues,
        orderSummaryModalError: "",
        orderSummaryModalSuccess: "Value applied successfully",
        orderSummaryModalValues: {}, // Clear modal values to prevent stale data on next open
        successMessage: "Value applied successfully",
      },
      () => {
        this.calculateTotalRate();
        setTimeout(() => {
          this.closeOrderSummaryModal();
        }, 2000);
        setTimeout(() => {
          this.setState({ successMessage: "" });
        }, 4000);
      }
    );
  };

  getOrderSummarySignedAmount = (item) => {
    const amount = parseFloat(item?.applied_amount || 0);
    return String(item?.operation || "").toUpperCase() === "ADD" ? amount : -amount;
  };

  hasValidLegacyData = () => {
    const { discount_value_total, shipping_value_total, tax_value_total } = this.state;
    // Always show legacy data sections for consistency
    return true;
  };

  handleChangeServicesCheckbox = (idx) => (e) => {
    const { target } = e;
    const services_rows = [...this.state.services_rows];
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    // console.log("services_rows[idx][value]: ", value);
    // console.log("services_rows[idx][name]: ", name);
    if (services_rows[idx]) {
      services_rows[idx][name] = value;
    } else {
      this.setState((prevState) => {
        const services_rows = [...prevState.services_rows];
        if (services_rows[idx]) {
          services_rows[idx][name] = value;
        }
      });
    }

    this.setState({
      services_rows,
      isBlocking: false,
    });
    if (name === "service_checked") {
      this.calculateTotalRate();
    }
    // console.log("services_rows: ", this.state.services_rows);
    //
  };

  open_discount = () => {
    window.$("#modalFormDiscount").modal("show");
  };

  applyDiscount = async () => {
    const { service_grand_total, service_grand_sub_total, discount_value_error } = this.state;

    // Prevent applying if there's a validation error
    if (discount_value_error) {
      return;
    }

    try {
      const grandTotal = new Decimal(service_grand_total || 0);
      const subTotal = new Decimal(service_grand_sub_total || 0);
      const discountValue = new Decimal(this.state.discount_value || 0);

      let discount_value_total = new Decimal(0);

      if (this.state.discount_type === "amount") {
        discount_value_total = discountValue;
      } else if (this.state.discount_type === "percentage") {
        discount_value_total = new Decimal(this.calculatePercent(
          discountValue.toNumber(),
          subTotal.toNumber()
        ));
      }

      // Check for Infinity or invalid results
      if (!discount_value_total.isFinite()) {
        this.setState({
          discount_value_error: "Calculation resulted in an invalid number. Please use a smaller value."
        });
        return;
      }

      this.setState({
        discount_value_total: discount_value_total.toNumber(),
      });

      setTimeout(() => {
        this.calculateTotalRate();
        window.$("#modalFormDiscount").modal("hide");
      }, 500);
    } catch (e) {
      console.error("applyDiscount error:", e);
      this.setState({
        discount_value_error: "Error calculating discount. Please check your input."
      });
    }
  };

  removeDiscount = async () => {
    this.setState({
      discount_reason: "",
      discount_type: "amount",
      discount_value: 0,
      discount_value_total: 0,
      discount_value_error: "",
    });
    setTimeout(async () => {
      // Your async function here
      await this.applyDiscount();
    }, 500);
  };

  calculatePercent = (percent, num) => {
    try {
      const percentDecimal = new Decimal(percent || 0);
      const numDecimal = new Decimal(num || 0);
      const result = percentDecimal.times(numDecimal.dividedBy(100));
      return result.toFixed(4);
    } catch (e) {
      console.error("calculatePercent error:", e);
      return (0).toFixed(4);
    }
  };

  open_shipping = () => {
    window.$("#modalFormShipping").modal("show");
  };

  applyShipping = async () => {
    const { shipping_value_error } = this.state;

    // Prevent applying if there's a validation error
    if (shipping_value_error) {
      return;
    }

    try {
      const shippingValue = new Decimal(this.state.shipping_value || 0);

      // Check for Infinity or invalid results
      if (!shippingValue.isFinite()) {
        this.setState({
          shipping_value_error: "Invalid shipping value. Please use a smaller number."
        });
        return;
      }

      this.setState({
        shipping_value_total: shippingValue.toNumber(),
      });
      window.$("#modalFormShipping").modal("hide");
      setTimeout(() => {
        this.calculateTotalRate();
      }, 500);
    } catch (e) {
      console.error("applyShipping error:", e);
      this.setState({
        shipping_value_error: "Error calculating shipping. Please check your input."
      });
    }
  };

  removeShipping = async () => {
    this.setState({
      shipping_title: "",
      shipping_value: 0,
      shipping_value_total: 0,
      shipping_value_error: "",
    });
    await this.applyShipping();
  };

  open_tax = async () => {
    window.$("#modalFormTax").modal("show");
  };

  applyTax = async () => {
    const {
      service_grand_sub_total,
      discount_value_total,
      tax_value_error,
    } = this.state;

    // Prevent applying if there's a validation error
    if (tax_value_error) {
      return;
    }

    try {
      const taxValue = new Decimal(this.state.tax_value || 0);
      const subTotal = new Decimal(service_grand_sub_total || 0);
      const discountTotal = new Decimal(discount_value_total || 0);

      let tax_value_total = new Decimal(0);

      if (this.state.tax_type === "amount") {
        tax_value_total = taxValue;
      } else if (this.state.tax_type === "percentage") {
        const discount_difference = subTotal.minus(discountTotal);
        tax_value_total = new Decimal(this.calculatePercent(
          taxValue.toNumber(),
          discount_difference.toNumber()
        ));
      }

      // Check for Infinity or invalid results
      if (!tax_value_total.isFinite()) {
        this.setState({
          tax_value_error: "Calculation resulted in an invalid number. Please use a smaller value."
        });
        return;
      }

      this.setState({
        tax_value_total: tax_value_total.toNumber(),
      });

      setTimeout(() => {
        this.calculateTotalRate();
        window.$("#modalFormTax").modal("hide");
      }, 500);
    } catch (e) {
      console.error("applyTax error:", e);
      this.setState({
        tax_value_error: "Error calculating tax. Please check your input."
      });
    }
  };

  removeTax = async () => {
    this.setState({
      tax_reason: "",
      tax_type: "amount",
      tax_value: 0,
      tax_value_total: 0,
      tax_value_error: "",
    });
    await this.applyTax();
  };

  addRowOld = () => {
    const item = {
      service_id: "",
      service_title: "",
      service_quantity: 1,
      service_unit: "lbs",
      service_price: 0,
      service_sub_total: 0,
    };
    this.setState({
      quotation_services: [...this.state.quotation_services, item],
    });
  };

  handleChangeServices = (idx) => (e) => {
    const { name, value } = e.target;
    const rows = [...this.state.rows];
    const rows_service_temp = [...this.state.rows_service_temp];
    // console.log("services_rows[idx][value]: ", value);
    // console.log("services_rows[idx][name]: ", name);
    // console.log("handleChangeServices rows: ", rows);
    let sub_total = 0;
    if (rows_service_temp) {
      for (let i = 0; i < rows_service_temp.length; i++) {
        // console.log(
        //   "select_service: " + " " + rows_service_temp[i].temp_serv_id
        // );
        if (idx == rows_service_temp[i].temp_serv_id) {
          if (name === "name") {
            rows_service_temp[i].temp_serv_data.temp_serv_inner_name = value;
          }
          if (name === "unit") {
            rows_service_temp[i].temp_serv_data.temp_serv_inner_unit = value;
          }
          if (name === "quantity") {
            rows_service_temp[i].temp_serv_data.temp_serv_inner_quantity =
              value;
            const quantity = parseInt(value) || 0;
            const price =
              parseFloat(
                rows_service_temp[i].temp_serv_data.temp_serv_inner_price
              ) || 0;
            sub_total = price * quantity;
            /*sub_total =
              rows_service_temp[i].temp_serv_data.temp_serv_inner_price *
              parseInt(value);*/
            rows_service_temp[i].temp_serv_data.temp_serv_inner_total = Number(
              sub_total
            ).toFixed(this.getBillingDecimalPoint());
          }

          if (name === "price") {
            rows_service_temp[i].temp_serv_data.temp_serv_inner_price = value;
            const quantity =
              parseInt(
                rows_service_temp[i].temp_serv_data.temp_serv_inner_quantity
              ) || 0;
            const price = parseFloat(value) || 0;
            sub_total = price * quantity;
            /*sub_total =
              rows_service_temp[i].temp_serv_data.temp_serv_inner_quantity *
              parseFloat(value);*/
            rows_service_temp[i].temp_serv_data.temp_serv_inner_total = Number(
              sub_total
            ).toFixed(this.getBillingDecimalPoint());
          }
        }
      }
    } else {
      // console.log("Here1: ");
      this.setState((prevState) => {
        const rows_service_temp = [...prevState.rows_service_temp];
        if (rows_service_temp) {
          rows_service_temp.temp_serv_data[name] = value;
        }
      });
    }
    //Handle Actual Rows
    if (rows) {
      for (let i = 0; i < rows.length; i++) {
        // console.log("select_service: " + " " + rows[i].id);
        if (idx == rows[i].id) {
          if (name === "name") {
            rows[i].data.name = value;
          }
          if (name === "unit") {
            rows[i].data.unit = value;
          }
          if (name === "quantity") {
            rows[i].data.quantity = value;
            const quantity = parseInt(value) || 0;
            const price = parseFloat(rows[i].data.price) || 0;
            sub_total = price * quantity;
            //sub_total = rows[i].data.price * parseInt(value);
            rows[i].data.total = Number(sub_total).toFixed(
              this.getBillingDecimalPoint()
            );
          }

          if (name === "price") {
            rows[i].data.price = value;
            const quantity = parseInt(rows[i].data.quantity) || 0;
            const price = parseFloat(value) || 0;
            sub_total = price * quantity;
            //sub_total = rows[i].data.quantity * parseFloat(value);
            rows[i].data.total = Number(sub_total).toFixed(
              this.getBillingDecimalPoint()
            );
          }
        }
      }
    } else {
      // console.log("Here1: ");
      this.setState((prevState) => {
        const rows = [...prevState.rows];
        if (rows) {
          rows.data[name] = value;
        }
      });
    }

    this.setState({
      rows_service_temp,
      rows,
      isBlocking: false,
    });
    if (name === "quantity" || name === "price") {
      this.calculateTotalRate();
    }
    // console.log("rows_service_temp: ", this.state.rows_service_temp);
    //
  };

  handleChangeServicesOptional = (idx) => (e) => {
    const { name, value } = e.target;
    const rows_optional = [...this.state.rows_optional];

    let sub_total = 0;
    if (rows_optional) {
      for (let i = 0; i < rows_optional.length; i++) {
        // console.log("select_service: " + " " + rows_optional[i].id);
        if (idx == rows_optional[i].id) {
          if (name === "name") {
            rows_optional[i].data.name = value;
          }
          if (name === "unit") {
            rows_optional[i].data.unit = value;
          }
          if (name === "quantity") {
            rows_optional[i].data.quantity = value;
            if (value === "") {
              rows_optional[i].data.quantity = 1;
            }

            sub_total = rows_optional[i].data.price * Number(value);
            rows_optional[i].data.total = Number(sub_total).toFixed(
              this.getBillingDecimalPoint()
            );
          }

          if (name === "price") {
            rows_optional[i].data.price = value;
            sub_total =
              Number(rows_optional[i].data.quantity) * parseFloat(value);
            rows_optional[i].data.total = Number(sub_total).toFixed(
              this.getBillingDecimalPoint()
            );
          }
        }
      }
    } else {
      // console.log("Here1: ");
      this.setState((prevState) => {
        const rows_optional = [...prevState.rows_optional];
        if (rows_optional) {
          rows_optional.data[name] = value;
        }
      });
    }

    this.setState({
      rows_optional,
      isBlocking: false,
    });

    // console.log("services_rows: ", this.state.rows_optional);
    //
  };

  /*addNewService = async (row_id) => {
    const { select_service, rows, rows_service_temp } = this.state;
    console.log("rows_service_temp: ", rows_service_temp);
    if (rows_service_temp) {
      for (let i = 0; i < rows_service_temp.length; i++) {
        if (row_id == rows_service_temp[i].temp_serv_id) {
          this.setState((prevState) => ({
            rows: prevState.rows.filter((row) => row.id !== row_id),
          }));
          let selected_service_row = await this.getServiceWithId(
            rows_service_temp[i].temp_serv_data.temp_serv_inner_id
          );

          const newRow = {
            id: row_id,
            data: {
              id: rows_service_temp[i].temp_serv_data.temp_serv_inner_id,
              sku: selected_service_row[9],
              name: rows_service_temp[i].temp_serv_data.temp_serv_inner_name,
              quantity:
                rows_service_temp[i].temp_serv_data.temp_serv_inner_quantity,
              unit: rows_service_temp[i].temp_serv_data.temp_serv_inner_unit,
              price: selected_service_row[8] && selected_service_row[8] > 0
              ? Number(selected_service_row[8]).toFixed(this.getBillingDecimalPoint())
              : (0).toFixed(this.getBillingDecimalPoint()),
              total: Number(
                selected_service_row[8] *
                  rows_service_temp[i].temp_serv_data.temp_serv_inner_quantity
              ).toFixed(this.getBillingDecimalPoint()),
              type: "service",
            },
          };

          this.setState((prevState) => ({
            rows: [...prevState.rows, newRow],
            select_service: "",
            select_name: "",
          }));
        }
      }
      
      setTimeout(() => {
        this.calculateTotalRate();
      }, 500);
    }
  };*/

  addNewService = async (row_id) => {
    const { rows, rows_service_temp } = this.state;

    // Find the selected row
    const rowToUpdate = rows_service_temp.find(
      (row) => row.temp_serv_id === row_id
    );
    if (!rowToUpdate) return; // Exit if no matching row is found

    const index = rows_service_temp.indexOf(rowToUpdate);
    const selectedServiceId = rowToUpdate.temp_serv_data?.temp_serv_inner_id;

    if (selectedServiceId) {
      const selectedServiceRow = await this.getServiceWithId(selectedServiceId);

      if (selectedServiceRow && selectedServiceRow.length > 0) {
        const qty = rowToUpdate.temp_serv_data.temp_serv_inner_quantity || 1;
        const unit = rowToUpdate.temp_serv_data.temp_serv_inner_unit || "";

        // Remove the old row and replace it with the new data
        this.setState((prevState) => ({
          rows: prevState.rows.map((r) =>
            r.id === row_id
              ? {
                ...r,
                data: {
                  id: selectedServiceRow[0],
                  sku: selectedServiceRow[9] || "",
                  name: rowToUpdate.temp_serv_data.temp_serv_inner_name,
                  quantity: qty,
                  unit: unit,
                  price: Number(selectedServiceRow[8]) || 0,
                  total: Number(selectedServiceRow[8] * qty).toFixed(
                    this.getBillingDecimalPoint()
                  ),
                  type: "service",
                },
              }
              : r
          ),
          savedRows: new Set([...prevState.savedRows, row_id]),
        }));

        setTimeout(() => {
          this.calculateTotalRate();
          if (this.state.discount_type) {
            this.applyDiscount();
          }

          if (this.state.tax_type) {
            this.applyTax();
          }
        }, 500);
      }
    }
  };

  addNewServiceOptional = async (row_id) => {
    const { select_service_optional, rows_optional } = this.state;

    // console.log(
    //   "select_service_optional: ",
    //   select_service_optional + " " + row_id
    // );
    if (select_service_optional !== "") {
      let selected_service_row = await this.getServiceWithId(
        select_service_optional
      );
      // console.log("selected_service_row: ", selected_service_row);
      if (selected_service_row && selected_service_row.length > 0) {
        let qty = 0;
        let unit = "";
        if (rows_optional) {
          for (let i = 0; i < rows_optional.length; i++) {
            if (row_id == rows_optional[i].id) {
              qty = rows_optional[i].data.quantity;
              unit = rows_optional[i].data.unit;
            }
          }
        }

        this.setState((prevState) => ({
          rows_optional: prevState.rows_optional.filter(
            (row) => row.id !== row_id
          ),
        }));
        const newRow = {
          id: row_id,
          data: {
            id: selected_service_row[0],
            sku: selected_service_row[9],
            name: selected_service_row[1],
            quantity: qty,
            unit: unit,
            price: selected_service_row[8],
            total: selected_service_row[8],
            type: "service",
          },
        };

        this.setState((prevState) => ({
          rows_optional: [...prevState.rows_optional, newRow],
          select_service_optional: "",
          select_name: "",
        }));

        /*setTimeout(() => {
          this.calculateTotalRate();
        }, 500);*/
        //window.$("#modalFormServices").modal("hide");
      }
    }
  };

  handleChangeSection = (idx) => (e) => {
    const { name, value } = e.target;
    const rows = [...this.state.rows];

    this.setState({
      select_name: value,
      isBlocking: false,
    });
  };

  handleChangeSectionOptional = (idx) => (e) => {
    const { name, value } = e.target;
    const rows_optional = [...this.state.rows_optional];

    this.setState({
      select_name_optional: value,
      isBlocking: false,
    });
  };

  addNewSection = async (row_id) => {
    const { select_name, rows } = this.state;

    // console.log("select_name: ", select_name + " " + row_id);
    if (select_name !== "") {
      const newRow = {
        id: row_id,
        data: {
          id: "",
          name: select_name,
          quantity: "",
          unit: "",
          price: "",
          total: "",
          type: "section",
        },
      };

      const updatedRows = rows.map((row) => (row.id === row_id ? newRow : row));

      const isRowExists = rows.some((row) => row.id === row_id);
      const finalRows = isRowExists ? updatedRows : [...rows, newRow];

      this.setState((prevState) => ({
        rows: finalRows,
        select_service: "",
        select_name: "",
        savedRows: new Set([...prevState.savedRows, row_id]),
      }));
    }
  };

  addNewSectionOptional = async (row_id) => {
    const { select_name_optional, rows_optional } = this.state;

    // console.log("select_name_optional: ", select_name_optional + " " + row_id);
    if (select_name_optional !== "") {
      this.setState((prevState) => ({
        rows_optional: prevState.rows_optional.filter(
          (row) => row.id !== row_id
        ),
      }));
      const newRow = {
        id: row_id,
        data: {
          id: "",
          name: select_name_optional,
          quantity: "",
          unit: "",
          price: "",
          total: "",
          type: "section",
        },
      };

      this.setState((prevState) => ({
        rows_optional: [...prevState.rows_optional, newRow],
        select_service: "",
        select_name_optional: "",
        savedRowsOptional: new Set([...prevState.savedRowsOptional, row_id]),
      }));
    }
  };

  handleChangeCustom = (idx) => (e) => {
    const { name, value } = e.target;
    const rows_custom_temp = [...this.state.rows_custom_temp];
    const rows = [...this.state.rows];
    // console.log("services_rows[idx][value]: ", value);
    // console.log("services_rows[idx][name]: ", name);
    // console.log("handleChangeCustom rows: ", rows_custom_temp);
    let sub_total = 0;
    if (!rows_custom_temp.find((row) => row.temp_id === idx)) {
      const existingRow = rows.find((row) => row.id === idx);
      if (existingRow) {
        const newTempRow = {
          temp_id: idx,
          temp_data: {
            temp_inner_id: existingRow.data.id,
            temp_inner_sku: existingRow.data.sku,
            temp_inner_name: existingRow.data.name,
            temp_inner_description: existingRow.data.description,
            temp_inner_quantity: existingRow.data.quantity,
            temp_inner_unit: existingRow.data.unit,
            temp_inner_price: existingRow.data.price,
            temp_inner_total: existingRow.data.total,
            temp_inner_type: "custom",
          },
        };
        rows_custom_temp.push(newTempRow);
      }
    }
    if (rows_custom_temp) {
      for (let i = 0; i < rows_custom_temp.length; i++) {
        //console.log("select_service: " + " " + rows_custom_temp[i].id);
        // console.log(
        //   "select_custom_skus idx = temp_id: " +
        //     " " +
        //     idx +
        //     " " +
        //     rows_custom_temp[i].temp_id
        // );
        if (idx == rows_custom_temp[i].temp_id) {
          if (name === "select_custom_id") {
            rows_custom_temp[i].temp_data.temp_inner_id = value;
          }
          if (name === "select_custom_sku") {
            rows_custom_temp[i].temp_data.temp_inner_sku = value;
          }
          if (name === "select_custom_name") {
            rows_custom_temp[i].temp_data.temp_inner_name = value;
          }
          if (name === "select_custom_description") {
            rows_custom_temp[i].temp_data.temp_inner_description = value;
          }
          if (name === "select_custom_unit") {
            rows_custom_temp[i].temp_data.temp_inner_unit = value;
          }
          if (name === "select_custom_quantity") {
            rows_custom_temp[i].temp_data.temp_inner_quantity = value;
            sub_total =
              rows_custom_temp[i].temp_data.temp_inner_price * parseInt(value);
            rows_custom_temp[i].temp_data.temp_inner_total = sub_total;
          }

          if (name === "select_custom_price") {
            rows_custom_temp[i].temp_data.temp_inner_price = value;
            sub_total =
              rows_custom_temp[i].temp_data.temp_inner_quantity *
              parseFloat(value);
            rows_custom_temp[i].temp_data.temp_inner_total = sub_total;
          }
        }
      }
      // console.log("handleChangeCustom rows after: ", rows_custom_temp);
    } else {
      // console.log("Here1: ");
      this.setState((prevState) => {
        const rows_custom_temp = [...prevState.rows_custom_temp];
        if (rows_custom_temp) {
          rows_custom_temp.data[name] = value;
        }
      });
    }

    this.setState({
      rows_custom_temp,
      isBlocking: false,
    });

    if (
      name === "select_custom_quantity" ||
      name === "select_custom_price" ||
      name === "select_custom_sku" ||
      name === "select_custom_description"
    ) {
      if (rows) {
        for (let i = 0; i < rows.length; i++) {
          if (idx == rows[i].id) {
            if (rows[i].data.name !== "") {
              if (name === "select_custom_id") {
                rows[i].data.id = value;
              }
              if (name === "select_custom_name") {
                rows[i].data.name = value;
              }
              if (name === "select_custom_description") {
                rows[i].data.description = value;
              }
              /*if (name === "select_custom_sku") {
                rows[i].data.sku = value;
              }*/
              if (name === "select_custom_unit") {
                rows[i].data.unit = value;
              }
              if (name === "select_custom_quantity") {
                rows[i].data.quantity = value;
                sub_total = rows[i].data.price * parseInt(value);
                rows[i].data.total = sub_total;
              }

              if (name === "select_custom_price") {
                rows[i].data.price = value;
                sub_total = rows[i].data.quantity * parseFloat(value);
                rows[i].data.total = sub_total;
              }
            }
          }
        }
        setTimeout(() => {
          this.calculateTotalRate();
        }, 500);
      }
    }

    // console.log("this.state.rows_custom_temp: ", this.state.rows_custom_temp);
  };

  addNewCustomService = async (row_id) => {
    const { select_name, rows, rows_custom_temp } = this.state;
    const customTempRow = rows_custom_temp.find(
      (row) => row.temp_id === row_id
    );
    if (!customTempRow) {
      console.error("Custom row not found in temporary storage.");
      return;
    }
    // console.log("select_name: ", select_name + " " + row_id);
    if (rows_custom_temp) {
      for (let i = 0; i < rows_custom_temp.length; i++) {
        if (row_id == rows_custom_temp[i].temp_id) {
          const updatedRow = {
            id: row_id,
            data: {
              id: rows_custom_temp[i].temp_data.temp_inner_id,
              sku: rows_custom_temp[i].temp_data.temp_inner_sku,
              name: rows_custom_temp[i].temp_data.temp_inner_name,
              description: rows_custom_temp[i].temp_data.temp_inner_description,
              quantity: rows_custom_temp[i].temp_data.temp_inner_quantity,
              unit: rows_custom_temp[i].temp_data.temp_inner_unit,
              price: Number(rows_custom_temp[i].temp_data.temp_inner_price) || 0,
              total: (
                Number(rows_custom_temp[i].temp_data.temp_inner_quantity) *
                Number(rows_custom_temp[i].temp_data.temp_inner_price)
              ).toFixed(this.getBillingDecimalPoint()),
              type: "custom",
            },
          };

          // Update rows while preserving the original order
          const updatedRows = rows.map((row) =>
            row.id === row_id ? updatedRow : row
          );

          this.setState((prevState) => ({
            rows: updatedRows,
            select_service: "",
            savedRows: new Set([...prevState.savedRows, row_id]),
            editableRows: new Set(
              [...prevState.editableRows].filter((id) => id !== row_id)
            ),
          }));
        }
      }

      // Remove the row from temporary storage
      this.setState((prevState) => ({
        rows_custom_temp: prevState.rows_custom_temp.filter(
          (row) => row.temp_id !== row_id
        ),
      }));

      // Recalculate total rate after a slight delay
      setTimeout(() => {
        this.calculateTotalRate();
        if (this.state.discount_type) {
          this.applyDiscount();
        }

        if (this.state.tax_type) {
          this.applyTax();
        }
      }, 500);
    }
  };

  getServiceWithId = async (select_service) => {
    const { all_services } = this.state;
    // console.log("all_services: ", all_services);
    if (all_services && all_services.length > 0) {
      for (let i = 0; i < all_services.length; i++) {
        // console.log(
        //   "select_service: " + select_service + " " + all_services[i][0]
        // );
        if (select_service == all_services[i][0]) {
          return all_services[i];
        }
      }
    }
  };

  /*handleChangeSearchNew = (selectedOption, { action, row, index }) => {
    const { rows_service_temp } = this.state;
    // Your custom logic here
    console.log("selectedOption:", selectedOption);
    console.log("row:", row);
    //let select_a_service_ = "select_a_service_"+index;

    if (selectedOption) {
      this.setState((prevState) => ({
        select_service: selectedOption.value,
        [`select_a_service_${index}`]: selectedOption,
      }));
      if (rows_service_temp) {
        for (let i = 0; i < rows_service_temp.length; i++) {
          if (row.id == rows_service_temp[i].temp_serv_id) {
            this.setState((prevState) => ({
              rows_service_temp: prevState.rows_service_temp.filter(
                (rows) => rows.temp_serv_id !== row.id
              ),
            }));
            const newRow = {
              temp_serv_id: row.id,
              temp_serv_data: {
                temp_serv_inner_id: selectedOption.value,
                temp_serv_inner_sku:
                  rows_service_temp[i].temp_serv_data.temp_serv_inner_sku,
                temp_serv_inner_name: selectedOption.label,
                temp_serv_inner_quantity:
                  rows_service_temp[i].temp_serv_data.temp_serv_inner_quantity,
                temp_serv_inner_unit:
                  rows_service_temp[i].temp_serv_data.temp_serv_inner_unit,
                temp_serv_inner_price:
                  rows_service_temp[i].temp_serv_data.temp_serv_inner_price,
                temp_serv_inner_total: "",
                temp_serv_inner_type: "service",
              },
            };

            this.setState((prevState) => ({
              rows_service_temp: [...prevState.rows_service_temp, newRow],
            }));
          }
        }
      }
    } else {
      this.setState({ [`select_a_service_${index}`]: null });
    }
  };*/

  handleChangeSearchNew = (selectedOption, { action, row, index }) => {
    const { rows_service_temp, all_services } = this.state;

    if (selectedOption) {
      const selectedService = all_services.find(
        (service) => service[0] === selectedOption.value
      );
      const servicePrice = selectedService ? selectedService[8] : 0;
      const serviceQuantity = row.data.quantity || 1;
      const serviceTotal = servicePrice * serviceQuantity;

      this.setState((prevState) => {
        const updatedRows = prevState.rows.map((r) => {
          if (r.id === row.id) {
            return {
              ...r,
              data: {
                ...r.data,
                price: servicePrice,
                total: Number(serviceTotal).toFixed(
                  this.getBillingDecimalPoint()
                ),
              },
            };
          }
          return r;
        });

        return {
          select_service: selectedOption.value,
          [`select_a_service_${index}`]: selectedOption,
          rows: updatedRows,
        };
      });

      // Update rows_service_temp with the new selection
      if (rows_service_temp) {
        this.setState((prevState) => {
          const filteredRows = prevState.rows_service_temp.filter(
            (rows) => rows.temp_serv_id !== row.id
          );

          const newRow = {
            temp_serv_id: row.id,
            temp_serv_data: {
              temp_serv_inner_id: selectedOption.value,
              temp_serv_inner_sku: selectedService ? selectedService[9] : "",
              temp_serv_inner_name: selectedOption.label,
              temp_serv_inner_quantity: row.data.quantity || 1,
              temp_serv_inner_unit: row.data.unit || "",
              temp_serv_inner_price: servicePrice,
              temp_serv_inner_total: serviceTotal.toFixed(
                this.getBillingDecimalPoint()
              ),
              temp_serv_inner_type: "service",
            },
          };

          return {
            rows_service_temp: [...filteredRows, newRow],
          };
        });
      }
    } else {
      this.setState({ [`select_a_service_${index}`]: null });
      this.setState((prevState) => {
        const filteredRows = prevState.rows_service_temp.filter(
          (rows) => rows.temp_serv_id !== row.id
        );
        return {
          rows_service_temp: filteredRows,
        };
      });
    }
    // Recalculate totals whenever a product is selected or cleared so that
    // the row total (updated above) and the order summary stay in sync.
    setTimeout(() => {
      this.calculateTotalRate();
    }, 0);
  };

  handleChangeSearch = async (changed_value) => {
    // console.log("handleChangeSearch: ", changed_value);
    //console.log("handleChangeSearch idx: ", idx);
    if (changed_value) {
      this.setState((prevState) => ({
        select_service: changed_value.value,
        select_a_service: changed_value,
      }));
    } else {
      this.setState({ select_a_service: null });
    }
  };

  handleChangeSearchOptional = async (changed_value) => {
    // console.log("handleChangeSearchOptional: ", changed_value);
    if (changed_value) {
      this.setState((prevState) => ({
        select_service_optional: changed_value.value,
        select_a_service_optional: changed_value,
      }));
    } else {
      this.setState({ select_a_service_optional: null });
    }
  };

  handleRemoveSpecificRowGeneric = (idx) => () => {
    const quotation_services = [...this.state.quotation_services];
    quotation_services.splice(idx, 1);
    this.setState({ quotation_services });
    setTimeout(() => {
      this.calculateTotalRate();
    }, 500);
  };

  handleInputChange = (index, event) => {
    const { services } = this.state;
    const { name, value } = event.target;

    const updatedServices = services.map((service, i) => {
      if (i === index) {
        return { ...service, [name]: value };
      }
      return service;
    });

    this.setState({ services: updatedServices }, () => {
      this.calculateSubtotal(index);
    });
  };

  calculateSubtotal = (index) => {
    const { services } = this.state;
    const service = services[index];
    const subtotal = service.price * service.quantity;

    const updatedServices = services.map((s, i) => {
      if (i === index) {
        return { ...s, subtotal };
      }
      return s;
    });

    this.setState({ services: updatedServices });
  };

  /***** Drag Drop ****/

  handleDragEnd = (result) => {
    if (!result.destination) return;

    const rows = [...this.state.rows];
    const [reorderedRow] = rows.splice(result.source.index, 1);
    rows.splice(result.destination.index, 0, reorderedRow);

    this.setState({ rows });
  };

  handleDragEndOptional = (result) => {
    if (!result.destination) return;

    const rows_optional = [...this.state.rows_optional];
    const [reorderedRow] = rows_optional.splice(result.source.index, 1);
    rows_optional.splice(result.destination.index, 0, reorderedRow);

    this.setState({ rows_optional });
  };

  addRow = () => {
    this.getServices();
    let id = `row-${Date.now()}`;

    const newRow = {
      id: id,
      data: {
        id: "",
        sku: "",
        name: "",
        quantity: 1,
        unit: "",
        price: 0,
        total: 0,
        type: "service",
      },
    };

    const newRows = {
      temp_serv_id: id,
      temp_serv_data: {
        temp_serv_inner_id: "",
        temp_serv_inner_sku: "",
        temp_serv_inner_name: "",
        temp_serv_inner_quantity: 1,
        temp_serv_inner_unit: "",
        temp_serv_inner_price: 0,
        temp_serv_inner_total: 0,
        temp_serv_inner_type: "service",
      },
    };

    this.setState((prevState) => ({
      rows: [...prevState.rows, newRow],
      rows_service_temp: [...prevState.rows_service_temp, newRows],
      saveButtonEnabled: true,
    }));
    // console.log("addRow rows_service_temp: ", this.state.rows_service_temp);
  };

  addRowOptional = () => {
    this.getServices();
    const newRow = {
      id: `row-${Date.now()}`,
      data: {
        id: "",
        sku: "",
        name: "",
        quantity: 1,
        unit: "",
        price: 0,
        total: 0,
        type: "service",
      },
    };

    this.setState((prevState) => ({
      rows_optional: [...prevState.rows_optional, newRow],
    }));
  };

  addRowSec = () => {
    //this.getServices();
    const newRow = {
      id: `row-${Date.now()}`,
      data: {
        id: "",
        sku: "",
        name: "",
        quantity: 1,
        unit: "",
        price: 0,
        total: 0,
        type: "section",
      },
    };

    this.setState((prevState) => ({
      rows: [...prevState.rows, newRow],
      saveButtonEnabled: true,
    }));
  };

  addRowSecOptional = () => {
    //this.getServices();
    const newRow = {
      id: `row-${Date.now()}`,
      data: {
        id: "",
        sku: "",
        name: "",
        quantity: 1,
        unit: "",
        price: 0,
        total: 0,
        type: "section",
      },
    };

    this.setState((prevState) => ({
      rows_optional: [...prevState.rows_optional, newRow],
    }));
  };

  addRowCustom = () => {
    //this.getServices();
    let id = `row-${Date.now()}`;
    const newRow = {
      temp_id: id,
      temp_data: {
        temp_inner_id: "",
        temp_inner_sku: "",
        temp_inner_name: "",
        temp_inner_quantity: 1,
        temp_inner_unit: "",
        temp_inner_price: 0,
        temp_inner_total: 0,
        temp_inner_type: "custom",
        temp_inner_description: "",
      },
    };

    const newRow2 = {
      id: id,
      data: {
        id: "",
        sku: "",
        name: "",
        quantity: 1,
        unit: "",
        price: 0,
        total: 0,
        type: "custom",
        description: "",
      },
    };

    this.setState((prevState) => ({
      rows_custom_temp: [...prevState.rows_custom_temp, newRow],
      rows: [...prevState.rows, newRow2],
    }));
  };

  removeRow = (id) => {
    const { rows } = this.state;
    const updatedRows = rows.filter((row) => row.id !== id);

    this.setState((prevState) => ({
      rows: prevState.rows.filter((row) => row.id !== id),
      rows_service_temp: prevState.rows_service_temp.filter(
        (row) => row.temp_serv_id !== id
      ),
      [`select_a_service_${this.getRowIndex(id)}`]: null,
      saveButtonEnabled: updatedRows.length > 0,
    }));

    setTimeout(() => {
      this.calculateTotalRate();
      if (this.state.discount_type) {
        this.applyDiscount();
      }

      if (this.state.tax_type) {
        this.applyTax();
      }
    }, 500);
  };

  getRowIndex = (rowId) => {
    const { rows } = this.state;
    return rows.findIndex((row) => row.id === rowId);
  };

  removeRowOptional = (id) => {
    this.setState((prevState) => ({
      rows_optional: prevState.rows_optional.filter((row) => row.id !== id),
    }));
  };

  format_date = (value) => {
    const d = parseDateLocal(value);
    return d ? dateFormat(d, "mm-dd-yyyy") : "---";
  };

  handleEditorChange = (updatedContent) => {
    //console.log('updatedContent: ',updatedContent);
    this.setState({ quote_notes: updatedContent });
  };

  handleEditorChangePayment = (updatedContent) => {
    //console.log('updatedContent: ',updatedContent);
    this.setState({ payment_details: updatedContent });
  };

  close_modal = (modal_id) => {
    window.$("#" + modal_id).modal("hide");
  };

  save_as_draft = async () => {
    const {
      discount_type,
      discount_value,
      discount_value_total,
      discount_reason,
      shipping_title,
      shipping_value,
      shipping_value_total,
      tax_type,
      tax_value,
      tax_value_total,
      tax_reason,
      orderno,
      quote_title,
      quote_notes,
      quotation_notes,
      payment_terms,
      custom_payment_terms,
      currency,
      contact_person,
      contact_email,
      validity,
      rows,
      rows_optional,
      client_accountno,
      service_grand_sub_total,
      service_grand_total,
      order_paid,
      payment_details,
      cp_commission,
      dueDate,
      issueDate,
    } = this.state;
    // console.log("items_list: ", rows);
    const searchParams = new URLSearchParams(window.location.search);
    const orderParam = searchParams.get("order") || "";
    const actualPaymentTerms =
      payment_terms === "Other" ? custom_payment_terms : payment_terms;

    if (payment_terms === "Other" && !custom_payment_terms.trim()) {
      this.setState({
        errorMessage: "Please enter custom terms of payment.",
        draft_button: false,
        disabled: false,
      });
      return;
    }

    const validationError = this.validateAllRowsSaved();
    if (validationError) {
      this.setState({
        errorMessage: validationError,
        draft_button: false,
        disabled: false,
      });
      document
        .getElementById("editQuotations")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      setTimeout(() => {
        this.setState({
          errorMessage: "",
          successMessage: "",
        });
      }, 4000);
      return;
    }
    if (rows && rows.length > 0) {
      this.setState({ draft_button: true, disabled: true });
      const draftParsedDueDate = parseDateLocal(dueDate);
      const draftFormattedDueDate = draftParsedDueDate
        ? `${draftParsedDueDate.getFullYear()}-${String(draftParsedDueDate.getMonth() + 1).padStart(2, "0")}-${String(draftParsedDueDate.getDate()).padStart(2, "0")}`
        : null;
      const draftParsedIssueDate = parseDateLocal(issueDate);
      const draftFormattedIssueDate = draftParsedIssueDate
        ? `${draftParsedIssueDate.getFullYear()}-${String(draftParsedIssueDate.getMonth() + 1).padStart(2, "0")}-${String(draftParsedIssueDate.getDate()).padStart(2, "0")}`
        : null;
      // Build order summary items for payload
      const orderSummaryItemsPayload = this.state.useDynamicOrderSummary
        ? this.buildOrderSummaryItems(
          parseFloat(this.state.service_grand_sub_total || 0),
          this.state.orderSummarySections,
          this.state.orderSummaryValues
        )
        : [];
      const servicesResponce = await saveOrderAsDraft(
        auth.getAccount(),
        auth.getToken(),
        discount_type,
        discount_value,
        discount_value_total,
        discount_reason,
        shipping_title,
        shipping_value,
        shipping_value_total,
        tax_type,
        tax_value,
        tax_value_total,
        tax_reason,
        orderno,
        quote_title,
        quote_notes,
        quotation_notes,
        actualPaymentTerms,
        currency,
        contact_person,
        contact_email,
        validity,
        JSON.stringify(rows),
        client_accountno,
        service_grand_sub_total,
        service_grand_total,
        order_paid,
        payment_details,
        cp_commission,
        dueDate,
        orderParam,
        JSON.stringify(orderSummaryItemsPayload),
        draftFormattedDueDate,
        draftFormattedIssueDate
      );
      //console.log("saveOrderAsDraft: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          errorMessage: "There is some error while saving the order.",
          draft_button: false,
          disabled: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        const newOrderno = servicesResponce.data.orderno;
        this.setState({
          errorMessage: "",
          successMessage:
            "Order saved successfully. The page will automatically refresh in a moment. Thank you for your patience.",
          tableLoader: false,
          draft_button: false,
          disabled: false,
          orderno: newOrderno,
          quote_title: "Order - " + newOrderno,
        });
        setTimeout(() => {
          const pathParts = window.location.pathname.split("/").filter(Boolean);
          if (pathParts.length > 0) {
            pathParts[pathParts.length - 1] = String(newOrderno);
          }
          const updatedPath = "/" + pathParts.join("/");
          window.location.href = updatedPath + "?order=edit";
        }, 3000);
      } else {
        this.setState({
          errorMessage: "There is some error while saving the order.",
          draft_button: false,
          disabled: false,
        });
      }
    } else {
      this.setState({
        errorMessage: "Please add order lines to proceed.",
        draft_button: false,
        disabled: false,
      });
    }
    document
      .getElementById("editQuotations")
      ?.scrollIntoView({ top: 0, behavior: "smooth" });
    setTimeout(() => {
      this.setState({
        errorMessage: "",
        successMessage: "",
      });
    }, 4000);
  };

  send_to_customer = async () => {
    if (this.isSendingToCustomer || this.state.send_client_button) {
      return;
    }

    const {
      discount_type,
      discount_value,
      discount_value_total,
      discount_reason,
      shipping_title,
      shipping_value,
      shipping_value_total,
      tax_type,
      tax_value,
      tax_value_total,
      tax_reason,
      orderno,
      quote_title,
      quote_notes,
      quotation_notes,
      payment_terms,
      custom_payment_terms,
      currency,
      contact_person,
      contact_email,
      validity,
      rows,
      client_accountno,
      service_grand_sub_total,
      service_grand_total,
      order_paid,
      payment_details,
      cp_commission,
      dueDate,
      issueDate,
    } = this.state;
    // console.log("items_list: ", rows);
    const searchParams = new URLSearchParams(window.location.search);
    const orderParam = searchParams.get("order") || "";
    const actualPaymentTerms =
      payment_terms === "Other" ? custom_payment_terms : payment_terms;

    if (payment_terms === "Other" && !custom_payment_terms.trim()) {
      this.setState({
        errorMessage: "Please enter custom terms of payment.",
        send_client_button: false,
        disabled: false,
      });
      window.$("#modalQuotationConfirmation").modal("hide");
      return;
    }

    const validationError = this.validateAllRowsSaved();
    if (validationError) {
      this.setState({
        errorMessage: validationError,
        draft_button: false,
        disabled: false,
      });
      document
        .getElementById("editQuotations")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      window.$("#modalQuotationConfirmation").modal("hide");
      setTimeout(() => {
        this.setState({
          errorMessage: "",
          successMessage: "",
        });
      }, 4000);
      return;
    }
    if (rows && rows.length > 0) {
      this.isSendingToCustomer = true;
      this.setState({ send_client_button: true, disabled: true });
      const sendParsedDueDate = parseDateLocal(dueDate);
      const sendFormattedDueDate = sendParsedDueDate
        ? `${sendParsedDueDate.getFullYear()}-${String(sendParsedDueDate.getMonth() + 1).padStart(2, "0")}-${String(sendParsedDueDate.getDate()).padStart(2, "0")}`
        : null;
      const sendParsedIssueDate = parseDateLocal(issueDate);
      const sendFormattedIssueDate = sendParsedIssueDate
        ? `${sendParsedIssueDate.getFullYear()}-${String(sendParsedIssueDate.getMonth() + 1).padStart(2, "0")}-${String(sendParsedIssueDate.getDate()).padStart(2, "0")}`
        : null;
      try {
        // Build order summary items for payload
        const orderSummaryItemsPayload = this.state.useDynamicOrderSummary
          ? this.buildOrderSummaryItems(
            parseFloat(this.state.service_grand_sub_total || 0),
            this.state.orderSummarySections,
            this.state.orderSummaryValues
          )
          : [];
        const servicesResponce = await saveOrderAndSent(
          auth.getAccount(),
          auth.getToken(),
          discount_type,
          discount_value,
          discount_value_total,
          discount_reason,
          shipping_title,
          shipping_value,
          shipping_value_total,
          tax_type,
          tax_value,
          tax_value_total,
          tax_reason,
          orderno,
          quote_title,
          quote_notes,
          quotation_notes,
          actualPaymentTerms,
          currency,
          contact_person,
          contact_email,
          validity,
          JSON.stringify(rows),
          client_accountno,
          service_grand_sub_total,
          service_grand_total,
          order_paid,
          payment_details,
          cp_commission,
          dueDate,
          orderParam,
          JSON.stringify(orderSummaryItemsPayload),
          sendFormattedDueDate,
          sendFormattedIssueDate
        );
        //console.log("saveOrderAndSent: ", servicesResponce.data);

        if (
          servicesResponce.data.status === 403 ||
          servicesResponce.data.errors === "authentication missing" ||
          servicesResponce.data.errors === "jwt expired"
        ) {
          auth.logout();
        } else if (servicesResponce.data.status === 404) {
          this.setState({
            errorMessage: "There is some error while saving the order.",
            send_client_button: false,
            disabled: false,
          });
        } else if (
          servicesResponce.data.status === 200 &&
          servicesResponce.data.message === "success"
        ) {
          this.setState({
            errorMessage: "",
            successMessage:
              "Order created successfully. The page will automatically refresh in a moment. Thank you for your patience.",
            tableLoader: false,
            send_client_button: false,
            disabled: false,
          });
          setTimeout(() => {
            this.addMenuHistory("/partner_orders");
          }, 4000);
        } else {
          this.setState({
            errorMessage: "There is some error while saving the order.",
            send_client_button: false,
            disabled: false,
          });
        }
      } catch (error) {
        this.setState({
          errorMessage: "There is some error while saving the order.",
          send_client_button: false,
          disabled: false,
        });
      } finally {
        this.isSendingToCustomer = false;
      }
    } else {
      this.setState({
        errorMessage: "Please add order lines to proceed.",
        draft_button: false,
        disabled: false,
      });
    }
    document
      .getElementById("editQuotations")
      ?.scrollIntoView({ top: 0, behavior: "smooth" });
    window.$("#modalQuotationConfirmation").modal("hide");
    setTimeout(() => {
      this.setState({
        errorMessage: "",
        successMessage: "",
      });
    }, 4000);
  };

  edit_quotation_info = async () => {
    const { client_accountno } = this.state;
    let qoutationAgreementsList = [];
    /*const listQuotationResponse = await listQuotationAgreements(
      auth.getAccount(),
      auth.getToken(),
      client_accountno
    );
    if (listQuotationResponse.data.message === "success") {
      qoutationAgreementsList = listQuotationResponse.data.data;
      console.log("quotation_agreements", qoutationAgreementsList);
    }*/
    //Zc5DaPETvz7oXkd
    this.setState({
      quotation_agreements: qoutationAgreementsList,
    });
    window.$("#modalDefaultInfo").modal("show");
  };

  save_quotation_info = async () => {
    const {
      payment_terms,
      custom_payment_terms,
      currency,
      contact_person,
      contact_email,
      validity,
      orderno,
      client_accountno,
      selectedAgreement,
      quote_title,
      dueDate,
      issueDate,
    } = this.state;
    const searchParams = new URLSearchParams(window.location.search);
    const orderParam = searchParams.get("order") || "";

    this.setState({
      errorMessageInfo: "",
      successMessageInfo: "",
      info_button: true,
    });

    const actualPaymentTerms =
      payment_terms === "Other" ? custom_payment_terms : payment_terms;

    if (payment_terms === "Other" && !custom_payment_terms.trim()) {
      this.setState({
        errorMessage: "Please enter custom terms of payment.",
        errorMessageInfo: "Please enter custom terms of payment.",
        info_button: false,
      });
      return;
    }

    const parsedDueDate = parseDateLocal(dueDate);

    if (!parsedDueDate || isNaN(parsedDueDate)) {
      throw new Error("Invalid date provided");
    }
    const formattedDueDate = `${parsedDueDate.getFullYear()}-${(
      parsedDueDate.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${parsedDueDate
        .getDate()
        .toString()
        .padStart(2, "0")}`;

    const parsedIssueDate = parseDateLocal(issueDate);
    const formattedIssueDate = parsedIssueDate
      ? `${parsedIssueDate.getFullYear()}-${String(parsedIssueDate.getMonth() + 1).padStart(2, "0")}-${String(parsedIssueDate.getDate()).padStart(2, "0")}`
      : null;

    const servicesResponce = await saveOrderInformation(
      auth.getAccount(),
      auth.getToken(),
      orderno,
      actualPaymentTerms,
      currency,
      contact_person,
      contact_email,
      validity,
      client_accountno,
      selectedAgreement,
      quote_title,
      dueDate,
      formattedDueDate,
      undefined,
      orderParam,
      formattedIssueDate
    );
    //console.log("payment_terms: ", payment_terms);
    //console.log("save_order_info: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessageInfo: "There is some error while saving the info.",
        info_button: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      const newOrderno = servicesResponce.data.orderno || orderno;
      this.setState({
        errorMessageInfo: "",
        successMessageInfo:
          "Order information has been successfully saved. The page will automatically refresh in a moment. Thank you for your patience.",
        info_button: false,
        orderno: newOrderno,
        quote_title: "Order - " + newOrderno,
      });
      window.$("#modalDefaultInfo").modal("hide");
      setTimeout(() => {
        const pathParts = window.location.pathname.split("/").filter(Boolean);
        if (pathParts.length > 0) {
          pathParts[pathParts.length - 1] = String(newOrderno);
        }
        const updatedPath = "/" + pathParts.join("/");
        window.location.href = updatedPath + "?order=edit";
      }, 3000);
    } else {
      this.setState({
        errorMessageInfo: "There is some error while saving the info.",
        info_button: false,
      });
    }

    setTimeout(() => {
      this.setState({
        errorMessageInfo: "",
        successMessageInfo: "",
      });
    }, 4000);
  };

  downloadPdf = async (d_f_name) => {
    if (d_f_name !== "") {
      this.setState({ download_start: true });
      var url = APP_LIVE_URL + "files_data/rfq/" + d_f_name;
      //console.log("url: ", url);
      let file_name = d_f_name;
      fetch(url)
        .then((x) => x.blob())
        .then((b) => {
          // console.log("B INSTANCE", b instanceof Blob);
          const url = window.URL.createObjectURL(b);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = file_name;
          a.click();
          window.URL.revokeObjectURL(url);
          this.setState({ download_start: false });
        })
        .catch((error) => {
          this.setState({
            convErrorMessage: "There is some error while downloading the PDF.",
          });
          setTimeout(() => {
            this.setState({ convErrorMessage: "", download_start: false });
          }, 4000);
          // Handle any errors that occurred during the fetch
          console.error("Fetch error:", error);
        });
    }
  };

  addToCart = async (service_id) => {
    const { all_services, rows } = this.state;
    this.setState({
      service_already_eists_message: "",
      service_success_message: "",
    });
    // console.log("addToCart service_id: ", service_id);
    //Check if service exists
    let service_exists = false;
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].data.id === service_id) {
        service_exists = true;
      }
    }
    if (service_exists === true) {
      this.setState({
        service_already_eists_message: "Product already exists in our cart.",
      });
      window.$("#modalAlertCart").modal("show");
    } else {
      let selected_service_row = await this.getServiceWithId(service_id);
      if (selected_service_row) {
        const newRow = {
          id: `row-${Date.now()}`,
          data: {
            id: selected_service_row[0],
            name: selected_service_row[1],
            quantity: 1,
            unit: "",
            price: selected_service_row[8],
            total: Number(selected_service_row[8] * 1).toFixed(
              this.getBillingDecimalPoint()
            ),
            type: "service",
          },
        };

        this.setState((prevState) => ({
          rows: [...prevState.rows, newRow],
          service_success_message: "Product successfully added to the cart.",
        }));
        setTimeout(() => {
          this.calculateTotalRate();
        }, 500);
        window.$("#modalAlertCartSuccess").modal("show");
        // console.log("addToCart selected_service_row: ", selected_service_row);
      } else {
        this.setState({
          service_already_eists_message: "Product does not exist.",
        });
        window.$("#modalAlertCart").modal("show");
      }
    }
  };

  addComment = async () => {
    const { quote_comment, quote_accountno, client_accountno } = this.state;
    this.setState({ quote_comment_button: true, convErrorMessage: "" });
    if (quote_comment !== "") {
      const servicesResponce = await saveQuotationComment(
        auth.getAccount(),
        auth.getToken(),
        quote_accountno,
        client_accountno,
        quote_comment
      );
      //console.log("save_quotation_info: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          convErrorMessage: "There is some error while adding the comment.",
          quote_comment_button: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          conversations: servicesResponce.data.conversations,
          convErrorMessage: "",
          quote_comment_button: false,
          quote_comment: "",
        });
      } else {
        this.setState({
          convErrorMessage: "There is some error while adding the comment.",
          quote_comment_button: false,
        });
      }
    } else {
      this.setState({
        convErrorMessage: "Please enter the comment.",
        quote_comment_button: false,
      });
    }

    setTimeout(() => {
      this.setState({
        convErrorMessage: "",
      });
    }, 4000);
  };

  getSingleNote = async (client_accountno, quote_accountno) => {
    const servicesResponce = await getSingleNote(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
      quote_accountno
    );
    //console.log("getSingleNote: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        note: servicesResponce.data.data,
        tableLoader: false,
      });
    } else {
      // window.location.replace("/error");
    }
  };

  addNote = async () => {
    const { quote_note, quote_accountno, client_accountno } = this.state;
    this.setState({ quote_note_button: true, noteErrorMessage: "" });
    if (quote_note !== "") {
      const servicesResponce = await saveQuotationNote(
        auth.getAccount(),
        auth.getToken(),
        quote_accountno,
        client_accountno,
        quote_note
      );
      //console.log("save_quotation_info: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          noteErrorMessage: "There is some error while adding the note.",
          quote_note_button: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          noteErrorMessage: "",
          quote_note_button: false,
          quote_note: "",
          note: servicesResponce.data.notes,
        });
      } else {
        this.setState({
          noteErrorMessage: "There is some error while adding the note.",
          quote_note_button: false,
        });
      }
    } else {
      this.setState({
        noteErrorMessage: "Please enter the note.",
        quote_note_button: false,
      });
    }

    setTimeout(() => {
      this.setState({
        noteErrorMessage: "",
      });
    }, 4000);
  };

  formatAsCurrency = (amount) => {
    //console.log("amount: ", typeof amount);
    let decimal_point = this.getBillingDecimalPoint();

    if (typeof amount === "string") {
      amount = parseFloat(amount);
    }
    return amount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: decimal_point,
      maximumFractionDigits: decimal_point,
    });
  };

  formatAsCurrencySimple = (amount) => {
    //console.log("amount: ", typeof amount);
    let decimal_point = this.getDecimalPoint();

    if (typeof amount === "string") {
      amount = parseFloat(amount);
    }
    return amount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: decimal_point,
      maximumFractionDigits: decimal_point,
    });
  };

  handleConfirmation = () => {
    window.$("#modalQuotationConfirmation").modal("show");
  };

  formatPhoneNumber = (phoneNumber) => {
    const phoneNumberObj = parsePhoneNumberFromString(phoneNumber);
    if (phoneNumberObj) {
      if (phoneNumberObj.country === "US") {
        const nationalNumber = phoneNumberObj
          .formatNational()
          .replace(/\D/g, ""); // e.g. "2123727200"
        const areaCode = nationalNumber.slice(0, 3);
        const firstPart = nationalNumber.slice(3, 6);
        const secondPart = nationalNumber.slice(6);
        return `(${areaCode}) ${firstPart}-${secondPart}`;
      }
      return phoneNumberObj.formatInternational();
    }
    return phoneNumber; // Return original number if parsing fails
  };

  saveAllListItem = async () => {
    const { rows, rows_service_temp, rows_custom_temp } = this.state;
    let updatedRows = [...rows];
    let savedRowIds = new Set([...this.state.savedRows]);
    let promises = [];

    const originalEditingSection = this.state.editingSection;

    for (const row of rows) {
      if (!this.state.savedRows.has(row.id)) {
        if (row.data.type === "service") {
          const serviceTempRow = rows_service_temp.find(
            (temp) => temp.temp_serv_id === row.id
          );

          if (serviceTempRow) {
            const selectedServiceId =
              serviceTempRow.temp_serv_data?.temp_serv_inner_id;

            if (selectedServiceId) {
              const promise = this.getServiceWithId(selectedServiceId).then(
                (selectedServiceRow) => {
                  if (selectedServiceRow && selectedServiceRow.length > 0) {
                    const qty =
                      serviceTempRow.temp_serv_data.temp_serv_inner_quantity ||
                      1;
                    const unit =
                      serviceTempRow.temp_serv_data.temp_serv_inner_unit || "";

                    const rowIndex = updatedRows.findIndex(
                      (r) => r.id === row.id
                    );
                    if (rowIndex !== -1) {
                      updatedRows[rowIndex] = {
                        ...updatedRows[rowIndex],
                        data: {
                          id: selectedServiceRow[0],
                          sku: selectedServiceRow[9] || "",
                          name: serviceTempRow.temp_serv_data
                            .temp_serv_inner_name,
                          quantity: qty,
                          unit: unit,
                          price: selectedServiceRow[8]
                            ? Number(selectedServiceRow[8]).toFixed(
                              this.getDecimalPoint()
                            )
                            : (0).toFixed(this.getDecimalPoint()),
                          total: Number(selectedServiceRow[8] * qty).toFixed(
                            this.getBillingDecimalPoint()
                          ),
                          type: "service",
                        },
                      };
                      savedRowIds.add(row.id);
                    }
                  }
                }
              );

              promises.push(promise);
            }
          }
        } else if (row.data.type === "section") {
          const isNewSection = !row.data.name || row.data.name === "";
          let sectionName = row.data.name || "";
          if (this.state.editingSection === row.id || isNewSection) {
            const sectionInputs = document.querySelectorAll(
              "[name='select_name']"
            );
            for (let input of sectionInputs) {
              if (
                input.closest("tr") &&
                input
                  .closest("tr")
                  .contains(
                    document.querySelector(
                      `[data-rbd-draggable-id="${row.id}-1"]`
                    )
                  )
              ) {
                sectionName = input.value;
                break;
              }
            }
          }

          if (sectionName !== "") {
            const rowIndex = updatedRows.findIndex((r) => r.id === row.id);
            if (rowIndex !== -1) {
              updatedRows[rowIndex] = {
                ...updatedRows[rowIndex],
                data: {
                  id: "",
                  name: sectionName,
                  quantity: "",
                  unit: "",
                  price: "",
                  total: "",
                  type: "section",
                },
              };
              savedRowIds.add(row.id);
            }
          }
        } else if (row.data.type === "custom") {
          const customTempRow = rows_custom_temp.find(
            (temp) => temp.temp_id === row.id
          );

          let customData = {
            id: "",
            sku: "",
            name: "",
            description: "",
            quantity: "1",
            unit: "",
            price: "0",
            total: "0",
            type: "custom",
          };

          if (customTempRow) {
            customData = {
              id: customTempRow.temp_data.temp_inner_id || row.data.id || "",
              sku: customTempRow.temp_data.temp_inner_sku || row.data.sku || "",
              name:
                customTempRow.temp_data.temp_inner_name || row.data.name || "",
              description:
                customTempRow.temp_data.temp_inner_description ||
                row.data.description ||
                "",
              quantity:
                customTempRow.temp_data.temp_inner_quantity ||
                row.data.quantity ||
                "1",
              unit:
                customTempRow.temp_data.temp_inner_unit || row.data.unit || "",
              price:
                customTempRow.temp_data.temp_inner_price ||
                row.data.price ||
                "0",
              type: "custom",
            };
          } else {
            const rowElement = document.querySelector(
              `[data-rbd-draggable-id="${row.id}-1"]`
            );
            if (rowElement) {
              const idInput = rowElement.querySelector(
                '[name="select_custom_id"]'
              );
              const skuInput = rowElement.querySelector(
                '[name="select_custom_sku"]'
              );
              const nameInput = rowElement.querySelector(
                '[name="select_custom_name"]'
              );
              const descInput = rowElement.querySelector(
                '[name="select_custom_description"]'
              );
              const qtyInput = rowElement.querySelector(
                '[name="select_custom_quantity"]'
              );
              const unitInput = rowElement.querySelector(
                '[name="select_custom_unit"]'
              );
              const priceInput = rowElement.querySelector(
                '[name="select_custom_price"]'
              );

              customData = {
                id: idInput ? idInput.value : row.data.id || "",
                sku: skuInput ? skuInput.value : row.data.sku || "",
                name: nameInput ? nameInput.value : row.data.name || "",
                description: descInput
                  ? descInput.value
                  : row.data.description || "",
                quantity: qtyInput ? qtyInput.value : row.data.quantity || "1",
                unit: unitInput ? unitInput.value : row.data.unit || "",
                price: priceInput ? priceInput.value : row.data.price || "0",
                type: "custom",
              };
            }
          }

          const qty = parseFloat(customData.quantity) || 0;
          const price = parseFloat(customData.price) || 0;
          customData.total = (qty * price).toFixed(
            this.getBillingDecimalPoint()
          );

          if (customData.price && parseFloat(customData.price) > 0) {
            customData.price = Number(customData.price).toFixed(
              this.getDecimalPoint()
            );
          } else {
            customData.price = (0).toFixed(this.getDecimalPoint());
          }
          if (customData.name !== "") {
            const rowIndex = updatedRows.findIndex((r) => r.id === row.id);
            if (rowIndex !== -1) {
              updatedRows[rowIndex] = {
                ...updatedRows[rowIndex],
                data: customData,
              };
              savedRowIds.add(row.id);
            }
          }
        }
      }
    }

    await Promise.all(promises);

    this.setState(
      {
        rows: updatedRows,
        savedRows: savedRowIds,
        rows_custom_temp: rows_custom_temp.filter(
          (row) => !savedRowIds.has(row.temp_id)
        ),
        editingRows: new Set(),
        editableRows: new Set(),
        editingSection: null,
      },
      () => {
        this.calculateTotalRate();
        if (this.state.discount_type) {
          this.applyDiscount();
        }
        if (this.state.tax_type) {
          this.applyTax();
        }
      }
    );
  };

  getAvailableServices = (currentRowId) => {
    const { all_services, rows_service_temp } = this.state;
    const selectedServiceIds = rows_service_temp
      .filter((row) => row.temp_serv_id !== currentRowId)
      .map((row) => row.temp_serv_data.temp_serv_inner_id);
    const availableServices = all_services
      .filter((service) => !selectedServiceIds.includes(service[0]))
      .map((service) => ({
        value: service[0],
        label: service[1] || service[0],
      }));

    return availableServices;
  };

  showDetails = async (service_id) => {
    this.setState({
      errorMessage: "",
      successMessage: "",
    });
    const servicesResponce = await getAgentService(
      auth.getAccount(),
      auth.getToken(),
      service_id
    );
    //console.log("getAgentService: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessage: "There is some error while getting the service data.",
        successMessage: "",
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        serviceData: servicesResponce.data.data,
        tableLoader: false,
        tableLoaderListing: false,
        errorMessage: "",
      });
    } else {
      this.setState({
        errorMessage: "There is some error while getting the service data.",
        successMessage: "",
      });
      //window.location.replace("/error");
    }
    window.$("#modalFormDetail").modal("show");
  };

  modalHide = () => {
    window.$("#modalFormDetail").modal("hide");
  };

  formatRate = (rate) => {
    let decimal_point = 2;
    if (
      this.props.quotationSettings[0]?.decimal_point &&
      this.props.quotationSettings[0]?.decimal_point !== ""
    ) {
      decimal_point = this.props.quotationSettings[0]?.decimal_point;
    }
    // Ensure rate is a number
    if (typeof rate !== "number") {
      rate = parseFloat(rate);
    }

    // Handle case where rate is NaN (invalid input)
    if (isNaN(rate)) {
      return "Invalid rate";
    }

    // Handle case where rate is zero
    if (rate === 0) {
      return (0).toFixed(decimal_point);
    }

    // Round the rate to the specified decimal points
    const formattedRate = rate.toFixed(decimal_point);

    return formattedRate;
  };

  downloadDeck = async (d_f_name) => {
    if (d_f_name !== "") {
      var url = ADMIN_URL + "files_data/logos/" + d_f_name;
      const parts = url.split("/");
      let file_name = d_f_name;

      fetch(url)
        .then((x) => x.blob())
        .then((b) => {
          // console.log("B INSTANCE", b instanceof Blob);
          const url = window.URL.createObjectURL(b);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = file_name;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Fetch error:", error);
        });
    }
  };

  stopAndShowBundle = async (bundleId) => {
    window.$("#modalFormDetail").modal("hide");
  };

  render() {
    const fetchToken = async () => {
      try {
        const response = await fetch(
          API_URL + "agents/editor_token_url_agents",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              request_type: "ckeditor-tokenUrl",
              user: auth.getAccount(),
            }),
          }
        );
        const data = await response.json();
        return data.token;
      } catch (error) {
        console.error("Failed to fetch token:", error);
        return null;
      }
    };
    //console.log("getDecimalPoint : ", this.getBillingDecimalPoint());
    return (
      <div className="nk-content " id="editQuotations">
        <div className="container-fluid">
          {/* MSA WARNING  START*/}
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}
          {/* MSA WARNING END */}
          <div className="nk-content-inner">
            <div className="nk-content-body">
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <Breadcrumbs aria-label="breadcrumb">
                      <Link
                        color="inherit"
                        onClick={() => this.addMenuHistory("/")}
                        className=""
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <HomeIcon fontSize="inherit" className="" />
                        Home
                      </Link>

                      <Link
                        color="inherit"
                        onClick={() => this.addMenuHistory("/partner_orders")}
                        className=""
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        Sales Orders
                      </Link>
                      <Typography color="textPrimary" className="">
                        Add New Sales Order
                      </Typography>
                    </Breadcrumbs>
                  </div>
                </div>
              </div>

              <div className="row g-gs">
                {/* Table 5th Col Start */}
                <div className="col-xxl-12">
                  {this.state.errorMessage !== "" ? (
                    <div
                      className="example-alert"
                      style={{ marginBottom: "15px" }}
                    >
                      <div className="alert alert-pro alert-danger">
                        <div className="alert-text">
                          <h4>Error</h4>
                          <p>{this.state.errorMessage}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {this.state.successMessage !== "" ? (
                    <div
                      className="example-alert"
                      style={{ marginBottom: "15px" }}
                    >
                      <div className="alert alert-pro alert-success">
                        <div className="alert-text">
                          <h4>Success</h4>
                          <p>{this.state.successMessage}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <div className="card card-bordered">
                    <div className="card-inner">
                      <div className="invoice">
                        {/*<div className="invoice-action">
                          <a
                            className="btn btn-icon btn-lg btn-white btn-dim btn-outline-primary"
                            href="#"
                            target="_blank"
                          >
                            <em className="icon ni ni-printer-fill"></em>
                          </a>
                        </div>*/}
                        <div className="col-md-12 mb-3">
                          <div className="d-flex justify-content-end">
                            <ul className="nk-block-tools gx-3">
                              {this.state.quote_attachement &&
                                this.state.quote_attachement !== "" ? (
                                <>
                                  <li className="btn-wrap">
                                    <button
                                      onClick={() =>
                                        this.addMenuHistory(
                                          "/ViewSalesOrder/" +
                                          this.state.orderno
                                        )
                                      }
                                      style={{
                                        cursor: "pointer",
                                      }}
                                      className="btn btn-icon btn-xl btn-primary"
                                    >
                                      <em className="icon ni ni-sign-usdc"></em>
                                    </button>
                                    <span className="btn-extext">
                                      View Order
                                    </span>
                                  </li>
                                  <li className="btn-wrap">
                                    {this.state.quotation_attachement_button ===
                                      true ? (
                                      <>
                                        <button
                                          disabled
                                          style={{
                                            cursor: "pointer",
                                            color: "#fff",
                                          }}
                                          className="btn btn-icon btn-xl btn-success"
                                        >
                                          <em className="icon ni ni-file-pdf"></em>
                                        </button>
                                        <span className="btn-extext">
                                          Downloading
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <button
                                          onClick={() =>
                                            this.downloadPdfDetails(
                                              this.state.quote_attachement
                                            )
                                          }
                                          style={{
                                            cursor: "pointer",
                                            color: "#fff",
                                          }}
                                          className="btn btn-icon btn-xl btn-success"
                                        >
                                          <em className="icon ni ni-file-pdf"></em>
                                        </button>
                                        <span className="btn-extext">
                                          Download
                                        </span>
                                      </>
                                    )}
                                  </li>
                                </>
                              ) : null}
                            </ul>
                          </div>
                        </div>
                        <div className="invoice-wrap">
                          <div className="invoice-head">
                            <div className="invoice-contact">
                              <span className="overline-title text-dark">
                                Order For
                              </span>
                              <div className="invoice-contact-info">
                                <h4 className="title text-dark">
                                  {this.state.client_name} -{" "}
                                  {this.state.client_company}
                                </h4>
                                <ul className="list-plain">
                                  {this.state.client_address &&
                                    this.state.client_address !== "" ? (
                                    <li>
                                      <em className="icon ni ni-map-pin-fill"></em>
                                      <span className="text-dark">
                                        {this.state.client_address &&
                                          this.state.client_address !== ""
                                          ? this.state.client_address
                                          : ""}{" "}
                                        {this.state.client_address2 &&
                                          this.state.client_address2 !== ""
                                          ? this.state.client_address2
                                          : ""}
                                        <br />
                                        {this.state.client_city &&
                                          this.state.client_city !== ""
                                          ? this.state.client_city
                                          : ""}{" "}
                                        {this.state.client_state &&
                                          this.state.client_state !== ""
                                          ? this.state.client_state
                                          : ""}{" "}
                                        {this.state.client_zip &&
                                          this.state.client_zip !== ""
                                          ? this.state.client_zip
                                          : ""}{" "}
                                        {this.state.client_country &&
                                          this.state.client_country !== ""
                                          ? this.state.client_country
                                          : ""}
                                      </span>
                                    </li>
                                  ) : null}
                                  <li>
                                    <em className="icon ni ni-call-fill"></em>
                                    <span className="text-dark">
                                      {this.state.client_phone &&
                                        this.state.client_phone !== ""
                                        ? this.formatPhoneNumber(
                                          this.state.client_phone
                                        )
                                        : "---"}
                                    </span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="invoice-desc right_invoice">
                              <h3 className="title">
                                Order{" "}
                                {this.state.quote_status !== "completed" &&
                                  this.state.quote_status !== "cancelled" ? (
                                  <a
                                    onClick={() => this.edit_quotation_info()}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <span className="badge badge-outline-dark">
                                      <em className="icon ni ni-edit"></em>
                                    </span>
                                  </a>
                                ) : null}
                                {this.state.quote_status !== "" &&
                                  this.state.quote_status === "completed" ? (
                                  <span className="badge badge-outline-success">
                                    Completed
                                  </span>
                                ) : null}
                                {this.state.quote_status !== "" &&
                                  this.state.quote_status === "cancelled" ? (
                                  <span className="badge badge-outline-danger">
                                    Cancelled / Rejected
                                  </span>
                                ) : null}
                              </h3>
                              <ul className="list-plain">
                                <li className="invoice-id border-bottom">
                                  <span className="text-dark">Order No</span>:
                                  <span className="text-dark fw-bold">
                                    {this.state.orderno}
                                  </span>
                                </li>
                                <li className="invoice-date border-bottom">
                                  <span className="text-dark">Issue Date</span>:
                                  <span className="text-dark">
                                    {this.format_date(this.state.issueDate)}
                                  </span>
                                </li>
                                <li className="invoice-date border-bottom">
                                  <span className="text-dark">Due Date</span>:
                                  <span className="text-dark">
                                    {this.format_date(this.state.dueDate)}
                                  </span>
                                </li>
                                <li className="invoice-date border-bottom">
                                  <span className="text-dark">From</span>:
                                  <span className="text-dark">
                                    {this.state.reseller_company}
                                  </span>
                                </li>
                                <li className="invoice-date border-bottom">
                                  <span className="text-dark">Company</span>:
                                  <span className="text-dark">
                                    {this.state.client_company}
                                  </span>
                                </li>

                                {this.state.payment_terms !== "" ? (
                                  <li className="invoice-date border-bottom">
                                    <span className="text-dark">
                                      Terms of Payment
                                    </span>
                                    :
                                    <span className="text-dark">
                                      {this.state.payment_terms === "Other"
                                        ? this.state.custom_payment_terms
                                        : this.state.payment_terms}
                                    </span>
                                  </li>
                                ) : null}
                                {this.state.currency !== "" ? (
                                  <li className="invoice-date border-bottom">
                                    <span className="text-dark">Currency</span>:
                                    <span className="text-dark">
                                      {this.state.currency}
                                    </span>
                                  </li>
                                ) : null}
                                {this.state.contact_person !== "" ? (
                                  <li className="invoice-date border-bottom">
                                    <span className="text-dark">
                                      Contact Person{" "}
                                    </span>
                                    :
                                    <span className="text-dark">
                                      {this.state.contact_person}
                                    </span>
                                  </li>
                                ) : null}
                                {this.state.contact_email !== "" ? (
                                  <li className="invoice-date border-bottom">
                                    <span className="text-dark">Email</span>:
                                    <span className="text-dark">
                                      {this.state.contact_email}
                                    </span>
                                  </li>
                                ) : null}

                                {this.state.agreementTitle &&
                                  this.state.agreementTitle !== "" ? (
                                  <li className="invoice-date">
                                    <span className="text-dark">
                                      Order Agreement
                                    </span>
                                    :
                                    <span className="text-dark">
                                      {this.state.agreementTitle}
                                    </span>
                                  </li>
                                ) : null}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <ul className="nav nav-tabs mt-4">
                        <li className="nav-item">
                          <a
                            className="nav-link active"
                            data-toggle="tab"
                            href="#tabItem5"
                          >
                            <em className="icon ni ni-list-ol"></em>
                            <span>Order Lines</span>
                          </a>
                        </li>
                        {/*<li className="nav-item">
                          <a
                            className="nav-link"
                            data-toggle="tab"
                            href="#tabItem6"
                          >
                            <em className="icon ni ni-list-ol"></em>
                            <span>Optional Products</span>
                          </a>
                                </li>*/}
                        <li className="nav-item">
                          <a
                            className="nav-link"
                            data-toggle="tab"
                            href="#tabItem7"
                          >
                            <em className="icon ni ni-info"></em>
                            <span>Other Info</span>
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link"
                            data-toggle="tab"
                            href="#tabItemPayment"
                          //onClick={() => this.getPaymentMethod(this.state.orderno)}
                          >
                            <em className="icon ni ni-sign-usdc"></em>
                            <span>Payments</span>
                          </a>
                        </li>
                      </ul>
                      <div className="tab-content">
                        <div className="tab-pane active" id="tabItem5">
                          <div className="row g-gs">
                            <div className="col-xxl-12 inner_content">
                              <div className="invoice">
                                <div className="invoice-wrap">
                                  <div className="invoice-bills">
                                    <div className=" genericTable">
                                      <DragDropContext
                                        onDragEnd={this.handleDragEnd}
                                      >
                                        <Droppable droppableId="droppable-1">
                                          {(provided) => (
                                            <table
                                              ref={provided.innerRef}
                                              {...provided.droppableProps}
                                              className="table table-striped"
                                            >
                                              <thead>
                                                <tr>
                                                  <th className="w-5">
                                                    <em className="icon ni ni-move"></em>
                                                  </th>
                                                  <th className="w-10">
                                                    ITEM ID
                                                  </th>
                                                  <th className="w-10">SKU</th>
                                                  <th className="w-25">
                                                    PRODUCT NAME
                                                  </th>
                                                  <th className="w-10">QTY</th>
                                                  <th className="w-10">UNIT</th>
                                                  <th className="w-10">
                                                    PRICE($)
                                                  </th>
                                                  <th className="w-10">
                                                    TOTAL($)
                                                  </th>
                                                  <th className="w-10">
                                                    {this.state
                                                      .saveButtonEnabled ? (
                                                      <span
                                                        className="badge badge-outline-success"
                                                        onClick={() =>
                                                          this.saveAllListItem()
                                                        }
                                                        style={{
                                                          cursor: "pointer",
                                                          paddingTop: "3px",
                                                          paddingBottom: "3px",
                                                          paddingLeft: "7px",
                                                          fontSize: "13px",
                                                          fontWeight: "600",
                                                        }}
                                                      >
                                                        <em className="icon ni ni-save"></em>{" "}
                                                        Save All
                                                      </span>
                                                    ) : null}
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {this.state.rows.map(
                                                  (row, index) => (
                                                    <Draggable
                                                      key={row.id}
                                                      draggableId={`${row.id}-1`}
                                                      index={index}
                                                    >
                                                      {(provided) => (
                                                        <tr
                                                          ref={
                                                            provided.innerRef
                                                          }
                                                          {...provided.draggableProps}
                                                          {...provided.dragHandleProps}
                                                        >
                                                          {row.data.type &&
                                                            row.data.type ===
                                                            "service" ? (
                                                            <>
                                                              <td>
                                                                <em className="icon ni ni-move"></em>
                                                              </td>
                                                              <td>
                                                                {row.data.id &&
                                                                  row.data.id !==
                                                                  ""
                                                                  ? row.data.id
                                                                  : "---"}
                                                              </td>
                                                              <td>
                                                                {row.data.sku &&
                                                                  row.data.sku !==
                                                                  ""
                                                                  ? row.data.sku
                                                                  : "---"}
                                                              </td>
                                                              <td>
                                                                {row.data
                                                                  .name !==
                                                                  "" ? (
                                                                  !this.state.editingRows.has(
                                                                    row.id
                                                                  ) ? (
                                                                    <div
                                                                      style={{
                                                                        display:
                                                                          "flex",
                                                                        alignItems:
                                                                          "center",
                                                                      }}
                                                                    >
                                                                      {row.data
                                                                        .id && (
                                                                          <em
                                                                            className="icon-show icon ni ni-info mr-1"
                                                                            style={{
                                                                              cursor:
                                                                                "pointer",
                                                                              fontSize:
                                                                                "1.1rem",
                                                                            }}
                                                                            onClick={() =>
                                                                              this.showDetails(
                                                                                row
                                                                                  .data
                                                                                  .id
                                                                              )
                                                                            }
                                                                          ></em>
                                                                        )}
                                                                      <span>
                                                                        {row
                                                                          .data
                                                                          .name &&
                                                                          row.data
                                                                            .name !==
                                                                          ""
                                                                          ? row
                                                                            .data
                                                                            .name
                                                                          : "---"}
                                                                      </span>
                                                                    </div>
                                                                  ) : (
                                                                    <Select
                                                                      options={this.getAvailableServices(
                                                                        row.id
                                                                      )}
                                                                      name={`select_a_service_${index}`}
                                                                      placeholder="Select product / service"
                                                                      value={
                                                                        this
                                                                          .state[
                                                                        `select_a_service_${index}`
                                                                        ]
                                                                      }
                                                                      autoComplete="off"
                                                                      emptyMessage="Product not found"
                                                                      onChange={(
                                                                        select_a_service,
                                                                        {
                                                                          action,
                                                                        }
                                                                      ) =>
                                                                        this.handleChangeSearchNew(
                                                                          select_a_service,
                                                                          {
                                                                            action,
                                                                            row,
                                                                            index,
                                                                          }
                                                                        )
                                                                      }
                                                                      isClearable
                                                                      isSearchable
                                                                      components={
                                                                        animatedComponents
                                                                      }
                                                                    />
                                                                  )
                                                                ) : (
                                                                  <Select
                                                                    options={this.getAvailableServices(
                                                                      row.id
                                                                    )}
                                                                    name={`select_a_service_${index}`}
                                                                    placeholder="Select product / service"
                                                                    value={
                                                                      this
                                                                        .state[
                                                                      `select_a_service_${index}`
                                                                      ]
                                                                    }
                                                                    autoComplete="off"
                                                                    emptyMessage="Product not found"
                                                                    onChange={(
                                                                      select_a_service,
                                                                      { action }
                                                                    ) =>
                                                                      this.handleChangeSearchNew(
                                                                        select_a_service,
                                                                        {
                                                                          action,
                                                                          row,
                                                                          index,
                                                                        }
                                                                      )
                                                                    }
                                                                    isClearable
                                                                    isSearchable
                                                                    components={
                                                                      animatedComponents
                                                                    }
                                                                  />
                                                                )}
                                                              </td>
                                                              <td>
                                                                <div className="form-control-wrap">
                                                                  <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="quantity"
                                                                    name="quantity"
                                                                    onChange={this.handleChangeServices(
                                                                      row.id
                                                                    )}
                                                                    placeholder=""
                                                                    style={{
                                                                      width:
                                                                        "100px",
                                                                      textAlign:
                                                                        "center",
                                                                    }}
                                                                    defaultValue={
                                                                      row.data
                                                                        .quantity
                                                                    }
                                                                    maxLength={
                                                                      11
                                                                    }
                                                                    onInput={(
                                                                      e
                                                                    ) => {
                                                                      e.target.value =
                                                                        e.target.value.replace(
                                                                          /[^0-9]/gi,
                                                                          ""
                                                                        );
                                                                    }}
                                                                    disabled={
                                                                      !this.state.editingRows.has(
                                                                        row.id
                                                                      ) &&
                                                                      row.data
                                                                        .name !==
                                                                      ""
                                                                    }
                                                                    autoComplete="off"
                                                                    required
                                                                  />
                                                                </div>
                                                              </td>
                                                              <td>
                                                                <div className="form-control-wrap">
                                                                  <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="unit"
                                                                    name="unit"
                                                                    onChange={this.handleChangeServices(
                                                                      row.id
                                                                    )}
                                                                    placeholder=""
                                                                    style={{
                                                                      width:
                                                                        "100px",
                                                                      textAlign:
                                                                        "center",
                                                                    }}
                                                                    defaultValue={
                                                                      row.data
                                                                        .unit
                                                                    }
                                                                    maxLength={
                                                                      20
                                                                    }
                                                                    onInput={(
                                                                      e
                                                                    ) => {
                                                                      e.target.value =
                                                                        e.target.value.replace(
                                                                          /[^a-zA-Z0-9 ]/gi,
                                                                          ""
                                                                        );
                                                                    }}
                                                                    disabled={
                                                                      !this.state.editingRows.has(
                                                                        row.id
                                                                      ) &&
                                                                      row.data
                                                                        .name !==
                                                                      ""
                                                                    }
                                                                    autoComplete="off"
                                                                    required
                                                                  />
                                                                </div>
                                                              </td>
                                                              <td>
                                                                <div className="form-control-wrap">
                                                                  <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="price"
                                                                    name="price"
                                                                    onChange={this.handleChangeServices(
                                                                      row.id
                                                                    )}
                                                                    placeholder=""
                                                                    style={{
                                                                      width:
                                                                        "100px",
                                                                      textAlign:
                                                                        "center",
                                                                    }}
                                                                    value={parseFloat(
                                                                      row.data
                                                                        .price
                                                                    ).toFixed(
                                                                      this.getDecimalPoint()
                                                                    )}
                                                                    maxLength={
                                                                      10
                                                                    }
                                                                    onInput={(
                                                                      e
                                                                    ) => {
                                                                      e.target.value =
                                                                        e.target.value.replace(
                                                                          /[^0-9.]/gi,
                                                                          ""
                                                                        );
                                                                    }}
                                                                    autoComplete="off"
                                                                    readOnly
                                                                    required
                                                                  />
                                                                </div>
                                                              </td>
                                                              <td>
                                                                {this.formatAsCurrency(
                                                                  Number(
                                                                    row.data
                                                                      .total
                                                                  )
                                                                )}
                                                              </td>
                                                              <td
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  justifyContent:
                                                                    "end",
                                                                }}
                                                              >
                                                                {/* Save button only for new entries */}
                                                                {row.data
                                                                  .name ===
                                                                  "" &&
                                                                  !this.state.editingRows.has(
                                                                    row.id
                                                                  ) ? (
                                                                  <span
                                                                    className="badge badge-outline-primary mr-1"
                                                                    onClick={() =>
                                                                      this.addNewService(
                                                                        row.id
                                                                      )
                                                                    }
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                      paddingTop:
                                                                        "3px",
                                                                      paddingBottom:
                                                                        "3px",
                                                                      paddingLeft:
                                                                        "7px",
                                                                      fontSize:
                                                                        "18px",
                                                                    }}
                                                                  >
                                                                    <em className="icon ni ni-save"></em>
                                                                  </span>
                                                                ) : null}
                                                                {/* Edit button for saved entries that aren't being edited */}
                                                                {row.data
                                                                  .name !==
                                                                  "" &&
                                                                  !this.state.editingRows.has(
                                                                    row.id
                                                                  ) ? (
                                                                  <span
                                                                    className="badge badge-outline-dark mr-1"
                                                                    onClick={() =>
                                                                      this.toggleEditMode(
                                                                        row.id
                                                                      )
                                                                    }
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                      paddingTop:
                                                                        "3px",
                                                                      paddingBottom:
                                                                        "3px",
                                                                      paddingLeft:
                                                                        "7px",
                                                                      fontSize:
                                                                        "18px",
                                                                    }}
                                                                  >
                                                                    <em className="icon ni ni-edit"></em>
                                                                  </span>
                                                                ) : null}
                                                                {/* Save button for entries being edited */}
                                                                {this.state.editingRows.has(
                                                                  row.id
                                                                ) ? (
                                                                  <span
                                                                    className="badge badge-outline-primary mr-1"
                                                                    onClick={() => {
                                                                      this.addNewService(
                                                                        row.id
                                                                      );
                                                                      this.toggleEditMode(
                                                                        row.id
                                                                      );
                                                                    }}
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                      paddingTop:
                                                                        "3px",
                                                                      paddingBottom:
                                                                        "3px",
                                                                      paddingLeft:
                                                                        "7px",
                                                                      fontSize:
                                                                        "18px",
                                                                    }}
                                                                  >
                                                                    <em className="icon ni ni-save"></em>
                                                                  </span>
                                                                ) : null}
                                                                {/* Delete button */}
                                                                {this.state
                                                                  .quote_status !==
                                                                  "completed" &&
                                                                  this.state
                                                                    .quote_status !==
                                                                  "cancelled" ? (
                                                                  <span
                                                                    className="badge badge-outline-danger"
                                                                    onClick={() =>
                                                                      this.removeRow(
                                                                        row.id
                                                                      )
                                                                    }
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                      paddingTop:
                                                                        "3px",
                                                                      paddingBottom:
                                                                        "3px",
                                                                      paddingLeft:
                                                                        "7px",
                                                                      fontSize:
                                                                        "18px",
                                                                    }}
                                                                  >
                                                                    <em className="icon ni ni-trash"></em>
                                                                  </span>
                                                                ) : null}
                                                              </td>
                                                            </>
                                                          ) : row.data.type ===
                                                            "section" ? (
                                                            <>
                                                              <td>
                                                                <em className="icon ni ni-move"></em>
                                                              </td>
                                                              <td colSpan={7}>
                                                                {row.data
                                                                  .name &&
                                                                  row.data
                                                                    .name !==
                                                                  "" &&
                                                                  this.state
                                                                    .editingSection !==
                                                                  row.id ? (
                                                                  <div className="d-flex align-items-center">
                                                                    <span>
                                                                      {
                                                                        row.data
                                                                          .name
                                                                      }
                                                                    </span>
                                                                  </div>
                                                                ) : (
                                                                  <div className="form-control-wrap">
                                                                    <input
                                                                      type="text"
                                                                      className="form-control"
                                                                      id="select_name"
                                                                      name="select_name"
                                                                      onChange={this.handleChangeSection(
                                                                        row.id
                                                                      )}
                                                                      placeholder=""
                                                                      autoComplete="off"
                                                                      defaultValue={
                                                                        row.data
                                                                          .name
                                                                      }
                                                                      maxLength={
                                                                        100
                                                                      }
                                                                      required
                                                                    />
                                                                  </div>
                                                                )}
                                                              </td>

                                                              <td
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  justifyContent:
                                                                    "end",
                                                                }}
                                                              >
                                                                {row.data
                                                                  .name &&
                                                                  row.data
                                                                    .name !==
                                                                  "" &&
                                                                  this.state
                                                                    .editingSection !==
                                                                  row.id ? (
                                                                  <span
                                                                    className="badge badge-outline-dark mr-1"
                                                                    onClick={() =>
                                                                      this.handleEditSection(
                                                                        row.id
                                                                      )
                                                                    }
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                      paddingTop:
                                                                        "3px",
                                                                      paddingBottom:
                                                                        "3px",
                                                                      paddingLeft:
                                                                        "7px",
                                                                      fontSize:
                                                                        "18px",
                                                                    }}
                                                                  >
                                                                    <em className="icon ni ni-edit"></em>
                                                                  </span>
                                                                ) : (
                                                                  <span
                                                                    className="badge badge-outline-primary mr-1"
                                                                    onClick={() =>
                                                                      this.state
                                                                        .editingSection
                                                                        ? this.updateSection(
                                                                          row.id
                                                                        )
                                                                        : this.addNewSection(
                                                                          row.id
                                                                        )
                                                                    }
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                      padding:
                                                                        "3px 7px",
                                                                      fontSize:
                                                                        "18px",
                                                                    }}
                                                                  >
                                                                    <em className="icon ni ni-save"></em>
                                                                  </span>
                                                                )}
                                                                {this.state
                                                                  .quote_status !==
                                                                  "completed" &&
                                                                  this.state
                                                                    .quote_status !==
                                                                  "cancelled" && (
                                                                    <span
                                                                      className="badge badge-outline-danger"
                                                                      onClick={() =>
                                                                        this.removeRow(
                                                                          row.id
                                                                        )
                                                                      }
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                        padding:
                                                                          "3px 7px",
                                                                        fontSize:
                                                                          "18px",
                                                                      }}
                                                                    >
                                                                      <em className="icon ni ni-trash"></em>
                                                                    </span>
                                                                  )}
                                                              </td>
                                                            </>
                                                          ) : row.data.type ===
                                                            "custom" ? (
                                                            <>
                                                              <td>
                                                                <em className="icon ni ni-move"></em>
                                                              </td>
                                                              <td>
                                                                {row.data.id &&
                                                                  row.data.id !==
                                                                  "" ? (
                                                                  row.data.id
                                                                ) : (
                                                                  <div className="form-control-wrap">
                                                                    <input
                                                                      type="text"
                                                                      className="form-control"
                                                                      id="select_custom_id"
                                                                      name="select_custom_id"
                                                                      onChange={this.handleChangeCustom(
                                                                        row.id
                                                                      )}
                                                                      placeholder=""
                                                                      autoComplete={
                                                                        false
                                                                      }
                                                                      defaultValue={
                                                                        row.data
                                                                          .id
                                                                      }
                                                                      onInput={(
                                                                        e
                                                                      ) => {
                                                                        e.target.value =
                                                                          e.target.value.replace(
                                                                            /[^0-9]/gi,
                                                                            ""
                                                                          );
                                                                      }}
                                                                      maxLength={
                                                                        7
                                                                      }
                                                                      style={{
                                                                        width:
                                                                          "120px",
                                                                        textAlign:
                                                                          "center",
                                                                      }}
                                                                      required
                                                                    />
                                                                  </div>
                                                                )}
                                                              </td>
                                                              <td>
                                                                {row.data
                                                                  .sku !== "" &&
                                                                  !this.state.editableRows.has(
                                                                    row.id
                                                                  ) ? (
                                                                  row.data
                                                                    .sku ||
                                                                  "---"
                                                                ) : (
                                                                  <div className="form-control-wrap">
                                                                    <input
                                                                      type="text"
                                                                      className="form-control"
                                                                      id="select_custom_sku"
                                                                      name="select_custom_sku"
                                                                      onChange={this.handleChangeCustom(
                                                                        row.id
                                                                      )}
                                                                      placeholder=""
                                                                      autoComplete={
                                                                        false
                                                                      }
                                                                      value={
                                                                        this.state.rows_custom_temp.find(
                                                                          (r) =>
                                                                            r.temp_id ===
                                                                            row.id
                                                                        )
                                                                          ?.temp_data
                                                                          .temp_inner_sku ||
                                                                        ""
                                                                      }
                                                                      maxLength={
                                                                        25
                                                                      }
                                                                      style={{
                                                                        width:
                                                                          "120px",
                                                                        textAlign:
                                                                          "center",
                                                                      }}
                                                                      required
                                                                    />
                                                                  </div>
                                                                )}
                                                              </td>
                                                              <td>
                                                                {row.data
                                                                  .name !==
                                                                  "" &&
                                                                  !this.state.editableRows.has(
                                                                    row.id
                                                                  ) ? (
                                                                  row.data
                                                                    .name ||
                                                                  "---"
                                                                ) : (
                                                                  <div className="form-control-wrap mb-2">
                                                                    <input
                                                                      type="text"
                                                                      className="form-control"
                                                                      id="select_custom_name"
                                                                      name="select_custom_name"
                                                                      onChange={this.handleChangeCustom(
                                                                        row.id
                                                                      )}
                                                                      placeholder=""
                                                                      autoComplete={
                                                                        false
                                                                      }
                                                                      value={
                                                                        this.state.rows_custom_temp.find(
                                                                          (r) =>
                                                                            r.temp_id ===
                                                                            row.id
                                                                        )
                                                                          ?.temp_data
                                                                          .temp_inner_name ||
                                                                        ""
                                                                      }
                                                                      maxLength={
                                                                        100
                                                                      }
                                                                      required
                                                                    />
                                                                  </div>
                                                                )}
                                                                {(!row.data
                                                                  .name ||
                                                                  this.state.editableRows.has(
                                                                    row.id
                                                                  ) ||
                                                                  row.data
                                                                    .description) && (
                                                                    <>
                                                                      {row.data
                                                                        .description !==
                                                                        "" &&
                                                                        !this.state.editableRows.has(
                                                                          row.id
                                                                        ) ? (
                                                                        <div className="text-muted small"
                                                                          style={{
                                                                            whiteSpace: "pre-wrap",
                                                                            overflowWrap: "anywhere",
                                                                            wordBreak: "break-word",
                                                                          }}
                                                                        >
                                                                          {
                                                                            row
                                                                              .data
                                                                              .description
                                                                          }
                                                                        </div>
                                                                      ) : (
                                                                        <div
                                                                          className="form-control-wrap"
                                                                          style={{
                                                                            width:
                                                                              "100%",
                                                                          }}
                                                                        >
                                                                          <textarea
                                                                            className="form-control"
                                                                            id="select_custom_description"
                                                                            name="select_custom_description"
                                                                            onChange={this.handleChangeCustom(
                                                                              row.id
                                                                            )}
                                                                            placeholder="Enter description"
                                                                            autoComplete="off"
                                                                            value={
                                                                              this.state.rows_custom_temp.find(
                                                                                (
                                                                                  r
                                                                                ) =>
                                                                                  r.temp_id ===
                                                                                  row.id
                                                                              )
                                                                                ?.temp_data
                                                                                .temp_inner_description ||
                                                                              ""
                                                                            }
                                                                            maxLength={
                                                                              2000
                                                                            }
                                                                            style={{
                                                                              width:
                                                                                "100%",
                                                                              height:
                                                                                "80px",
                                                                              resize:
                                                                                "none",
                                                                              overflow:
                                                                                "hidden",
                                                                              lineHeight:
                                                                                "1.5",
                                                                              padding:
                                                                                "0.375rem 0.75rem",
                                                                              fontSize:
                                                                                "0.8rem",
                                                                              border:
                                                                                "1px solid #ced4da",
                                                                              borderRadius:
                                                                                "0.25rem",
                                                                              minHeight:
                                                                                "38px",
                                                                            }}
                                                                            rows={
                                                                              1
                                                                            }
                                                                            onFocus={(
                                                                              e
                                                                            ) => {
                                                                              e.target.style.height =
                                                                                "80px";
                                                                              e.target.style.height = `${e.target.scrollHeight}px`;
                                                                            }}
                                                                            onBlur={(
                                                                              e
                                                                            ) => {
                                                                              if (
                                                                                !e
                                                                                  .target
                                                                                  .value
                                                                              ) {
                                                                                e.target.style.height =
                                                                                  "80px";
                                                                              }
                                                                            }}
                                                                            onInput={(
                                                                              e
                                                                            ) => {
                                                                              e.target.style.height =
                                                                                "80px";
                                                                              e.target.style.height = `${e.target.scrollHeight}px`;
                                                                            }}
                                                                            required
                                                                          />
                                                                        </div>
                                                                      )}
                                                                    </>
                                                                  )}
                                                              </td>
                                                              <td>
                                                                <div className="form-control-wrap">
                                                                  <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="select_custom_quantity"
                                                                    name="select_custom_quantity"
                                                                    onChange={this.handleChangeCustom(
                                                                      row.id
                                                                    )}
                                                                    placeholder=""
                                                                    style={{
                                                                      width:
                                                                        "100px",
                                                                      textAlign:
                                                                        "center",
                                                                    }}
                                                                    defaultValue={
                                                                      row.data
                                                                        .quantity
                                                                    }
                                                                    maxLength={
                                                                      11
                                                                    }
                                                                    onInput={(
                                                                      e
                                                                    ) => {
                                                                      e.target.value =
                                                                        e.target.value.replace(
                                                                          /[^0-9]/gi,
                                                                          ""
                                                                        );
                                                                    }}
                                                                    disabled={
                                                                      !this.state.editableRows.has(
                                                                        row.id
                                                                      ) &&
                                                                      row.data
                                                                        .name !==
                                                                      ""
                                                                    }
                                                                    autoComplete="off"
                                                                    required
                                                                  />
                                                                </div>
                                                              </td>
                                                              <td>
                                                                <div className="form-control-wrap">
                                                                  <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="select_custom_unit"
                                                                    name="select_custom_unit"
                                                                    onChange={this.handleChangeCustom(
                                                                      row.id
                                                                    )}
                                                                    placeholder=""
                                                                    style={{
                                                                      width:
                                                                        "100px",
                                                                      textAlign:
                                                                        "center",
                                                                    }}
                                                                    defaultValue={
                                                                      row.data
                                                                        .unit
                                                                    }
                                                                    maxLength={
                                                                      20
                                                                    }
                                                                    onInput={(
                                                                      e
                                                                    ) => {
                                                                      e.target.value =
                                                                        e.target.value.replace(
                                                                          /[^a-zA-Z0-9 ]/gi,
                                                                          ""
                                                                        );
                                                                    }}
                                                                    disabled={
                                                                      !this.state.editableRows.has(
                                                                        row.id
                                                                      ) &&
                                                                      row.data
                                                                        .name !==
                                                                      ""
                                                                    }
                                                                    autoComplete="off"
                                                                    required
                                                                  />
                                                                </div>
                                                              </td>
                                                              <td>
                                                                <div className="form-control-wrap">
                                                                  <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="select_custom_price"
                                                                    name="select_custom_price"
                                                                    onChange={this.handleChangeCustom(
                                                                      row.id
                                                                    )}
                                                                    placeholder=""
                                                                    style={{
                                                                      width:
                                                                        "100px",
                                                                      textAlign:
                                                                        "center",
                                                                    }}
                                                                    defaultValue={Number(
                                                                      row.data
                                                                        .price
                                                                    ).toFixed(
                                                                      this.getDecimalPoint()
                                                                    )}
                                                                    maxLength={
                                                                      10
                                                                    }
                                                                    onInput={(
                                                                      e
                                                                    ) => {
                                                                      e.target.value =
                                                                        e.target.value.replace(
                                                                          /[^0-9.]/gi,
                                                                          ""
                                                                        );
                                                                    }}
                                                                    disabled={
                                                                      !this.state.editableRows.has(
                                                                        row.id
                                                                      ) &&
                                                                      row.data
                                                                        .name !==
                                                                      ""
                                                                    }
                                                                    autoComplete="off"
                                                                    required
                                                                  />
                                                                </div>
                                                              </td>
                                                              <td>
                                                                {this.formatAsCurrency(
                                                                  Number(
                                                                    row.data
                                                                      .total
                                                                  )
                                                                )}
                                                              </td>
                                                              <td
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  justifyContent:
                                                                    "end",
                                                                }}
                                                              >
                                                                {row.data
                                                                  .name !==
                                                                  "" ? (
                                                                  <>
                                                                    {this.state.editableRows.has(
                                                                      row.id
                                                                    ) ? (
                                                                      <span
                                                                        className="badge badge-outline-primary mr-1"
                                                                        onClick={() =>
                                                                          this.addNewCustomService(
                                                                            row.id
                                                                          )
                                                                        }
                                                                        style={{
                                                                          cursor:
                                                                            "pointer",
                                                                          paddingTop:
                                                                            "3px",
                                                                          paddingBottom:
                                                                            "3px",
                                                                          paddingLeft:
                                                                            "7px",
                                                                          fontSize:
                                                                            "18px",
                                                                        }}
                                                                      >
                                                                        <em className="icon ni ni-save"></em>
                                                                      </span>
                                                                    ) : (
                                                                      <span
                                                                        className="badge badge-outline-dark mr-1"
                                                                        onClick={() =>
                                                                          this.toggleEditModeCustom(
                                                                            row.id
                                                                          )
                                                                        }
                                                                        style={{
                                                                          cursor:
                                                                            "pointer",
                                                                          paddingTop:
                                                                            "3px",
                                                                          paddingBottom:
                                                                            "3px",
                                                                          paddingLeft:
                                                                            "7px",
                                                                          fontSize:
                                                                            "18px",
                                                                        }}
                                                                      >
                                                                        <em className="icon ni ni-edit"></em>
                                                                      </span>
                                                                    )}
                                                                  </>
                                                                ) : (
                                                                  <span
                                                                    className="badge badge-outline-primary mr-1"
                                                                    onClick={() =>
                                                                      this.addNewCustomService(
                                                                        row.id
                                                                      )
                                                                    }
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                      paddingTop:
                                                                        "3px",
                                                                      paddingBottom:
                                                                        "3px",
                                                                      paddingLeft:
                                                                        "7px",
                                                                      fontSize:
                                                                        "18px",
                                                                    }}
                                                                  >
                                                                    <em className="icon ni ni-save"></em>
                                                                  </span>
                                                                )}
                                                                {this.state
                                                                  .quote_status !==
                                                                  "completed" &&
                                                                  this.state
                                                                    .quote_status !==
                                                                  "cancelled" ? (
                                                                  <span
                                                                    className="badge badge-outline-danger"
                                                                    onClick={() =>
                                                                      this.removeRow(
                                                                        row.id
                                                                      )
                                                                    }
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                      paddingTop:
                                                                        "3px",
                                                                      paddingBottom:
                                                                        "3px",
                                                                      paddingLeft:
                                                                        "7px",
                                                                      fontSize:
                                                                        "18px",
                                                                    }}
                                                                  >
                                                                    <em className="icon ni ni-trash"></em>
                                                                  </span>
                                                                ) : null}
                                                              </td>
                                                            </>
                                                          ) : null}
                                                        </tr>
                                                      )}
                                                    </Draggable>
                                                  )
                                                )}
                                              </tbody>
                                              <tfoot>
                                                <tr>
                                                  <td colSpan="6"></td>
                                                  <td colSpan="2">Subtotal</td>
                                                  <td>
                                                    {this.formatAsCurrency(
                                                      Number(
                                                        this.state
                                                          .service_grand_sub_total
                                                      )
                                                    )}
                                                  </td>
                                                </tr>
                                                {this.state.useDynamicOrderSummary &&
                                                  this.state.orderSummarySections &&
                                                  this.state.orderSummarySections.length > 0 ? (
                                                  <>
                                                    {this.state.orderSummarySections.map((section) => {
                                                      const sectionItem =
                                                        (this.state.orderSummaryItems || []).find(
                                                          (item) => item.section_id === section.id
                                                        ) || null;
                                                      const signedAmount = sectionItem
                                                        ? Math.abs(this.getOrderSummarySignedAmount(sectionItem))
                                                        : 0;
                                                      return (
                                                        <tr key={section.id}>
                                                          <td colSpan="6"></td>
                                                          <td colSpan="2">
                                                            <a
                                                              style={{ cursor: "pointer" }}
                                                              onClick={() =>
                                                                this.openOrderSummaryModal(section.id)
                                                              }
                                                              className="text-primary"
                                                            >
                                                              {section.section_title || "Adjustment"}
                                                            </a>
                                                            {sectionItem?.description && (
                                                              <Tooltip title={sectionItem.description} placement="top">
                                                                <em className="icon ni ni-info" style={{ marginLeft: "6px", cursor: "pointer", color: "#8094ae", fontSize: "14px" }}></em>
                                                              </Tooltip>
                                                            )}
                                                          </td>
                                                          <td>
                                                            {this.formatAsCurrency(parseFloat(signedAmount || 0))}
                                                          </td>
                                                        </tr>
                                                      );
                                                    })}
                                                  </>
                                                ) : this.state.order === "edit" &&
                                                  this.state.orderSummaryItems &&
                                                  this.state.orderSummaryItems.length > 0 ? (
                                                  <>
                                                    {this.state.orderSummaryItems.map((item, index) => {
                                                      const signedAmount = Math.abs(this.getOrderSummarySignedAmount(item));
                                                      return (
                                                        <tr key={`saved-summary-${index}`}>
                                                          <td colSpan="6"></td>
                                                          <td colSpan="2">
                                                            {item.section_title || item.module_type || "Summary Item"}
                                                            {item.description && (
                                                              <Tooltip title={item.description} placement="top">
                                                                <em className="icon ni ni-info" style={{ marginLeft: "6px", cursor: "pointer", color: "#8094ae", fontSize: "14px" }}></em>
                                                              </Tooltip>
                                                            )}
                                                          </td>
                                                          <td>
                                                            {this.formatAsCurrency(parseFloat(signedAmount || 0))}
                                                          </td>
                                                        </tr>
                                                      );
                                                    })}
                                                  </>
                                                ) : this.hasValidLegacyData() ? (
                                                  <>
                                                    {parseFloat(this.state.discount_value_total || 0) > 0 && (
                                                      <tr>
                                                        <td colSpan="6"></td>
                                                        <td colSpan="2">
                                                          <a
                                                            style={{
                                                              cursor: "pointer",
                                                            }}
                                                            onClick={() =>
                                                              this.open_discount()
                                                            }
                                                            className="text-primary"
                                                          >
                                                            Edit discount
                                                          </a>
                                                        </td>
                                                        <td>
                                                          {this.formatAsCurrency(
                                                            Number(
                                                              this.state
                                                                .discount_value_total
                                                            )
                                                          )}
                                                        </td>
                                                      </tr>
                                                    )}
                                                    {parseFloat(this.state.shipping_value_total || 0) > 0 && (
                                                      <tr>
                                                        <td colSpan="6"></td>
                                                        <td colSpan="2">
                                                          <a
                                                            style={{
                                                              cursor: "pointer",
                                                            }}
                                                            onClick={() =>
                                                              this.open_shipping()
                                                            }
                                                            className="text-primary"
                                                          >
                                                            Edit shipping or delivery
                                                          </a>
                                                        </td>
                                                        <td>
                                                          {this.formatAsCurrency(
                                                            Number(
                                                              this.state
                                                                .shipping_value_total
                                                            )
                                                          )}
                                                        </td>
                                                      </tr>
                                                    )}
                                                    {parseFloat(this.state.tax_value_total || 0) > 0 && (
                                                      <tr>
                                                        <td colSpan="6"></td>
                                                        <td colSpan="2">
                                                          <a
                                                            style={{
                                                              cursor: "pointer",
                                                            }}
                                                            onClick={() =>
                                                              this.open_tax()
                                                            }
                                                            className="text-primary"
                                                          >
                                                            Edit estimated tax
                                                          </a>
                                                        </td>
                                                        <td>
                                                          {this.formatAsCurrency(
                                                            Number(
                                                              this.state
                                                                .tax_value_total
                                                            )
                                                          )}
                                                        </td>
                                                      </tr>
                                                    )}
                                                  </>
                                                ) : null}
                                                <tr>
                                                  <td colSpan="6"></td>
                                                  <td colSpan="2">
                                                    Grand Total
                                                  </td>
                                                  <td>
                                                    {this.formatAsCurrency(
                                                      Number(
                                                        this.state
                                                          .service_grand_total
                                                      )
                                                    )}
                                                  </td>
                                                </tr>
                                              </tfoot>
                                            </table>
                                          )}
                                        </Droppable>
                                      </DragDropContext>

                                      <div className="nk-notes ff-italic fs-12px text-soft">
                                        {" "}
                                      </div>
                                    </div>
                                    <div className="col-xxl-12 mt-5 order-mobile-add-actions">
                                      {this.state.quote_status !==
                                        "completed" &&
                                        this.state.quote_status !==
                                        "cancelled" ? (
                                        <>
                                          <a
                                            style={{ cursor: "pointer" }}
                                            onClick={this.addRow}
                                            //onClick={this.openServices}
                                            className="btn btn-dim btn-outline-primary mr-1"
                                          >
                                            Add a product
                                          </a>
                                          <a
                                            style={{ cursor: "pointer" }}
                                            onClick={this.addRowSec}
                                            className="btn btn-dim btn-outline-primary mr-1"
                                          >
                                            Add a section
                                          </a>
                                          <a
                                            style={{ cursor: "pointer" }}
                                            onClick={this.addRowCustom}
                                            className="btn btn-dim btn-outline-primary"
                                          >
                                            Add a custom product
                                          </a>
                                        </>
                                      ) : null}
                                    </div>
                                    <div className="col-md-12 mt-4 d-flex justify-content-end">
                                      <div className="form-group">
                                        <label
                                          className="form-label"
                                          htmlFor="cp_commission"
                                        >
                                          <b>Assigned CP:</b>{" "}
                                          {this.state.agent_name} (
                                          {this.state.agent_comp_name})<br />
                                          Est. CP Commission{" "}
                                          {this.state.commission_value_type ===
                                            "percentage" ? (
                                            <>
                                              ({this.state.commission_value}% of
                                              the order amount)
                                            </>
                                          ) : this.state
                                            .commission_value_type ===
                                            "fixed" ? (
                                            <>
                                              (Fixed{" "}
                                              {this.state.commission_value} per
                                              order)
                                            </>
                                          ) : null}
                                        </label>
                                        <div className="form-control-wrap">
                                          <div className="form-icon form-icon-left">
                                            <em className="icon ni ni-sign-usdc-alt"></em>
                                          </div>
                                          <input
                                            type="text"
                                            className="form-control form-control-lg"
                                            id="cp_commission"
                                            name="cp_commission"
                                            value={this.state.cp_commission}
                                            onChange={this.handleChange}
                                            readOnly
                                          />
                                        </div>
                                        <div className="form-note">
                                          {this.state.commission_value_type ===
                                            "percentage" ? (
                                            <>
                                              Calculated On =
                                              (Subtotal-Discount)
                                            </>
                                          ) : null}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="tab-pane" id="tabItem6">
                          <div className="row g-gs">
                            <div className="col-xxl-12 inner_content">
                              <div className="invoice">
                                <div className="invoice-wrap">
                                  <div className="invoice-bills">
                                    <div className=" genericTable">
                                      <DragDropContext
                                        onDragEnd={this.handleDragEndOptional}
                                      >
                                        <Droppable droppableId="droppable-2">
                                          {(provided) => (
                                            <table
                                              ref={provided.innerRef}
                                              {...provided.droppableProps}
                                              className="table table-striped"
                                            >
                                              <thead>
                                                <tr>
                                                  <th className="w-5">
                                                    <em className="icon ni ni-move"></em>
                                                  </th>
                                                  <th className="w-10">
                                                    ITEM ID
                                                  </th>
                                                  <th className="w-10">SKU</th>
                                                  <th className="w-25">
                                                    PRODUCT NAME
                                                  </th>
                                                  <th className="w-10">QTY</th>
                                                  <th className="w-10">UNIT</th>
                                                  <th className="w-10">
                                                    PRICE($)
                                                  </th>
                                                  <th className="w-10">
                                                    TOTAL($)
                                                  </th>
                                                  <th className="w-10">
                                                    &nbsp;
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {this.state.rows_optional.map(
                                                  (row, index) => (
                                                    <Draggable
                                                      key={row.id}
                                                      draggableId={`${row.id}-2`}
                                                      index={index}
                                                    >
                                                      {(provided) => (
                                                        <tr
                                                          ref={
                                                            provided.innerRef
                                                          }
                                                          {...provided.draggableProps}
                                                          {...provided.dragHandleProps}
                                                        >
                                                          {row.data.type &&
                                                            row.data.type ===
                                                            "service" ? (
                                                            <>
                                                              <td>
                                                                <em className="icon ni ni-move"></em>
                                                              </td>
                                                              <td>
                                                                {row.data.id &&
                                                                  row.data.id !==
                                                                  ""
                                                                  ? row.data.id
                                                                  : "---"}
                                                              </td>
                                                              <td>
                                                                {row.data.sku &&
                                                                  row.data.sku !==
                                                                  ""
                                                                  ? row.data.sku
                                                                  : "---"}
                                                              </td>
                                                              <td>
                                                                {row.data
                                                                  .name !==
                                                                  "" ? (
                                                                  row.data
                                                                    .name &&
                                                                    row.data
                                                                      .name !==
                                                                    "" ? (
                                                                    row.data
                                                                      .name
                                                                  ) : (
                                                                    "---"
                                                                  )
                                                                ) : (
                                                                  <Select
                                                                    options={
                                                                      this.state
                                                                        .all_select_services
                                                                    }
                                                                    name="select_a_service_optional"
                                                                    placeholder="Select product / service"
                                                                    value={
                                                                      this.state
                                                                        .select_a_service_optional
                                                                    }
                                                                    autoComplete="off"
                                                                    emptyMessage="Product not found"
                                                                    onChange={
                                                                      this
                                                                        .handleChangeSearchOptional
                                                                    }
                                                                    isClearable
                                                                    isSearchable
                                                                    components={
                                                                      animatedComponents
                                                                    }
                                                                  />
                                                                )}
                                                              </td>
                                                              <td>
                                                                <div className="form-control-wrap">
                                                                  <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="quantity"
                                                                    name="quantity"
                                                                    onChange={this.handleChangeServicesOptional(
                                                                      row.id
                                                                    )}
                                                                    placeholder=""
                                                                    style={{
                                                                      width:
                                                                        "60px",
                                                                      textAlign:
                                                                        "center",
                                                                    }}
                                                                    defaultValue={
                                                                      row.data
                                                                        .quantity
                                                                    }
                                                                    maxLength={
                                                                      11
                                                                    }
                                                                    onInput={(
                                                                      e
                                                                    ) => {
                                                                      e.target.value =
                                                                        e.target.value.replace(
                                                                          /[^0-9]/gi,
                                                                          ""
                                                                        );
                                                                    }}
                                                                    autoComplete="off"
                                                                    required
                                                                  />
                                                                </div>
                                                              </td>
                                                              <td>
                                                                <div className="form-control-wrap">
                                                                  <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="unit"
                                                                    name="unit"
                                                                    onChange={this.handleChangeServicesOptional(
                                                                      row.id
                                                                    )}
                                                                    placeholder=""
                                                                    style={{
                                                                      width:
                                                                        "100px",
                                                                      textAlign:
                                                                        "center",
                                                                    }}
                                                                    defaultValue={
                                                                      row.data
                                                                        .unit
                                                                    }
                                                                    maxLength={
                                                                      20
                                                                    }
                                                                    onInput={(
                                                                      e
                                                                    ) => {
                                                                      e.target.value =
                                                                        e.target.value.replace(
                                                                          /[^a-zA-Z0-9 ]/gi,
                                                                          ""
                                                                        );
                                                                    }}
                                                                    autoComplete="off"
                                                                    required
                                                                  />
                                                                </div>
                                                              </td>
                                                              <td>
                                                                <div className="form-control-wrap">
                                                                  <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="price"
                                                                    name="price"
                                                                    onChange={this.handleChangeServicesOptional(
                                                                      row.id
                                                                    )}
                                                                    placeholder=""
                                                                    style={{
                                                                      width:
                                                                        "100px",
                                                                      textAlign:
                                                                        "center",
                                                                    }}
                                                                    value={
                                                                      row.data
                                                                        .price
                                                                    }
                                                                    maxLength={
                                                                      10
                                                                    }
                                                                    onInput={(
                                                                      e
                                                                    ) => {
                                                                      e.target.value =
                                                                        e.target.value.replace(
                                                                          /[^0-9.]/gi,
                                                                          ""
                                                                        );
                                                                    }}
                                                                    autoComplete="off"
                                                                    readOnly
                                                                    required
                                                                  />
                                                                </div>
                                                              </td>
                                                              <td>
                                                                {row.data.total}
                                                              </td>
                                                              <td>
                                                                {row.data
                                                                  .name ===
                                                                  "" ? (
                                                                  <span
                                                                    className="badge badge-outline-primary mr-1"
                                                                    onClick={() =>
                                                                      this.addNewServiceOptional(
                                                                        row.id
                                                                      )
                                                                    }
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                      paddingTop:
                                                                        "3px",
                                                                      paddingBottom:
                                                                        "3px",
                                                                      paddingLeft:
                                                                        "7px",
                                                                      fontSize:
                                                                        "18px",
                                                                    }}
                                                                  >
                                                                    <em className="icon ni ni-save"></em>
                                                                  </span>
                                                                ) : null}
                                                                {this.state
                                                                  .quote_status !==
                                                                  "completed" &&
                                                                  this.state
                                                                    .quote_status !==
                                                                  "cancelled" ? (
                                                                  <span
                                                                    className="badge badge-outline-danger"
                                                                    onClick={() =>
                                                                      this.removeRowOptional(
                                                                        row.id
                                                                      )
                                                                    }
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                      paddingTop:
                                                                        "3px",
                                                                      paddingBottom:
                                                                        "3px",
                                                                      paddingLeft:
                                                                        "7px",
                                                                      fontSize:
                                                                        "18px",
                                                                    }}
                                                                  >
                                                                    <em className="icon ni ni-trash"></em>
                                                                  </span>
                                                                ) : null}
                                                              </td>
                                                            </>
                                                          ) : row.data.type ===
                                                            "section" ? (
                                                            <>
                                                              <td>
                                                                <em className="icon ni ni-move"></em>
                                                              </td>
                                                              <td colSpan={7}>
                                                                {row.data
                                                                  .name &&
                                                                  row.data
                                                                    .name !==
                                                                  "" ? (
                                                                  row.data.name
                                                                ) : (
                                                                  <div className="form-control-wrap">
                                                                    <input
                                                                      type="text"
                                                                      className="form-control"
                                                                      id="select_name"
                                                                      name="select_name"
                                                                      onChange={this.handleChangeSectionOptional(
                                                                        row.id
                                                                      )}
                                                                      placeholder=""
                                                                      autoComplete="off"
                                                                      defaultValue={
                                                                        row.data
                                                                          .name
                                                                      }
                                                                      maxLength={
                                                                        100
                                                                      }
                                                                      required
                                                                    />
                                                                  </div>
                                                                )}
                                                              </td>
                                                              <td>
                                                                {row.data
                                                                  .name ===
                                                                  "" ? (
                                                                  <span
                                                                    className="badge badge-outline-primary mr-1"
                                                                    onClick={() =>
                                                                      this.addNewSectionOptional(
                                                                        row.id
                                                                      )
                                                                    }
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                      paddingTop:
                                                                        "3px",
                                                                      paddingBottom:
                                                                        "3px",
                                                                      paddingLeft:
                                                                        "7px",
                                                                      fontSize:
                                                                        "18px",
                                                                    }}
                                                                  >
                                                                    <em className="icon ni ni-save"></em>
                                                                  </span>
                                                                ) : null}
                                                                {this.state
                                                                  .quote_status !==
                                                                  "completed" &&
                                                                  this.state
                                                                    .quote_status !==
                                                                  "cancelled" ? (
                                                                  <span
                                                                    className="badge badge-outline-danger"
                                                                    onClick={() =>
                                                                      this.removeRowOptional(
                                                                        row.id
                                                                      )
                                                                    }
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                      paddingTop:
                                                                        "3px",
                                                                      paddingBottom:
                                                                        "3px",
                                                                      paddingLeft:
                                                                        "7px",
                                                                      fontSize:
                                                                        "18px",
                                                                    }}
                                                                  >
                                                                    <em className="icon ni ni-trash"></em>
                                                                  </span>
                                                                ) : null}
                                                              </td>
                                                            </>
                                                          ) : null}
                                                        </tr>
                                                      )}
                                                    </Draggable>
                                                  )
                                                )}
                                              </tbody>
                                            </table>
                                          )}
                                        </Droppable>
                                      </DragDropContext>

                                      <div className="nk-notes ff-italic fs-12px text-soft">
                                        {" "}
                                      </div>
                                    </div>
                                    <div className="col-xxl-12 mt-5 order-mobile-add-actions">
                                      {this.state.quote_status !==
                                        "completed" &&
                                        this.state.quote_status !==
                                        "cancelled" ? (
                                        <>
                                          <a
                                            style={{ cursor: "pointer" }}
                                            onClick={this.addRowOptional}
                                            //onClick={this.openServices}
                                            className="btn btn-dim btn-outline-primary mr-1"
                                          >
                                            Add a product
                                          </a>
                                          <a
                                            style={{ cursor: "pointer" }}
                                            onClick={this.addRowSecOptional}
                                            className="btn btn-dim btn-outline-primary mr-1"
                                          >
                                            Add a section
                                          </a>
                                        </>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="tab-pane" id="tabItem7">
                          <div className="row g-gs">
                            <div className="col-xxl-12">
                              <div className="form-group mt-1">
                                <MutextField
                                  required
                                  id="quote_title"
                                  name="quote_title"
                                  type="text"
                                  label="Order Title"
                                  value={this.state.quote_title}
                                  onChange={this.handleChange}
                                  variant="outlined"
                                  maxLength={100}
                                  autoComplete="off"
                                  fullWidth
                                />
                              </div>
                            </div>
                            <div className="col-xxl-12">
                              <h6>Notes:</h6>
                              <div className="form-group mt-1">
                                {this.state.isEditorReadyNotes ? (
                                  <RichTextEditorComponent
                                    agreementContent={this.state.quote_notes}
                                    onContentChange={this.handleEditorChange}
                                  />
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="tab-pane" id="tabItemPayment">
                          <div className="row g-gs">
                            {/*<div className="col-xxl-12">
                              <div className="form-group mt-1">
                              <MutextField
                              id="order_paid"
                              name="order_paid"
                              select
                              label="Paid"
                              value={this.state.order_paid}
                              onChange={this.handleChange}
                              SelectProps={{
                                native: true,
                              }}
                              helperText=""
                              variant="outlined"
                              fullWidth
                            >
                              <option key="setyes" value="paid">
                                Yes
                              </option>
                              <option key="setno" value="unpaid">
                               No
                              </option>
                              
                            </MutextField>
                              </div>
                            </div>*/}
                            <div className="col-xxl-12">
                              <h6>Payment Details:</h6>
                              <div className="form-group mt-1">
                                {this.state.isEditorReady ? (
                                  <RichTextEditorComponent
                                    agreementContent={
                                      this.state.payment_details
                                    }
                                    onContentChange={
                                      this.handleEditorChangePayment
                                    }
                                  />
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="tab-pane p-4" id="tabItem8">
                          <div className="row g-gs">
                            <div className="col-xxl-12">
                              <h5>Requirements</h5>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: this.state.rfq_requirements,
                                }}
                              />
                            </div>
                            {this.state.rfq_attachment &&
                              this.state.rfq_attachment !== "" ? (
                              <div className="col-xxl-12">
                                <h5>Attachment</h5>
                                <table className="table table-striped">
                                  <tbody>
                                    <tr>
                                      <td>Download Attachment</td>
                                      <td>
                                        <a
                                          onClick={() =>
                                            this.downloadPdfRfq(
                                              this.state.rfq_attachment
                                            )
                                          }
                                          style={{ cursor: "pointer" }}
                                          title="Download Attachment"
                                        >
                                          <span className="badge badge-outline-secondary">
                                            {" "}
                                            <em className="icon ni ni-download"></em>{" "}
                                            Download Attachment
                                          </span>
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            ) : null}
                            {this.state.rows_rfq_services &&
                              this.state.rows_rfq_services.length > 0 ? (
                              <div className="col-xxl-12">
                                <h5>RFQ Products & Services</h5>

                                <table className="table table-striped">
                                  <thead>
                                    <tr>
                                      <th className="w-150px">ITEM ID</th>
                                      <th className="w-40">Product name</th>
                                      <th>SKU</th>
                                      <th>Quantity</th>
                                      <th>Unit</th>
                                      <th>Add</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.rows_rfq_services.map(
                                      (row, index) => (
                                        <tr key={index}>
                                          <td>{row.data.id}</td>
                                          <td>{row.data.name}</td>
                                          <td>{row.data.sku}</td>
                                          <td>{row.data.quantity}</td>
                                          <td>{row.data.unit}</td>
                                          <td>
                                            <a
                                              onClick={() =>
                                                this.addToCart(row.data.id)
                                              }
                                              style={{ cursor: "pointer" }}
                                            >
                                              <span className="badge badge-outline-dark">
                                                <em className="icon ni ni-cart"></em>
                                              </span>
                                            </a>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            ) : null}
                            {this.state.rows_rfq_questions &&
                              this.state.rows_rfq_questions.length > 0 ? (
                              <div className="col-xxl-12">
                                <h5>Questions</h5>

                                <table className="table table-striped">
                                  <thead>
                                    <tr>
                                      <th className="w-150px">Question</th>
                                      <th className="w-40">Answer</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.rows_rfq_questions.map(
                                      (rfq, index) => (
                                        <tr key={index}>
                                          <td>{rfq.question}</td>
                                          <td>{rfq.answer}</td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <ul className="nk-stepper-pagination pt-4 px-2 gx-4 gy-2 stepper-pagination d-flex justify-content-end order-mobile-action-stack">
                        <li className="step-next">
                          <button
                            type="button"
                            className="btn btn-wider btn-light"
                            disabled={this.state.disabled}
                            onClick={() =>
                              this.addMenuHistory("/partner_orders")
                            }
                          >
                            <em className="icon ni ni-arrow-left"></em>
                            <span>Back</span>
                          </button>
                        </li>
                        {this.state.quote_status !== "completed" &&
                          this.state.quote_status !== "cancelled" ? (
                          <>
                            {(this.state.quote_status === "draft" || this.state.quote_status === "") ? (
                              <li className="step-next">
                                {this.state.draft_button === true ? (
                                  <button
                                    className="btn btn-primary"
                                    type="button"
                                    disabled
                                  >
                                    <span
                                      className="spinner-grow spinner-grow-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    <span> Saving... </span>
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    className="btn btn-wider btn-primary"
                                    onClick={() => this.save_as_draft()}
                                  >
                                    <span>Save as draft</span>
                                    <em className="icon ni ni-save"></em>
                                  </button>
                                )}
                              </li>
                            ) : null}
                            <li className="step-next">
                              {this.state.send_client_button === true ? (
                                <button
                                  className="btn btn-primary"
                                  type="button"
                                  disabled
                                >
                                  <span
                                    className="spinner-grow spinner-grow-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                  <span> Creating Order... </span>
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  className="btn btn-wider btn-success"
                                  disabled={this.state.disabled}
                                  onClick={() => this.handleConfirmation()}
                                >
                                  <span>Create Order</span>
                                  <em className="icon ni ni-arrow-right"></em>
                                </button>
                              )}
                            </li>
                          </>
                        ) : null}
                      </ul>
                    </div>
                    {/* <div className="col-xxl-12 border-top mb-4">
                      <div
                        className="simplebar-content-wrapper"
                        style={{ height: "100%" }}
                      >
                        <div
                          className="simplebar-content"
                          style={{ padding: "0px" }}
                        >
                          {this.state.convErrorMessage !== "" ? (
                            <div
                              className="example-alert mt-4"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.convErrorMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <div className="nk-msg-head py-4 d-none">
                            <h4 className="title">
                              Unable to select currency when order
                            </h4>
                            <ul className="nk-msg-tags">
                              <li>
                                <span className="label-tag">
                                  <em className="icon ni ni-flag-fill"></em>{" "}
                                  <span>Technical Problem</span>
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>

                {/* Table 5th Col End */}
              </div>
              <div className="modal fade" tabIndex="-1" id="modalFormOptions">
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">Requirements</h5>
                    </div>
                    <div className="modal-body">
                      {this.state.formLoader === true ? (
                        FormLoader()
                      ) : (
                        <>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: this.state.rfq_requirements,
                            }}
                          />
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* DYNAMIC ORDER SUMMARY MODAL */}
              <div className="modal fade" id="modalOrderSummary">
                <div
                  className="modal-dialog modal-dialog-top modal-lg"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">
                        {(() => {
                          const activeSection = this.state.orderSummarySections.find(
                            (section) => section.id === this.state.activeOrderSummarySectionId
                          );
                          return activeSection
                            ? `Order Adjustment - ${activeSection.section_title}`
                            : "Order Adjustments";
                        })()}
                      </h5>
                      <a
                        style={{ cursor: "pointer" }}
                        className="close"
                        onClick={this.closeOrderSummaryModal}
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>
                    <div className="modal-body">
                      {this.state.orderSummaryModalSuccess ? (
                        <div className="alert alert-success">
                          {this.state.orderSummaryModalSuccess}
                        </div>
                      ) : null}
                      {this.state.orderSummaryModalError ? (
                        <div className="alert alert-danger">
                          {this.state.orderSummaryModalError}
                        </div>
                      ) : null}
                      {this.state.orderSummarySections.length === 0 ? (
                        <div className="alert alert-warning">
                          No active order settings found.
                        </div>
                      ) : (
                        (() => {
                          const activeSection = this.state.orderSummarySections.find(
                            (section) => section.id === this.state.activeOrderSummarySectionId
                          );

                          if (!activeSection) {
                            return (
                              // <div className="alert alert-warning">
                              //   Select an adjustment section from the order table.
                              // </div>
                              null
                            );
                          }

                          const sectionVals =
                            this.state.orderSummaryModalValues[activeSection.id] || {
                              value: "",
                              description: "",
                            };
                          const sectionError =
                            this.state.orderSummaryValueErrors[activeSection.id] || "";

                          return (
                            <div className="row g-gs">
                              <div className="col-sm-12" key={activeSection.id}>
                                <div className="card card-bordered p-3">
                                  <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="mb-0">{activeSection.section_title}</h6>
                                    <span className="badge badge-outline-primary">
                                      {activeSection.section_type} / {activeSection.section_scope}
                                    </span>
                                  </div>

                                  <div className="row g-gs">
                                    {activeSection?.fields?.type?.visible ? (
                                      <div className="col-sm-6">
                                        <div className="form-group">
                                          <label className="form-label">
                                            {activeSection?.fields?.type?.label || "Type"}
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control form-control-lg"
                                            value={`${activeSection.section_type} / ${activeSection.section_scope}`}
                                            readOnly
                                          />
                                        </div>
                                      </div>
                                    ) : null}

                                    {activeSection?.fields?.value?.visible ? (
                                      <div className="col-sm-6">
                                        <div className="form-group">
                                          <label className="form-label">
                                            {activeSection?.fields?.value?.label || "Value"}
                                          </label>
                                          <input
                                            type="text"
                                            className={`form-control form-control-lg ${sectionError ? "is-invalid" : ""
                                              }`}
                                            value={sectionVals.value || ""}
                                            onChange={(e) =>
                                              this.handleOrderSummaryValueChange(
                                                activeSection.id,
                                                "value",
                                                e.target.value
                                              )
                                            }
                                            maxLength={18}
                                            autoComplete="off"
                                            placeholder={
                                              String(activeSection.section_scope || "").toUpperCase() ===
                                                "PERCENTAGE"
                                                ? "e.g. 10"
                                                : "e.g. 50"
                                            }
                                          />
                                          {sectionError ? (
                                            <div
                                              className="invalid-feedback"
                                              style={{ display: "block" }}
                                            >
                                              {sectionError}
                                            </div>
                                          ) : null}
                                        </div>
                                      </div>
                                    ) : null}

                                    {activeSection?.fields?.description?.visible ? (
                                      <div className="col-sm-12">
                                        <div className="form-group">
                                          <label className="form-label">
                                            {activeSection?.fields?.description?.label || "Description"}
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control form-control-lg"
                                            value={sectionVals.description || ""}
                                            onChange={(e) =>
                                              this.handleOrderSummaryValueChange(
                                                activeSection.id,
                                                "description",
                                                e.target.value
                                              )
                                            }
                                            autoComplete="off"
                                          />
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })()
                      )}
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-light mr-1"
                        onClick={this.closeOrderSummaryModal}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={this.applyOrderSummaryModal}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* DYNAMIC ORDER SUMMARY MODAL */}
              {/* DISCOUNT MODEL */}
              <div className="modal fade" id="modalFormDiscount">
                <div
                  className="modal-dialog modal-dialog-top modal-lg"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Add/Edit Discount</h5>
                      <a
                        style={{ cursor: "pointer" }}
                        className="close"
                        onClick={() => {
                          this.modalHide("modalFormDiscount");
                        }}
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>
                    <div className="modal-body">
                      <div className="row g-gs">
                        {this.state.quote_status !== "completed" &&
                          this.state.quote_status !== "cancelled" ? (
                          <>
                            <div className="col-sm-6 col-xxl-6">
                              <div className="form-group">
                                <label
                                  className="form-label"
                                  htmlFor="discount_type"
                                >
                                  Discount Type
                                </label>
                                <div className="form-control-wrap">
                                  <div className="form-control-select">
                                    <select
                                      className="form-control form-control-lg"
                                      name="discount_type"
                                      id="discount_type"
                                      label="Select an Option"
                                      onChange={this.handleChange}
                                      defaultValue={this.state.discount_type}
                                    >
                                      <option key="sets100" value="amount">
                                        Amount
                                      </option>
                                      <option key="sets102" value="percentage">
                                        Percentage
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xxl-6">
                              <div className="form-group">
                                <label
                                  className="form-label"
                                  htmlFor="discount_value"
                                >
                                  Discount value
                                </label>
                                <div className="form-control-wrap">
                                  <input
                                    type="text"
                                    className={`form-control form-control-lg ${this.state.discount_value_error ? 'is-invalid' : ''}`}
                                    id="discount_value"
                                    name="discount_value"
                                    onChange={this.handleChange}
                                    value={this.state.discount_value}
                                    maxLength={18}
                                    autoComplete="off"
                                    required
                                  />
                                  {this.state.discount_value_error && (
                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                      {this.state.discount_value_error}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-12 col-xxl-12">
                              <div className="form-group">
                                <label
                                  className="form-label"
                                  htmlFor="discount_reason"
                                >
                                  Reason for discount
                                </label>
                                <div className="form-control-wrap">
                                  <input
                                    type="text"
                                    className="form-control form-control-lg"
                                    id="discount_reason"
                                    name="discount_reason"
                                    onChange={this.handleChange}
                                    defaultValue={this.state.discount_reason}
                                    autoComplete="off"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="form-group col-xxl-12 d-flex">
                              <div className="col-sm-4 col-xxl-4">
                                {this.state.discount_value_total &&
                                  this.state.discount_value_total > 0 &&
                                  this.state.discount_value_total !== "0.00" ? (
                                  <button
                                    type="button"
                                    onClick={() => this.removeDiscount()}
                                    className="btn btn-danger"
                                  >
                                    Remove Discount
                                  </button>
                                ) : null}{" "}
                              </div>
                              <div className="col-sm-8 col-xxl-8 col-md-8">
                                <div className="d-flex justify-content-end">
                                  <button
                                    type="button"
                                    className="btn btn-light mr-1"
                                    onClick={() => {
                                      this.modalHide("modalFormDiscount");
                                    }}
                                  >
                                    Cancel
                                  </button>{" "}
                                  <button
                                    type="button"
                                    style={{ marginLeft: "10px" }}
                                    className="btn btn-primary"
                                    onClick={() => this.applyDiscount()}
                                    disabled={!!this.state.discount_value_error}
                                  >
                                    Apply
                                  </button>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="alert alert-pro alert-warning mt-2 mb-2">
                            <div className="alert-text">
                              <h6>Not Allowed</h6>
                              <p>
                                Discounts cannot be added or edited when an
                                order is in the "Completed" or "Cancelled"
                                status.{" "}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* DISCOUNT MODEL */}
              {/* SHIPPING MODEL */}
              <div className="modal fade" id="modalFormShipping">
                <div
                  className="modal-dialog modal-dialog-top modal-lg"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">
                        Shipping and delivery options
                      </h5>
                      <a
                        onClick={() => this.close_modal("modalFormShipping")}
                        style={{ cursor: "pointer" }}
                        className="close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>
                    <div className="modal-body">
                      <div className="row g-gs">
                        {this.state.quote_status !== "completed" &&
                          this.state.quote_status !== "cancelled" ? (
                          <>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <label
                                  className="form-label"
                                  htmlFor="shipping_title"
                                >
                                  Name
                                </label>
                                <div className="form-control-wrap">
                                  <input
                                    type="text"
                                    className="form-control form-control-lg"
                                    id="shipping_title"
                                    name="shipping_title"
                                    onChange={this.handleChange}
                                    defaultValue={this.state.shipping_title}
                                    placeholder="E.g, Free shippping"
                                    autoComplete="off"
                                    required
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <label
                                  className="form-label"
                                  htmlFor="shipping_value"
                                >
                                  Price
                                </label>
                                <div className="form-control-wrap">
                                  <input
                                    type="text"
                                    className={`form-control form-control-lg ${this.state.shipping_value_error ? 'is-invalid' : ''}`}
                                    id="shipping_value"
                                    name="shipping_value"
                                    onChange={this.handleChange}
                                    value={this.state.shipping_value}
                                    maxLength={18}
                                    autoComplete="off"
                                    required
                                  />
                                  {this.state.shipping_value_error && (
                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                      {this.state.shipping_value_error}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="form-group col-xxl-12 d-flex">
                              <div className="col-sm-4 col-xxl-4">
                                {this.state.shipping_value_total &&
                                  this.state.shipping_value_total > 0 &&
                                  this.state.shipping_value_total !== "0.00" ? (
                                  <button
                                    type="button"
                                    onClick={() => this.remove_shipping()}
                                    className="btn btn-danger"
                                  >
                                    Remove Discount
                                  </button>
                                ) : null}
                              </div>
                              <div className="col-sm-8 col-xxl-8 col-md-8">
                                <div className="d-flex justify-content-end">
                                  <button
                                    type="button"
                                    onClick={() =>
                                      this.close_modal("modalFormShipping")
                                    }
                                    className="btn btn-light mr-1"
                                  >
                                    Cancel
                                  </button>{" "}
                                  <button
                                    type="button"
                                    style={{ marginLeft: "10px" }}
                                    className="btn btn-primary"
                                    onClick={this.applyShipping}
                                    disabled={!!this.state.shipping_value_error}
                                  >
                                    Apply
                                  </button>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="alert alert-pro alert-warning mt-2 mb-2">
                            <div className="alert-text">
                              <h6>Not Allowed</h6>
                              <p>
                                Shipping cannot be added or edited when an order
                                is in the "Completed" or "Cancelled" status.{" "}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* SHIPPING MODEL */}
              {/* TAX MODEL */}
              <div className="modal fade" id="modalFormTax">
                <div className="modal-dialog modal-lg" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Add/Edit Tax</h5>
                      <a
                        onClick={() => this.close_modal("modalFormTax")}
                        style={{ cursor: "pointer" }}
                        className="close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>
                    <div className="modal-body">
                      <div className="row g-gs">
                        {this.state.quote_status !== "completed" &&
                          this.state.quote_status !== "cancelled" ? (
                          <>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <label
                                  className="form-label"
                                  htmlFor="tax_type"
                                >
                                  Discount Type
                                </label>
                                <div className="form-control-wrap">
                                  <div className="form-control-select">
                                    <select
                                      className="form-control form-control-lg"
                                      name="tax_type"
                                      id="tax_type"
                                      label="Select tax type"
                                      onChange={this.handleChange}
                                      defaultValue={this.state.tax_type}
                                    >
                                      <option key="sets100" value="amount">
                                        Amount
                                      </option>
                                      <option key="sets102" value="percentage">
                                        Percentage
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <label
                                  className="form-label"
                                  htmlFor="tax_value"
                                >
                                  Tax value
                                </label>
                                <div className="form-control-wrap">
                                  <input
                                    type="text"
                                    className={`form-control form-control-lg ${this.state.tax_value_error ? 'is-invalid' : ''}`}
                                    id="tax_value"
                                    name="tax_value"
                                    onChange={this.handleChange}
                                    value={this.state.tax_value}
                                    maxLength={18}
                                    autoComplete="off"
                                    required
                                  />
                                  {this.state.tax_value_error && (
                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                      {this.state.tax_value_error}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-12">
                              <div className="form-group">
                                <label
                                  className="form-label"
                                  htmlFor="tax_reason"
                                >
                                  Reason
                                </label>
                                <div className="form-control-wrap">
                                  <input
                                    type="text"
                                    className="form-control form-control-lg"
                                    id="tax_reason"
                                    name="tax_reason"
                                    onChange={this.handleChange}
                                    defaultValue={this.state.tax_reason}
                                    autoComplete="off"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="form-group col-xxl-12 d-flex">
                              <div className="col-sm-4 col-xxl-4">
                                {this.state.tax_value_total &&
                                  this.state.tax_value_total > 0 &&
                                  this.state.tax_value_total !== "0.00" ? (
                                  <button
                                    type="button"
                                    onClick={() => this.removeTax()}
                                    className="btn btn-danger"
                                  >
                                    Remove Tax
                                  </button>
                                ) : null}
                              </div>
                              <div className="col-sm-8 col-xxl-8 col-md-8">
                                <div className="d-flex justify-content-end">
                                  <button
                                    type="button"
                                    onClick={() =>
                                      this.close_modal("modalFormTax")
                                    }
                                    className="btn btn-light mr-1"
                                  >
                                    Cancel
                                  </button>{" "}
                                  <button
                                    type="button"
                                    style={{ marginLeft: "10px" }}
                                    className="btn btn-primary"
                                    onClick={this.applyTax}
                                    disabled={!!this.state.tax_value_error}
                                  >
                                    Apply
                                  </button>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="alert alert-pro alert-warning mt-2 mb-2">
                            <div className="alert-text">
                              <h6>Not Allowed</h6>
                              <p>
                                Taxes cannot be added or edited when a quotation
                                is in the "Completed" or "Cancelled" status.{" "}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* TAX MODEL */}
              {/* SERVICE ADD MODAL*/}
              <div className="modal fade" id="modalFormServices">
                <div
                  className="modal-dialog modal-dialog-top modal-xl"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Add product / service</h5>
                      <a
                        style={{ cursor: "pointer" }}
                        className="close"
                        onClick={() => {
                          this.modalHide("modalFormServices");
                        }}
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>
                    <div className="modal-body">
                      <div className="col-sm-12 mb-4">
                        <div className="row g-gs">
                          <div className="col-sm-8">
                            <div className="form-group">
                              <label className="form-label">
                                Select product and add
                              </label>

                              <div className="form-control-wrap">
                                <Select
                                  options={this.state.all_select_services}
                                  name="select_a_service"
                                  placeholder="Select product / service"
                                  value={this.state.select_a_service}
                                  autoComplete="off"
                                  emptyMessage="Product not found"
                                  onChange={this.handleChangeSearch}
                                  isClearable
                                  isSearchable
                                  components={animatedComponents}
                                  styles={{
                                    control: (baseStyles, state) => ({
                                      ...baseStyles,
                                      lineHeight: "40px",
                                    }),
                                  }}
                                />
                                {/*<MutextField
                                  id="select_service"
                                  name="select_service"
                                  select
                                  label="Select product / service"
                                  value={this.state.select_service}
                                  onChange={this.handleChange}
                                  SelectProps={{
                                    native: true,
                                  }}
                                  helperText="Please select a service."
                                  variant="outlined"
                                  fullWidth
                                >
                                  <option key="sets100" value=""></option>
                                  {this.state.all_services &&
                                  this.state.all_services.length > 0 ? (
                                    <>
                                      {this.state.all_services.map(
                                        (service, sid) => (
                                          <option
                                            key={`ser${sid}`}
                                            value={service[0]}
                                          >
                                            {service[1]}
                                          </option>
                                        )
                                      )}
                                    </>
                                  ) : null}
                                        </MutextField>*/}
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label className="form-label">&nbsp;</label>
                              <div className="form-control-wrap">
                                <button
                                  type="button"
                                  className="btn btn-lg btn-primary"
                                  onClick={this.addNewService}
                                >
                                  Add
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row g-gs">
                        <div className="col-xxl-12">
                          <div className="invoice-bills">
                            <div className="example-alert mt-5 mb-2">
                              <div className="alert alert-light">
                                <strong>NOTE:</strong> After adding the product,
                                It will appear in "Order Lines" section where
                                you can add its unit and quantity.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* SERVICE ADD MODAL */}
              {/*** Edit Info Modal ***/}
              <div className="modal fade" tabIndex="-1" id="modalDefaultInfo">
                <div
                  className="modal-dialog modal-dialog-top modal-xl"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">Update Order Information</h5>
                    </div>
                    <div className="modal-body">
                      <div className="row g-gs">
                        {this.state.errorMessageInfo !== "" ? (
                          <div className="col-xxl-12">
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessageInfo}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {this.state.successMessageInfo !== "" ? (
                          <div className="col-xxl-12">
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessageInfo}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        <div className="col-xxl-6 col-md-6 col-sm-12">
                          <div className="form-group mt-1">
                            <MutextField
                              id="payment_terms"
                              name="payment_terms"
                              select
                              label="Terms of payment"
                              value={this.state.payment_terms}
                              onChange={this.handleChange}
                              SelectProps={{
                                native: true,
                              }}
                              helperText="Please select a payment term."
                              variant="outlined"
                              fullWidth
                            >
                              {this.state.paymentTermsList.map((term) => (
                                <option key={`pt_${term.id}`} value={term.term_name}>
                                  {term.term_name}
                                </option>
                              ))}
                              <option value="Other">Other</option>
                            </MutextField>
                          </div>
                        </div>
                        {this.state.payment_terms === "Other" && (
                          <div className="col-xxl-6 col-md-6 col-sm-12">
                            <div className="form-group mt-1">
                              <MutextField
                                required
                                id="custom_payment_terms"
                                name="custom_payment_terms"
                                type="text"
                                label="Custom Terms of Payment"
                                value={this.state.custom_payment_terms}
                                onChange={this.handleChange}
                                variant="outlined"
                                autoComplete="off"
                                fullWidth
                                inputProps={{ maxLength: 250 }}
                                helperText={`Please enter your custom payment terms. (${(this.state.custom_payment_terms || "").length}/250)`}
                                error={this.state.payment_terms === "Other" && !this.state.custom_payment_terms}
                              />
                            </div>
                          </div>
                        )}
                        <div className="col-xxl-6 col-md-6 col-sm-12">
                          <div className="form-group mt-1">
                            <MutextField
                              required
                              id="currency"
                              name="currency"
                              type="text"
                              label="Currency"
                              value={this.state.currency}
                              onChange={this.handleChange}
                              variant="outlined"
                              autoComplete="off"
                              fullWidth
                            />
                          </div>
                        </div>
                        <div className="col-xxl-6 col-md-6 col-sm-12">
                          <div className="form-group mt-1">
                            <MutextField
                              required
                              id="contact_person"
                              name="contact_person"
                              type="text"
                              label="Contact Person"
                              value={this.state.contact_person}
                              onChange={this.handleChange}
                              variant="outlined"
                              autoComplete="off"
                              fullWidth
                            />
                          </div>
                        </div>
                        <div className="col-xxl-6 col-md-6 col-sm-12">
                          <div className="form-group mt-1">
                            <MutextField
                              required
                              id="contact_email"
                              name="contact_email"
                              type="text"
                              label="Contact Email"
                              value={this.state.contact_email}
                              onChange={this.handleChange}
                              variant="outlined"
                              autoComplete="off"
                              fullWidth
                            />
                          </div>
                        </div>
                        {/*<div className="col-xxl-6 col-md-6 col-sm-12">
                          <div className="form-group mt-1">
                            <MutextField
                              required
                              id="validity"
                              name="validity"
                              type="text"
                              label="Validity"
                              value={this.state.validity}
                              onChange={this.handleChange}
                              variant="outlined"
                              autoComplete="off"
                              fullWidth
                            />
                          </div>
                        </div>*/}
                        <div className="col-xxl-6 col-md-6 col-sm-12">
                          <div className="form-group mt-1">
                            <div className="form-control-wrap">
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                  variant="dialog"
                                  name="issueDate"
                                  id="issueDate"
                                  inputVariant="outlined"
                                  format="MM-dd-yyyy"
                                  fullWidth
                                  value={this.state.issueDate}
                                  onChange={this.handleIssueDateChange}
                                  orientation="landscape"
                                />
                              </MuiPickersUtilsProvider>
                            </div>
                            <div className="form-note">Issue date of the invoice</div>
                          </div>
                        </div>
                        <div className="col-xxl-6 col-md-6 col-sm-12">
                          <div className="form-group mt-1">
                            <div className="form-control-wrap">
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                  variant="dialog"
                                  name="dueDate"
                                  id="dueDate"
                                  inputVariant="outlined"
                                  format="MM-dd-yyyy"
                                  fullWidth
                                  value={this.state.dueDate}
                                  onChange={this.handleDateChange}
                                  orientation="landscape"
                                  disabled={
                                    resolvePaymentTermDays(
                                      this.state.payment_terms,
                                      this.state.paymentTermsList
                                    ) !== null
                                  }
                                />
                              </MuiPickersUtilsProvider>
                            </div>
                            <div className="form-note">Due date of the invoice</div>
                          </div>
                        </div>

                        <div className="col-xxl-12">
                          <ul className="nk-stepper-pagination pt-4 gx-4 gy-2 stepper-pagination d-flex justify-content-end order-mobile-action-stack">
                            <li className="step-next">
                              {this.state.info_button === true ? (
                                <button
                                  className="btn btn-primary"
                                  type="button"
                                  disabled
                                >
                                  <span
                                    className="spinner-grow spinner-grow-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                  <span> Saving... </span>
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  onClick={() => this.save_quotation_info()}
                                  className="btn btn-wider btn-primary"
                                >
                                  <span>Save</span>
                                  <em className="icon ni ni-save"></em>
                                </button>
                              )}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/*** Edit Info Modal ***/}
              {/*** Alert Modal ***/}
              <div className="modal fade" tabIndex="-1" id="modalAlertCart">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></em>
                        <h4 className="nk-modal-title">Unable to Process!</h4>
                        <div className="nk-modal-text">
                          <p className="lead">
                            {this.state.service_already_eists_message}
                          </p>
                        </div>
                        <div className="nk-modal-action mt-5">
                          <a
                            href="#"
                            className="btn btn-lg btn-mw btn-light"
                            data-dismiss="modal"
                          >
                            Close
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/*** Confirmation Modal ***/}
              <div
                className="modal fade"
                tabIndex="-1"
                id="modalQuotationConfirmation"
              >
                <div
                  className="modal-dialog modal-dialog-top modal-xl"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">
                        <em className="icon ni ni-file-docs"></em> Order
                        Confirmation
                      </h5>
                    </div>
                    <div className="modal-body">
                      <div className="row g-gs">
                        <div className="col-md-12">
                          <p>
                            Are you sure you want to confirm the order? This
                            action cannot be undone.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="modal-footer"
                      style={{ justifyContent: "flex-end" }}
                    >
                      <button
                        type="button"
                        className="btn btn-light"
                        data-dismiss="modal"
                        disabled={this.state.send_client_button}
                      >
                        Cancel
                      </button>
                      {this.state.send_client_button === true ? (
                        <button
                          className="btn btn-primary"
                          type="button"
                          disabled
                        >
                          <span
                            className="spinner-grow spinner-grow-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span> Creating Order... </span>
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => this.send_to_customer()}
                          disabled={this.state.send_client_button}
                        >
                          Confirm
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/*** Confirmation Modal ***/}

              <div
                className="modal fade"
                tabIndex="-1"
                id="modalAlertCartSuccess"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <a href="#" className="close" data-dismiss="modal">
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-check bg-success"></em>
                        <h4 className="nk-modal-title">Congratulations!</h4>
                        <div className="nk-modal-text">
                          <div className="caption-text">
                            {this.state.service_success_message}
                          </div>
                        </div>
                        <div className="nk-modal-action">
                          <a
                            href="#"
                            className="btn btn-lg btn-mw btn-primary"
                            data-dismiss="modal"
                          >
                            OK
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/*** Alert Modal ***/}
              {/*  DETAILS MODAL*/}
              <div
                className="modal fade zoom"
                tabIndex="-1"
                id="modalFormDetail"
              >
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <div
                        className="modal-title"
                        style={{ textAlign: "center", fontSize: "20px" }}
                      >
                        <strong>
                          <em className="icon ni ni-list-round"></em> Product
                          Details
                        </strong>
                      </div>
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>

                    <div className="modal-body">
                      <br />
                      {/* NRC DIVS START */}

                      {this.state.serviceData ? (
                        <>
                          <div>
                            {this.state.serviceData.map((services, idx) => (
                              <div
                                className="card card-bordered"
                                key={`servi${idx}`}
                              >
                                <div className="card-inner-group">
                                  {services[6] === "did" ||
                                    services[6] === "tfn" ||
                                    services[6] === "teams" ? (
                                    <div className="card-inner">
                                      <div className="sp-plan-head">
                                        <h6 className="title">
                                          {services[1]}
                                          <span className="badge badge-dim badge-primary badge-pill">
                                            {services[6] === "did"
                                              ? "DID Origination"
                                              : ""}
                                            {services[6] === "tfn"
                                              ? "Toll Free Origination"
                                              : ""}
                                            {services[6] === "term"
                                              ? "Voice Termination"
                                              : ""}
                                            {services[6] === "teams"
                                              ? "Microsoft Teams UCAAS"
                                              : ""}
                                            {services[6] === "ivr"
                                              ? "Voyce Admins"
                                              : ""}
                                            {services[6] === "tfn_term"
                                              ? "Toll Free Termination"
                                              : ""}
                                            {services[6] === "az_term"
                                              ? "International A-Z Termination"
                                              : ""}
                                            {services[6] === "live_agent"
                                              ? "Live Agent"
                                              : ""}
                                            {services[6] === "live_agent"
                                              ? "CNAM"
                                              : ""}
                                            {services[6] === "sms"
                                              ? "SMS Inbound / Outbound"
                                              : ""}
                                            {services[6] === "generic"
                                              ? "Other Services"
                                              : ""}
                                          </span>
                                        </h6>
                                      </div>

                                      <div className="sp-plan-desc sp-plan-desc-mb">
                                        <ul className="row gx-1">
                                          <li className="col-sm-4">
                                            <p>
                                              <span className="text-soft">
                                                NRC
                                                <Tooltip
                                                  title="Non-Recurring Charge – A one-time fee that is deducted on service setup."
                                                  placement="top"
                                                >
                                                  <em
                                                    className="icon ni ni-info"
                                                    style={{
                                                      color: "#6576ff",
                                                    }}
                                                  ></em>
                                                </Tooltip>{" "}
                                                / Spiff
                                                <Tooltip
                                                  title="Sales Performance Incentive Fund is an Incentive amount earned against a sale / subscription."
                                                  placement="top"
                                                >
                                                  <em
                                                    className="icon ni ni-info"
                                                    style={{
                                                      color: "#6576ff",
                                                    }}
                                                  ></em>
                                                </Tooltip>
                                              </span>{" "}
                                              ${services[4]} / ${services[13]}
                                            </p>
                                          </li>
                                          <li className="col-sm-4">
                                            <p>
                                              <span className="text-soft">
                                                MRC{" "}
                                                <Tooltip
                                                  title="Monthly Recurring Charge - what you pay each month for the service."
                                                  placement="top"
                                                >
                                                  <em
                                                    className="icon ni ni-info"
                                                    style={{
                                                      color: "#6576ff",
                                                    }}
                                                  ></em>
                                                </Tooltip>{" "}
                                                / Commission{" "}
                                                <Tooltip
                                                  title="Commission amount for agent, taken out of profit."
                                                  placement="top"
                                                >
                                                  <em
                                                    className="icon ni ni-info"
                                                    style={{
                                                      color: "#6576ff",
                                                    }}
                                                  ></em>
                                                </Tooltip>
                                              </span>{" "}
                                              ${services[5]} / $
                                              {(services[5] - services[15]) *
                                                (services[12] / 100)}{" "}
                                              ({services[12]}%)
                                            </p>
                                          </li>
                                          {services[23] !== "ratedeck" &&
                                            services[28] !== "unmetered" ? (
                                            <li className="col-sm-4">
                                              <p>
                                                <span className="text-soft">
                                                  Rate Per Minute{" "}
                                                  <Tooltip
                                                    title="Rate assigned per minute."
                                                    placement="top"
                                                  >
                                                    <em
                                                      className="icon ni ni-info"
                                                      style={{
                                                        color: "#6576ff",
                                                      }}
                                                    ></em>
                                                  </Tooltip>{" "}
                                                  / Commission{" "}
                                                  <Tooltip
                                                    title="Commission amount for agent, taken out of profit."
                                                    placement="top"
                                                  >
                                                    <em
                                                      className="icon ni ni-info"
                                                      style={{
                                                        color: "#6576ff",
                                                      }}
                                                    ></em>
                                                  </Tooltip>
                                                </span>{" "}
                                                ${services[7]} / $
                                                {(services[7] - services[16]) *
                                                  (services[14] / 100)}{" "}
                                                ({services[14]}%)
                                              </p>
                                            </li>
                                          ) : null}
                                          {services[28] === "unmetered" ? (
                                            <li className="col-sm-4">
                                              <p>
                                                <span className="text-soft">
                                                  Rate Per Session{" "}
                                                  <Tooltip
                                                    title="Rate assigned per session."
                                                    placement="top"
                                                  >
                                                    <em
                                                      className="icon ni ni-info"
                                                      style={{
                                                        color: "#6576ff",
                                                      }}
                                                    ></em>
                                                  </Tooltip>{" "}
                                                  / Commission{" "}
                                                  <Tooltip
                                                    title="Commission amount for agent, taken out of profit."
                                                    placement="top"
                                                  >
                                                    <em
                                                      className="icon ni ni-info"
                                                      style={{
                                                        color: "#6576ff",
                                                      }}
                                                    ></em>
                                                  </Tooltip>
                                                </span>{" "}
                                                ${services[7]} / $
                                                {(services[7] - services[32]) *
                                                  (services[14] / 100)}{" "}
                                                ({services[14]}%)
                                              </p>
                                            </li>
                                          ) : null}
                                        </ul>
                                      </div>
                                    </div>
                                  ) : null}
                                  {services[6] === "term" ||
                                    services[6] === "ivr" ||
                                    services[6] === "live_agent" ||
                                    services[6] === "tfn_term" ||
                                    services[6] === "az_term" ||
                                    services[6] === "generic" ? (
                                    <div className="card-inner">
                                      <div className="sp-plan-head">
                                        <h6 className="title">
                                          {services[1]}{" "}
                                          <span className="badge badge-dim badge-primary badge-pill">
                                            {services[45] && services[45] !== ""
                                              ? services[45]
                                              : "---"}
                                          </span>
                                        </h6>
                                      </div>

                                      <div className="sp-plan-desc sp-plan-desc-mb">
                                        <ul className="row gx-1">
                                          {services[23] === "ratedeck" ? (
                                            <>
                                              {/*<li className="col-sm-4">
                                                    <p>
                                                      <span className="text-soft">
                                                        Agent Commission
                                                      </span>{" "}
                                                      {services[14]}%
                                                    </p>
                                                  </li>
                                                  <li className="col-sm-4">
                                                    <p>
                                                      <span className="text-soft">
                                                        Effective Date
                                                      </span>{" "}
                                                      {services[24]}
                                                    </p>
                                                  </li>
                                                  <li className="col-sm-4">
                                                    <p>
                                                      <span className="text-soft">
                                                        Download Rate Deck
                                                      </span>{" "}
                                                      <a
                                                        onClick={() =>
                                                          this.downloadCsv(
                                                            services[25]
                                                          )
                                                        }
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        className="btn btn-outline-primary"
                                                      >
                                                        <em className="icon ni ni-download"></em>{" "}
                                                        Download Rate Deck
                                                      </a>
                                                    </p>
                                                  </li>*/}
                                            </>
                                          ) : (
                                            <>
                                              {services[28] !== "unmetered" ? (
                                                <li className="col-sm-4">
                                                  <p>
                                                    <span className="text-soft">
                                                      {services[6] === "generic"
                                                        ? "Price"
                                                        : "Rate Per Minute"}{" "}
                                                      <Tooltip
                                                        title="Rate assigned per minute."
                                                        placement="top"
                                                      >
                                                        <em
                                                          className="icon ni ni-info"
                                                          style={{
                                                            color: "#6576ff",
                                                          }}
                                                        ></em>
                                                      </Tooltip>{" "}
                                                      / Commission{" "}
                                                      <Tooltip
                                                        title="Commission amount for agent, taken out of profit."
                                                        placement="top"
                                                      >
                                                        <em
                                                          className="icon ni ni-info"
                                                          style={{
                                                            color: "#6576ff",
                                                          }}
                                                        ></em>
                                                      </Tooltip>
                                                    </span>{" "}
                                                    $
                                                    {this.formatRate(
                                                      services[7]
                                                    )}{" "}
                                                    / $
                                                    {this.formatRate(
                                                      (services[7] -
                                                        services[16]) *
                                                      (services[14] / 100)
                                                    )}{" "}
                                                    ({services[14]}%)
                                                  </p>
                                                </li>
                                              ) : null}
                                            </>
                                          )}
                                          {services[28] === "unmetered" ? (
                                            <li className="col-sm-4">
                                              <p>
                                                <span className="text-soft">
                                                  {services[6] === "generic"
                                                    ? "Price"
                                                    : "Rate Per Session"}{" "}
                                                  <Tooltip
                                                    title="Rate assigned per session."
                                                    placement="top"
                                                  >
                                                    <em
                                                      className="icon ni ni-info"
                                                      style={{
                                                        color: "#6576ff",
                                                      }}
                                                    ></em>
                                                  </Tooltip>{" "}
                                                  / Commission{" "}
                                                  <Tooltip
                                                    title="Commission amount for agent, taken out of profit."
                                                    placement="top"
                                                  >
                                                    <em
                                                      className="icon ni ni-info"
                                                      style={{
                                                        color: "#6576ff",
                                                      }}
                                                    ></em>
                                                  </Tooltip>
                                                </span>{" "}
                                                ${services[7]} / $
                                                {(services[7] - services[32]) *
                                                  (services[14] / 100)}{" "}
                                                ({services[14]}%)
                                              </p>
                                            </li>
                                          ) : null}
                                        </ul>
                                      </div>
                                      {services[6] === "generic" ? (
                                        <>
                                          <div
                                            className="sp-plan-head"
                                            style={{
                                              marginTop: "15px",
                                              borderTop: "1px solid #f6f6f6",
                                              paddingTop: "15px",
                                            }}
                                          >
                                            <h6 className="title">
                                              Other Product Rates
                                            </h6>
                                          </div>
                                          <div className="sp-plan-desc sp-plan-desc-mb">
                                            <table className="table">
                                              <thead className="thead-light">
                                                <tr>
                                                  <th scope="col">Title</th>
                                                  <th scope="col">
                                                    Charge Type
                                                  </th>
                                                  <th scope="col">Cycle</th>
                                                  <th scope="col">Price</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {services[44].map(
                                                  (miscrate, idx) => (
                                                    <tr key={`mis${idx}`}>
                                                      <td>
                                                        {miscrate.generic_title}
                                                      </td>
                                                      <td>
                                                        {miscrate.pay_type ===
                                                          "recurring"
                                                          ? "Recurring"
                                                          : ""}

                                                        {miscrate.pay_type ===
                                                          "one_time"
                                                          ? "One Time"
                                                          : ""}
                                                      </td>
                                                      <td>
                                                        {miscrate.pay_type ===
                                                          "recurring" ? (
                                                          <>
                                                            {miscrate.generic_type ===
                                                              "per_minute"
                                                              ? "Per Minute"
                                                              : ""}
                                                            {miscrate.generic_type ===
                                                              "per_hour"
                                                              ? "Per Hour"
                                                              : ""}
                                                            {miscrate.generic_type ===
                                                              "per_second"
                                                              ? "Per Second"
                                                              : ""}
                                                            {miscrate.generic_type ===
                                                              "per_day"
                                                              ? "Per Day"
                                                              : ""}
                                                            {miscrate.generic_type ===
                                                              "per_month"
                                                              ? "Per Month"
                                                              : ""}
                                                            {miscrate.generic_type ===
                                                              "per_year"
                                                              ? "Per Year"
                                                              : ""}
                                                          </>
                                                        ) : null}
                                                      </td>
                                                      <td>
                                                        {miscrate.generic_rate !==
                                                          "" &&
                                                          miscrate.generic_rate >
                                                          0 ? (
                                                          <>
                                                            $
                                                            {this.formatRate(
                                                              miscrate.generic_rate
                                                            )}
                                                          </>
                                                        ) : (
                                                          <>
                                                            $
                                                            {this.formatRate(0)}
                                                          </>
                                                        )}
                                                      </td>
                                                    </tr>
                                                  )
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </>
                                      ) : null}
                                    </div>
                                  ) : null}
                                  {services[6] === "sms" ? (
                                    <div className="card-inner">
                                      <div className="sp-plan-head">
                                        <h6 className="title">
                                          {services[1]}{" "}
                                          <span className="badge badge-dim badge-primary badge-pill">
                                            New
                                          </span>
                                        </h6>
                                      </div>

                                      <div className="sp-plan-desc sp-plan-desc-mb">
                                        <ul className="row gx-1">
                                          <li className="col-sm-5">
                                            <p>
                                              <span className="text-soft">
                                                SMS In{" "}
                                                <Tooltip
                                                  title="Price applied to SMS In Services."
                                                  placement="top"
                                                >
                                                  <em
                                                    className="icon ni ni-info"
                                                    style={{
                                                      color: "#6576ff",
                                                    }}
                                                  ></em>
                                                </Tooltip>{" "}
                                                / Commission{" "}
                                                <Tooltip
                                                  title="Commission amount for agent, taken out of profit."
                                                  placement="top"
                                                >
                                                  <em
                                                    className="icon ni ni-info"
                                                    style={{
                                                      color: "#6576ff",
                                                    }}
                                                  ></em>
                                                </Tooltip>
                                              </span>{" "}
                                              ${services[10]} / $
                                              {(
                                                (services[10] - services[15]) *
                                                (services[17] / 100)
                                              ).toFixed(2)}{" "}
                                              ({services[17]}%)
                                            </p>
                                          </li>
                                          <li className="col-sm-5">
                                            <p>
                                              <span className="text-soft">
                                                SMS Out{" "}
                                                <Tooltip
                                                  title="Price applied to SMS Out Services."
                                                  placement="top"
                                                >
                                                  <em
                                                    className="icon ni ni-info"
                                                    style={{
                                                      color: "#6576ff",
                                                    }}
                                                  ></em>
                                                </Tooltip>{" "}
                                                / Commission{" "}
                                                <Tooltip
                                                  title="Commission amount for agent, taken out of profit"
                                                  placement="top"
                                                >
                                                  <em
                                                    className="icon ni ni-info"
                                                    style={{
                                                      color: "#6576ff",
                                                    }}
                                                  ></em>
                                                </Tooltip>
                                              </span>{" "}
                                              ${services[11]} / $
                                              {(
                                                (services[11] - services[16]) *
                                                (services[18] / 100)
                                              ).toFixed(2)}{" "}
                                              ({services[18]}%)
                                            </p>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  ) : null}
                                  {services[6] === "cnam" ? (
                                    <div className="card-inner">
                                      <div className="sp-plan-head">
                                        <h6 className="title">
                                          {services[1]}{" "}
                                          <span className="badge badge-dim badge-primary badge-pill">
                                            New
                                          </span>
                                        </h6>
                                      </div>

                                      <div className="sp-plan-desc sp-plan-desc-mb">
                                        <ul className="row gx-1">
                                          <li className="col-sm-4">
                                            <p>
                                              <span className="text-soft">
                                                Update CNAM (MRC){" "}
                                                <Tooltip
                                                  title="Price applied to Update CNAM (MRC)."
                                                  placement="top"
                                                >
                                                  <em
                                                    className="icon ni ni-info"
                                                    style={{
                                                      color: "#6576ff",
                                                    }}
                                                  ></em>
                                                </Tooltip>{" "}
                                                / Commission{" "}
                                                <Tooltip
                                                  title="Commission amount for agent, taken out of profit."
                                                  placement="top"
                                                >
                                                  <em
                                                    className="icon ni ni-info"
                                                    style={{
                                                      color: "#6576ff",
                                                    }}
                                                  ></em>
                                                </Tooltip>
                                              </span>{" "}
                                              $
                                              {services[33]
                                                ? services[33].toFixed(4)
                                                : "0.00"}{" "}
                                              / $
                                              {(
                                                (services[33] - services[36]) *
                                                (services[39] / 100)
                                              ).toFixed(2)}{" "}
                                              ({services[39]}%)
                                            </p>
                                          </li>
                                          <li className="col-sm-4">
                                            <p>
                                              <span className="text-soft">
                                                CNAM DIP{" "}
                                                <Tooltip
                                                  title="Price applied to CNAM DIP."
                                                  placement="top"
                                                >
                                                  <em
                                                    className="icon ni ni-info"
                                                    style={{
                                                      color: "#6576ff",
                                                    }}
                                                  ></em>
                                                </Tooltip>{" "}
                                                / Commission{" "}
                                                <Tooltip
                                                  title="Commission amount for agent, taken out of profit"
                                                  placement="top"
                                                >
                                                  <em
                                                    className="icon ni ni-info"
                                                    style={{
                                                      color: "#6576ff",
                                                    }}
                                                  ></em>
                                                </Tooltip>
                                              </span>{" "}
                                              $
                                              {services[34]
                                                ? services[34].toFixed(4)
                                                : "0.00"}{" "}
                                              / $
                                              {(
                                                (services[34] - services[37]) *
                                                (services[41] / 100)
                                              ).toFixed(2)}{" "}
                                              ({services[41]}%)
                                            </p>
                                          </li>
                                          <li className="col-sm-4">
                                            <p>
                                              <span className="text-soft">
                                                Storage DIP{" "}
                                                <Tooltip
                                                  title="Price applied to Storage DIP."
                                                  placement="top"
                                                >
                                                  <em
                                                    className="icon ni ni-info"
                                                    style={{
                                                      color: "#6576ff",
                                                    }}
                                                  ></em>
                                                </Tooltip>{" "}
                                                / Commission{" "}
                                                <Tooltip
                                                  title="Commission amount for agent, taken out of profit"
                                                  placement="top"
                                                >
                                                  <em
                                                    className="icon ni ni-info"
                                                    style={{
                                                      color: "#6576ff",
                                                    }}
                                                  ></em>
                                                </Tooltip>
                                              </span>{" "}
                                              $
                                              {services[35]
                                                ? services[35].toFixed(4)
                                                : "0.00"}{" "}
                                              / $
                                              {(
                                                (services[35] - services[38]) *
                                                (services[40] / 100)
                                              ).toFixed(2)}{" "}
                                              ({services[40]}%)
                                            </p>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  ) : null}
                                  {services[6] === "did" ||
                                    services[6] === "tfn" ||
                                    services[6] === "teams" ? (
                                    <>
                                      {services[30] &&
                                        services[30].length > 0 ? (
                                        <div className="card-inner">
                                          <div className="sp-plan-head">
                                            <h6 className="title">
                                              Porting Rates
                                            </h6>
                                          </div>

                                          <div className="sp-plan-desc sp-plan-desc-mb">
                                            <ul className="row gx-1">
                                              <li className="col-sm-5">
                                                <p>
                                                  <span className="text-soft">
                                                    Portin Sell Rate / Spiff
                                                  </span>{" "}
                                                  $
                                                  {services[30][0].portin_sell_rate.toFixed(
                                                    4
                                                  )}{" "}
                                                  / $
                                                  {services[30][0].portin_agent_spiff.toFixed(
                                                    2
                                                  )}
                                                </p>
                                              </li>
                                              <li className="col-sm-5">
                                                <p>
                                                  <span className="text-soft">
                                                    Portin Sell Rate / Spiff
                                                  </span>{" "}
                                                  $
                                                  {services[30][0].portout_sell_rate.toFixed(
                                                    4
                                                  )}{" "}
                                                  / $
                                                  {services[30][0].portout_agent_spiff.toFixed(
                                                    2
                                                  )}
                                                </p>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      ) : null}
                                    </>
                                  ) : null}
                                  <div className="card-inner">
                                    {services[23] !== "ratedeck" ? (
                                      <>
                                        {services[50] && services[50] !== "" ? (
                                          <>
                                            <div className="sp-plan-head">
                                              <h6 className="title">Summary</h6>
                                            </div>
                                            <div className="sp-plan-desc sp-plan-desc-mb">
                                              <ul className="row gx-1">
                                                <li className="col-sm-12">
                                                  {services[50]}
                                                </li>
                                              </ul>
                                            </div>
                                          </>
                                        ) : null}
                                        <div
                                          className="sp-plan-head"
                                          style={{
                                            marginTop: "15px",
                                            borderTop: "1px solid #f6f6f6",
                                            paddingTop: "15px",
                                          }}
                                        >
                                          <h6 className="title">
                                            Cancellation Fee
                                          </h6>
                                        </div>
                                        <div className="sp-plan-desc sp-plan-desc-mb">
                                          <ul className="row gx-1">
                                            <li className="col-sm-5">
                                              <p>
                                                <span className="text-soft">
                                                  Cancellation Fee
                                                </span>{" "}
                                                {services[29] &&
                                                  services[29] !== "" ? (
                                                  <>
                                                    $
                                                    {this.formatRate(
                                                      services[29]
                                                    )}
                                                  </>
                                                ) : (
                                                  <>${this.formatRate(0)}</>
                                                )}
                                              </p>
                                            </li>
                                          </ul>
                                        </div>
                                      </>
                                    ) : null}
                                    {services[23] === "ratedeck" ? (
                                      <>
                                        <div className="sp-plan-head">
                                          <h6 className="title">
                                            Rate Deck / Effective Date
                                          </h6>
                                        </div>
                                        <div className="sp-plan-desc sp-plan-desc-mb">
                                          <ul className="row gx-1">
                                            <li className="col-sm-5">
                                              <p>
                                                <span className="text-soft">
                                                  Rate Deck
                                                </span>{" "}
                                                {services[25] &&
                                                  services[25] !== "" ? (
                                                  <>
                                                    <a
                                                      onClick={() =>
                                                        this.downloadCsv(
                                                          services[25]
                                                        )
                                                      }
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      className="btn btn-outline-primary"
                                                    >
                                                      <em className="icon ni ni-download"></em>{" "}
                                                      Download Rate Deck
                                                    </a>
                                                  </>
                                                ) : null}
                                              </p>
                                            </li>
                                            <li className="col-sm-5">
                                              <p>
                                                <span className="text-soft">
                                                  Effective Date
                                                </span>{" "}
                                                {services[24] &&
                                                  services[24] !== "" ? (
                                                  <>
                                                    {this.format_date(
                                                      services[24]
                                                    )}
                                                  </>
                                                ) : null}
                                              </p>
                                            </li>
                                          </ul>
                                        </div>
                                      </>
                                    ) : null}
                                    {services[31] && services[31].length > 0 ? (
                                      <>
                                        <div
                                          className="sp-plan-head"
                                          style={{
                                            marginTop: "15px",
                                            borderTop: "1px solid #f6f6f6",
                                            paddingTop: "15px",
                                          }}
                                        >
                                          <h6 className="title">
                                            Miscellaneous Rates
                                          </h6>
                                        </div>
                                        <div className="sp-plan-desc sp-plan-desc-mb">
                                          <table className="table">
                                            <thead className="thead-light">
                                              <tr>
                                                <th scope="col">Title</th>
                                                <th scope="col">Rate Type</th>
                                                <th scope="col">Rate</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {services[31].map(
                                                (miscrate, idx) => (
                                                  <tr key={`mis${idx}`}>
                                                    <td>
                                                      {miscrate.misc_title}
                                                    </td>
                                                    <td>
                                                      {miscrate.misc_type ===
                                                        "per_minute"
                                                        ? "Per Minute"
                                                        : ""}
                                                      {miscrate.misc_type ===
                                                        "per_hour"
                                                        ? "Per Hour"
                                                        : ""}
                                                      {miscrate.misc_type ===
                                                        "one_time"
                                                        ? "One Time"
                                                        : ""}
                                                    </td>
                                                    <td>
                                                      {miscrate.misc_rate !==
                                                        "" &&
                                                        miscrate.misc_rate > 0 ? (
                                                        <>
                                                          $
                                                          {this.formatRate(
                                                            miscrate.misc_rate
                                                          )}
                                                        </>
                                                      ) : (
                                                        <>
                                                          ${this.formatRate(0)}
                                                        </>
                                                      )}
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </>
                                    ) : null}
                                  </div>
                                  {/*<div className="card-inner">
                                        <div className="sp-plan-head">
                                          <h6 className="title">
                                            Add / Update Dates
                                          </h6>
                                        </div>
                                        <div className="sp-plan-desc sp-plan-desc-mb">
                                          <ul className="row gx-1">
                                            <li className="col-sm-5">
                                              <p>
                                                <span className="text-soft">
                                                  Date Added
                                                </span>{" "}
                                                {services[19] !== ""
                                                  ? this.format_date(
                                                      services[19]
                                                    )
                                                  : null}
                                              </p>
                                            </li>
                                            <li className="col-sm-5">
                                              <p>
                                                <span className="text-soft">
                                                  Date Updated
                                                </span>{" "}
                                                {services[20] !== ""
                                                  ? this.format_date(
                                                      services[20]
                                                    )
                                                  : null}
                                              </p>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>*/}
                                  {services[42] && services[42] === "link" ? (
                                    <>
                                      {services[43] !== "" ? (
                                        <div className="card-inner">
                                          <div className="sp-plan-head">
                                            <h6 className="title">
                                              Marketing Link
                                            </h6>
                                          </div>
                                          <div className="sp-plan-desc sp-plan-desc-mb">
                                            <ul className="row gx-1">
                                              <li className="col-sm-5">
                                                <p>
                                                  <span className="text-soft">
                                                    Marketing Link
                                                  </span>{" "}
                                                  <a
                                                    href={services[43]}
                                                    target="_blank"
                                                  >
                                                    <em className="icon ni ni-link-h"></em>{" "}
                                                    Click to open link
                                                  </a>
                                                </p>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      ) : null}
                                    </>
                                  ) : null}
                                  {services[42] && services[42] === "pdf" ? (
                                    <>
                                      {services[43] !== "" ? (
                                        <div className="card-inner">
                                          <div className="sp-plan-head">
                                            <h6 className="title">
                                              Marketing Link
                                            </h6>
                                          </div>
                                          <div className="sp-plan-desc sp-plan-desc-mb">
                                            <ul className="row gx-1">
                                              <li className="col-sm-5">
                                                <p>
                                                  <span className="text-soft">
                                                    Marketing Link
                                                  </span>{" "}
                                                  <a
                                                    href={services[43]}
                                                    target="_blank"
                                                  >
                                                    <em className="icon ni ni-file-pdf"></em>{" "}
                                                    View PDF
                                                  </a>
                                                </p>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      ) : null}
                                    </>
                                  ) : null}

                                  {services[47] && services[47] !== "" ? (
                                    <div className="card-inner">
                                      <div className="sp-plan-head-group">
                                        <div className="sp-plan-head">
                                          <h6 className="title">
                                            Document / Rate Deck{" "}
                                          </h6>
                                        </div>
                                      </div>
                                      <div className="sp-plan-desc sp-plan-desc-mb">
                                        <ul className="row gx-1">
                                          <li className="col-sm-5">
                                            <p>
                                              <br />
                                              <a
                                                onClick={() =>
                                                  this.downloadDeck(
                                                    services[47]
                                                  )
                                                }
                                                style={{
                                                  cursor: "pointer",
                                                }}
                                                className="text-primary"
                                              >
                                                <em className="icon ni ni-download"></em>{" "}
                                                {services[46]}
                                              </a>
                                            </p>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  ) : null}

                                  {services[48] && services[48] !== "" ? (
                                    <div className="card-inner">
                                      <div className="sp-plan-head-group">
                                        <div className="sp-plan-head">
                                          <h6 className="title">
                                            3rd Party Integration{" "}
                                          </h6>
                                          <span className="text-body">
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html: services[49],
                                              }}
                                            />
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  <div className="card-inner">
                                    <div className="sp-plan-head-group">
                                      <div className="sp-plan-head">
                                        <h6 className="title">Description</h6>
                                        <span className="text-body">
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: services[3],
                                            }}
                                          />
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              {/* DETAILS MODAL */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
    quotationSettings: state.quotationSettings,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(EditUotations);
